// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/close_bt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/no_bt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/yes_bt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/frame_popup-desktop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/btn-login.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/btn-register.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/goto-lobby.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/BG_dialog.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images//homepage/BG_home.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../casino/images/BG_frame_SAgaming.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images//BG_frame_login.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/BG_register.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* line 8, ../sass/main.scss */
body {
  font-family: "Kanit-Regular", sans-serif;
}

/* line 14, ../sass/main.scss */
.bg-site {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  z-index: -2;
}



/* line 46, ../sass/main.scss */
::-webkit-scrollbar {
  width: 5px;
}

/* line 49, ../sass/main.scss */
::-webkit-scrollbar-thumb {
  background: #03ff1c;
}

/* line 52, ../sass/main.scss */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #03ff1c;
}


/* line 89, ../sass/main.scss */
p {
  margin-bottom: 0;
}

/* line 92, ../sass/main.scss */
.circle-p {
  max-width: 60px;
  max-height: 60px;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center 0px;
  background-size: contain;
}

/* line 102, ../sass/main.scss */
.circle-b {
  max-width: 60px;
  max-height: 60px;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center 0px;
  background-size: contain;
}

/* line 112, ../sass/main.scss */
.circle-t {
  max-width: 60px;
  max-height: 60px;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center 0px;
  background-size: contain;
}

/* line 123, ../sass/main.scss */
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0;
}

/* line 137, ../sass/main.scss */
img {
  max-width: 100%;
}

/* line 140, ../sass/main.scss */
.pd-site {
  padding-top: 100px;
}

@media only screen and (max-width: 1440px) {
  /* line 144, ../sass/main.scss */
  .pd-site {
    padding-top: 80px;
  }
}
@media only screen and (max-width: 1200px) {
  /* line 149, ../sass/main.scss */
  .pd-site {
    padding-top: 70px;
  }
}
@media only screen and (max-width: 767px) {
  /* line 154, ../sass/main.scss */
  .pd-site {
    padding-top: 60px;
  }
}
/* line 1, ../sass/_header.scss */
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #000;
  z-index: 9;
}
/* line 8, ../sass/_header.scss */
header .wrapper {
  max-width: 95%;
  margin: 0 auto;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* line 16, ../sass/_header.scss */
header .logo {
  max-width: 170px;
  margin-right: 20px;
}
/* line 19, ../sass/_header.scss */
header .logo img {
  max-height: 100%;
}
/* line 23, ../sass/_header.scss */
header .menu {
  display: flex;
  position: relative;
  min-width: fit-content;
}
/* line 27, ../sass/_header.scss */
header .menu .menu_wrapper {
  display: flex;
  gap: 10px;
}
/* line 31, ../sass/_header.scss */
header .menu .menu-item {
  position: relative;
  display: flex;
  cursor: pointer;
}
/* line 35, ../sass/_header.scss */
header .menu .menu-item:hover {
  filter: brightness(1.5);
}
/* line 39, ../sass/_header.scss */
header .menu .menu-item p {
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding: 5px 30px;
}
/* line 45, ../sass/_header.scss */
header .menu .menu-item p::before {
  content: "";
  width: 40px;
  height: 40px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 15px;
}
/* line 55, ../sass/_header.scss */
header .menu .menu-item::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: -1;
  transform: scaleY(0.6);
  background: linear-gradient(90deg, #3c6a35 0%, #5ea753 50%, #3c6a35 100%);
  border-bottom-right-radius: 50px 100px;
  border-top-left-radius: 50px 100px;
}
/* line 72, ../sass/_header.scss */
header .btn-back {
  text-decoration: none;
  margin-right: 10px;
}
/* line 76, ../sass/_header.scss */

/* line 110, ../sass/_header.scss */
header .btn-home {
  display: none !important;
}
/* line 113, ../sass/_header.scss */
header .btn-home p::before {
}

/* line 121, ../sass/_header.scss */
.menu-icon {
  display: none;
  cursor: pointer;
}

/* line 127, ../sass/_header.scss */
.bar1,
.bar2,
.bar3 {
  width: 35px;
  height: 5px;
  background-color: #1cdf2e;
  margin: 6px 0;
  transition: 0.4s;
}

/* line 137, ../sass/_header.scss */
.change .bar1 {
  transform: rotate(-45deg) translate(-9px, 6px);
}

/* line 142, ../sass/_header.scss */
.change .bar2 {
  opacity: 0;
}

/* line 146, ../sass/_header.scss */
.change .bar3 {
  transform: rotate(45deg) translate(-8px, -8px);
}

@media only screen and (max-width: 1200px) {
  /* line 152, ../sass/_header.scss */
  header .menu .menu_wrapper {
    display: none;
  }

  /* line 155, ../sass/_header.scss */
  .menu-icon {
    display: block;
    margin-left: 30px;
  }

  /* line 162, ../sass/_header.scss */
  header .menu .menu_wrapper_active {
    display: grid;
    position: fixed;
    align-items: center;
    justify-content: center;
    grid-template-rows: 55px 55px 55px 55px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    overflow: auto;
    padding-top: 15vh;
  }
  /* line 175, ../sass/_header.scss */
  header .menu .menu_wrapper_active .menu-item {
    margin-left: 0 !important;
    padding: 0px;
  }

  /* line 181, ../sass/_header.scss */
  header .btn-home,
  header .btn-contact {
    display: flex !important;
  }
}
@media only screen and (max-width: 767px) {
  /* line 187, ../sass/_header.scss */
  .btn-back {
    display: none !important;
  }

  /* line 190, ../sass/_header.scss */
  header .wrapper {
    padding: 10px 15px;
  }

  /* line 193, ../sass/_header.scss */
  header .logo {
    max-width: 140px;
  }
}
/* line 1, ../sass/_model.scss */
.model-group {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  overflow: auto;
  transition: 0.5s;
  visibility: hidden;
  opacity: 0;
  z-index: 10;
}
/* line 15, ../sass/_model.scss */
.model-group .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: -1;
}
/* line 26, ../sass/_model.scss */
.model-group .title h1 {
  color: #fff;
}
/* line 29, ../sass/_model.scss */
.model-group .title h3 {
  font-family: "Kanit-Light";
  color: #fff;
}
/* line 32, ../sass/_model.scss */
.model-group .title h3 span {
  margin-left: 20px;
  color: #fff;
}
/* line 38, ../sass/_model.scss */
.model-group .wrapper {
  padding: 20px;
  border: 1px solid #1cdf2e;
  background-color: rgba(0, 0, 0, 0.8);
}
/* line 43, ../sass/_model.scss */
.model-group .group-btn {
  text-align: center;
  position: absolute;
  left: 0;
  width: 100%;
}
/* line 49, ../sass/_model.scss */
.model-group .btn-closeModel {
  position: absolute;
  top: 0;
  right: 0;
  width: 35px;
  height: 35px;
  margin-left: auto;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
/* line 62, ../sass/_model.scss */
.model-group .btn-cancel {
  background-color: unset;
  border: unset;
  outline: unset;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: 0.3s;
}
/* line 69, ../sass/_model.scss */
.model-group .btn-cancel:hover {
  filter: brightness(2);
}
/* line 72, ../sass/_model.scss */
.model-group .btn-cancel:active {
  filter: brightness(2);
}
/* line 76, ../sass/_model.scss */
.model-group .btn-confirm {
  background-color: unset;
  border: unset;
  outline: unset;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: 0.3s;
}
/* line 83, ../sass/_model.scss */
.model-group .btn-confirm:hover {
  filter: brightness(1.3);
}
/* line 86, ../sass/_model.scss */
.model-group .btn-confirm:active {
  filter: brightness(1.3);
}
/* line 90, ../sass/_model.scss */
.model-group .btn-cancel,
.model-group .btn-confirm {
  width: 200px;
  height: 45px;
}
/* line 95, ../sass/_model.scss */
.model-group .model-item {
  width: calc(100vw - 35px);
  max-width: 800px;
  position: relative;
  padding: 40px 0;
}
/* line 102, ../sass/_model.scss */
.model-group .model-user {
  display: none;
}
/* line 104, ../sass/_model.scss */
.model-group .model-user .title {
  text-align: center;
}
/* line 107, ../sass/_model.scss */
.model-group .model-user .user-info {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  grid-gap: 15px 20px;
}
/* line 112, ../sass/_model.scss */
.model-group .model-user .info-item {
  display: grid;
  grid-template-columns: 125px 1fr;
  align-items: center;
}
/* line 116, ../sass/_model.scss */
.model-group .model-user .info-item:nth-child(even) {
  grid-template-columns: 80px 1fr;
}
/* line 119, ../sass/_model.scss */
.model-group .model-user .info-item p {
  font-family: "Kanit-Light";
  font-size: 20px;
}
/* line 122, ../sass/_model.scss */
.model-group .model-user .info-item p:nth-child(1) {
  color: #f3f3f3;
}
/* line 125, ../sass/_model.scss */
.model-group .model-user .info-item p:nth-child(2) {
  padding: 3px 20px;
  color: #1cdf2e;
  border: 1px solid #1cdf2e;
}
/* line 132, ../sass/_model.scss */
.model-group .model-user .wrapper_form {
  border: 1px solid #1cdf2e;
}
/* line 133, ../sass/_model.scss */
.model-group .model-user .wrapper_form .title-form {
  background-color: #1cdf2e;
  padding: 8px 20px;
}
/* line 136, ../sass/_model.scss */
.model-group .model-user .wrapper_form .title-form p {
  color: #fff;
  font-size: 24px;
}
/* line 143, ../sass/_model.scss */
.model-group .model-user .group-input {
  padding: 20px 23px;
}
/* line 146, ../sass/_model.scss */
.model-group .model-user .input-item {
  display: grid;
  grid-template-columns: 125px 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;
  align-items: center;
}
/* line 152, ../sass/_model.scss */
.model-group .model-user .input-item:last-child {
  margin-bottom: 0;
}
/* line 155, ../sass/_model.scss */
.model-group .model-user .input-item label {
  color: #f3f3f3;
  font-family: "Kanit-Light";
  font-size: 20px;
  margin-bottom: 0;
}
/* line 161, ../sass/_model.scss */
.model-group .model-user .input-item input {
  font-size: 20px;
  padding: 3px 20px;
  font-family: "Kanit-Light";
  width: 100%;
}
/* line 166, ../sass/_model.scss */
.model-group .model-user .input-item input::placeholder {
  color: #a3a3a3;
}
/* line 173, ../sass/_model.scss */
.model-group .model-redeem {
  display: none;
  text-align: center;
  max-width: 550px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
  padding-top: 60px;
}
/* line 180, ../sass/_model.scss */
.model-group .model-redeem .wrapper {
  border: unset;
  background-color: unset;
}
/* line 185, ../sass/_model.scss */
.model-group .model-redeem .title h1 {
  position: absolute;
  top: 10px;
  left: 50%;
  color: #05f31c;
  font-size: 24px;
  transform: translateX(-50%);
}
/* line 194, ../sass/_model.scss */
.model-group .model-redeem .btn-pastCredit {
  display: block;
  margin: 0 auto;
}
/* line 199, ../sass/_model.scss */
.model-group .model-redeem form p {
  font-family: "Kanit-Light";
  color: #a3a3a3;
}
/* line 203, ../sass/_model.scss */
.model-group .model-redeem form input {
  background-color: unset;
  border: unset;
  outline: unset;
  font-family: "Kanit-Light";
  color: #f3f3f3;
  text-align: center;
  width: 85%;
  font-size: 22px;
  padding: 5px 25px;
}
/* line 213, ../sass/_model.scss */
.model-group .model-redeem .btn-pastCredit {
  background-color: unset;
  border: unset;
  outline: unset;
  background-color: #1cdf2e;
  padding: 5px 15px;
  font-size: 20px;
  border-radius: 5px;
  color: #fff;
}
/* line 220, ../sass/_model.scss */
.model-group .model-redeem .btn-pastCredit:active {
  filter: brightness(1.3);
}
/* line 224, ../sass/_model.scss */
.model-group .model-redeem .group-btn {
  position: relative;
}
/* line 229, ../sass/_model.scss */
.model-group .model-logout {
  display: none;
  max-width: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
}
/* line 236, ../sass/_model.scss */
.model-group .model-logout .title h1 {
  font-size: 32px;
}
/* line 239, ../sass/_model.scss */
.model-group .model-logout .title h3 {
  font-size: 26px;
}
/* line 243, ../sass/_model.scss */
.model-group .model-logout .wrapper {
  border: unset;
  background-color: unset;
}
/* line 247, ../sass/_model.scss */
.model-group .model-logout .group-btn {
  position: relative;
}

/* line 252, ../sass/_model.scss */
.bg-input {
  background-color: #2b2b2b !important;
  border: 1px solid #474747 !important;
  border-radius: 5px;
}

/* line 259, ../sass/_model.scss */
.model-group.active {
  visibility: visible;
  opacity: 1;
}

/* line 263, ../sass/_model.scss */
.model-user_active {
  display: block !important;
}

/* line 266, ../sass/_model.scss */
.model-redeem_active {
  display: block !important;
}

/* line 269, ../sass/_model.scss */
.model-logout_active {
  display: block !important;
}

@media only screen and (max-width: 900px) {
  /* line 276, ../sass/_model.scss */
  .model-group .model-user .user-info {
    grid-template-columns: 1fr;
  }

  /* line 279, ../sass/_model.scss */
  .model-group .model-user .info-item:nth-child(even) {
    grid-template-columns: 125px 1fr;
  }
}
@media only screen and (max-width: 767px) {
  /* line 284, ../sass/_model.scss */
  .model-group .title h1 {
    font-size: 30px;
  }

  /* line 287, ../sass/_model.scss */
  .model-group .model-user .user-info {
    grid-gap: 10px 20px;
  }

  /* line 290, ../sass/_model.scss */
  .model-group .model-user .input-item label {
    font-size: 18px;
  }

  /* line 293, ../sass/_model.scss */
  .model-group .model-user .input-item input {
    font-size: 18px;
    padding: 2px 15px;
  }
  /* line 296, ../sass/_model.scss */
  .model-group .model-user .input-item input::placeholder {
    font-size: 14px;
  }

  /* line 300, ../sass/_model.scss */
  .model-group .model-user .input-item {
    grid-template-columns: 110px 1fr;
  }

  /* line 304, ../sass/_model.scss */
  .model-group .title h3 {
    font-size: 24px;
  }

  /* line 308, ../sass/_model.scss */
  .model-redeem .title {
    margin-bottom: 10px !important;
  }
  /* line 310, ../sass/_model.scss */
  .model-redeem .title h1 {
    margin-bottom: 10px !important;
  }
  /* line 313, ../sass/_model.scss */
  .model-redeem .title h3 {
    font-size: 24px;
  }

  /* line 318, ../sass/_model.scss */
  .model-group .model-redeem form input {
    font-size: 26px;
    padding: 3px 20px;
  }

  /* line 322, ../sass/_model.scss */
  .model-group .model-redeem .btn-pastCredit {
    font-size: 16px;
  }
}
@media only screen and (max-width: 550px) {
  /* line 329, ../sass/_model.scss */
  .model-group .group-btn {
    left: 0;
    width: 100%;
  }

  /* line 334, ../sass/_model.scss */
  .model-group .title h1 {
    font-size: 26px;
  }

  /* line 337, ../sass/_model.scss */
  .model-group .model-user .info-item p {
    font-size: 14px;
  }

  /* line 340, ../sass/_model.scss */
  .model-group .model-user .info-item:nth-child(even),
  .model-group .model-user .info-item {
    grid-template-columns: 85px 1fr;
  }

  /* line 344, ../sass/_model.scss */
  .model-group .model-user .user-info {
    grid-gap: 5px 20px;
  }

  /* line 347, ../sass/_model.scss */
  .model-group .model-user .wrapper_form .title-form p {
    font-size: 18px;
  }

  /* line 350, ../sass/_model.scss */
  .model-group .model-user .input-item label {
    font-size: 14px;
  }

  /* line 353, ../sass/_model.scss */
  .model-group .model-user .input-item input {
    font-size: 18px;
  }

  /* line 356, ../sass/_model.scss */
  .model-group .model-user .input-item {
    grid-template-columns: 1fr;
    grid-gap: 0px;
    margin-bottom: 5px;
  }

  /* line 361, ../sass/_model.scss */
  .model-group .model-user .group-input {
    padding: 10px 15px;
  }

  /* line 364, ../sass/_model.scss */
  .model-group .btn-cancel,
  .model-group .btn-confirm {
    width: 155px;
    height: 35px;
  }

  /* line 370, ../sass/_model.scss */
  .model-group .model-user .title {
    margin-bottom: 15px !important;
  }

  /* line 373, ../sass/_model.scss */
  .model-group .group-btn {
    text-align: center;
    margin-top: 25px !important;
  }

  /* line 377, ../sass/_model.scss */
  .model-group .model-item {
    width: calc(100vw - 15px);
  }

  /* line 380, ../sass/_model.scss */
  .model-group .model-user .wrapper_form .title-form {
    padding: 5px 14px;
  }

  /* line 384, ../sass/_model.scss */
  .model-group .model-redeem {
    max-width: 360px;
  }

  /* line 387, ../sass/_model.scss */
  .model-redeem .title h3 {
    font-size: 16px;
  }

  /* line 390, ../sass/_model.scss */
  .model-group .model-redeem form input {
    width: 100%;
    max-width: 270px;
    font-size: 20px;
  }

  /* line 395, ../sass/_model.scss */
  .model-group .wrapper {
    padding: 25px 15px;
  }

  /* line 398, ../sass/_model.scss */
  .model-group .model-redeem .title h1 {
    right: 88px;
  }

  /* line 403, ../sass/_model.scss */
  .model-group .model-logout .title h3 {
    font-size: 20px;
  }

  /* line 406, ../sass/_model.scss */
  .model-group .model-logout {
    max-width: 360px;
  }

  /* line 409, ../sass/_model.scss */
  .model-group .model-logout .miniTxt {
    top: 7px;
    right: 73px;
    font-size: 17px;
  }
}
/* line 418, ../sass/_model.scss */
.model-Link {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  visibility: hidden;
  padding: 0 10px;
  z-index: 100;
}
/* line 429, ../sass/_model.scss */
.model-Link .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  opacity: 1;
}
/* line 438, ../sass/_model.scss */
.model-Link .Link_wrapper {
  display: none;
  border: 1px solid #1cdf2e;
  background-color: black;
  z-index: 2;
  padding: 50px 20px;
  position: relative;
}
/* line 446, ../sass/_model.scss */
.model-Link .btnClose-modelslotPage {
  cursor: pointer;
  border: unset;
  outline: unset;
  background: unset;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0%, -125%);
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}
/* line 462, ../sass/_model.scss */
.model-Link .txtTtitle {
  text-align: center;
  font-size: 30px;
  color: #fff;
  margin-bottom: 20px;
}
/* line 468, ../sass/_model.scss */
.model-Link .gorupLink {
  display: flex;
  grid-gap: 15px;
}
/* line 472, ../sass/_model.scss */
.model-Link .link-item {
  text-decoration: none;
  cursor: pointer;
  width: 175px;
  height: 45px;
  display: grid;
  place-content: center;
  color: #8b8b8b;
  font-size: 20px;
  display: flex;
  align-items: center;
  border-radius: 7px;
  border: 1px solid #8b8b8b;
}
/* line 486, ../sass/_model.scss */
.model-Link .link-item:hover {
  filter: brightness(1.5);
}
/* line 489, ../sass/_model.scss */
.model-Link .link-item .icoLink {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  margin-right: 10px;
}
/* line 496, ../sass/_model.scss */
.model-Link .link-item .icoUnLink {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  margin-right: 10px;
}
/* line 508, ../sass/_model.scss */
.model-Link .call-codeLinkModel {
  background-color: #1cdf2e;
  border: 1px solid #1cdf2e;
  color: #000;
}
/* line 513, ../sass/_model.scss */
.model-Link .Link_wrapper.active {
  display: block;
}

/* line 517, ../sass/_model.scss */
.model-Link.active {
  visibility: visible;
}

/* line 520, ../sass/_model.scss */
.model-codeLink {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  visibility: hidden;
  padding: 0 10px;
  z-index: 100;
}
/* line 531, ../sass/_model.scss */
.model-codeLink .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  opacity: 1;
}
/* line 540, ../sass/_model.scss */
.model-codeLink .codeLink_wrapper {
  z-index: 2;
  border: 1px solid #1cdf2e;
  background-color: black;
  padding: 20px;
  position: relative;
}
/* line 548, ../sass/_model.scss */
.model-codeLink .btnClose-modelslotPage {
  cursor: pointer;
  border: unset;
  outline: unset;
  background: unset;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0%, -125%);
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}
/* line 564, ../sass/_model.scss */
.model-codeLink .txtTtitle {
  text-align: center;
  font-size: 30px;
  color: #fff;
  margin-bottom: 20px;
}
/* line 571, ../sass/_model.scss */
.model-codeLink .groupIp input {
  border: unset;
  width: 310px;
  background-color: #333333;
  outline: unset;
  padding: 3px 10px;
  font-size: 20px;
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
}
/* line 583, ../sass/_model.scss */
.model-codeLink .groupBtn {
  display: flex;
}
/* line 586, ../sass/_model.scss */
.model-codeLink .btnNo,
.model-codeLink .btnYes {
  text-decoration: none;
  cursor: pointer;
  width: 120px;
  height: 40px;
  margin: 0 auto;
  border-radius: 7px;
  display: grid;
  place-content: center;
}
/* line 596, ../sass/_model.scss */
.model-codeLink .btnNo p,
.model-codeLink .btnYes p {
  font-size: 20px;
  color: #000;
}
/* line 601, ../sass/_model.scss */
.model-codeLink .btnNo {
  border: 1px solid #1cdf2e;
}
/* line 603, ../sass/_model.scss */
.model-codeLink .btnNo p {
  color: #fff;
}
/* line 607, ../sass/_model.scss */
.model-codeLink .btnYes {
  background-color: #1cdf2e;
  border: 1px solid #1cdf2e;
}

/* line 612, ../sass/_model.scss */
.model-codeLink.active {
  visibility: visible;
}

@media only screen and (max-width: 460px) {
  /* line 616, ../sass/_model.scss */
  .model-Link .gorupLink {
    flex-direction: column;
    align-items: center;
  }
}
/* line 1, ../sass/selectGame.scss */
.sec-slectGame {
  width: 90%;
  max-width: 1540px;
  margin: 0 auto;
  padding: 50px 3% 30px;
  position: relative;
  margin-top: 50px;
}
/* line 8, ../sass/selectGame.scss */
.sec-slectGame .owl-carousel .owl-nav.disabled {
  display: flex !important;
}
/* line 11, ../sass/selectGame.scss */
.sec-slectGame .owl-carousel .owl-dots.disabled {
  display: block !important;
}
/* line 14, ../sass/selectGame.scss */
.sec-slectGame .owl-item {
  transform: scale(0.85);
  transition: 0.3s;
}
/* line 19, ../sass/selectGame.scss */
.sec-slectGame .owl-item:hover .item .gameName {
  visibility: visible;
  opacity: 1;
}
/* line 23, ../sass/selectGame.scss */
.sec-slectGame .owl-item:hover img {
  filter: brightness(1.2);
}
/* line 28, ../sass/selectGame.scss */
.sec-slectGame .owl-carousel .owl-stage-outer {
  padding: 20px 0;
}
/* line 32, ../sass/selectGame.scss */
.sec-slectGame .title-slide {
  position: absolute;
  top: -4%;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
}
/* line 40, ../sass/selectGame.scss */
.sec-slectGame .item {
  text-decoration: none;
}
/* line 42, ../sass/selectGame.scss */
.sec-slectGame .item img {
  filter: brightness(0.7);
}
/* line 46, ../sass/selectGame.scss */
.sec-slectGame .item:hover .gameName {
  visibility: visible;
  opacity: 1;
}
/* line 50, ../sass/selectGame.scss */
.sec-slectGame .item:hover img {
  filter: brightness(1);
}
/* line 57, ../sass/selectGame.scss */
.sec-slectGame .slide-2 .center,
.sec-slectGame .slide-1 .center {
  transform: scale(1);
}
/* line 59, ../sass/selectGame.scss */
.sec-slectGame .slide-2 .center img,
.sec-slectGame .slide-1 .center img {
  filter: brightness(1) drop-shadow(0px 0px 7px #a8906f);
}
/* line 61, ../sass/selectGame.scss */
.sec-slectGame .slide-2 .center img:hover,
.sec-slectGame .slide-1 .center img:hover {
  filter: brightness(1) drop-shadow(0px 0px 7px #a8906f);
}
/* line 68, ../sass/selectGame.scss */
.sec-slectGame .owl-nav {
  display: flex;
  justify-content: space-between;
}
/* line 72, ../sass/selectGame.scss */
.sec-slectGame .owl-nav button {
  width: 140px;
  height: 40px;
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-color: unset !important;
  outline: unset !important;
}
/* line 80, ../sass/selectGame.scss */
.sec-slectGame .owl-nav button span {
  display: none;
}
/* line 83, ../sass/selectGame.scss */
.sec-slectGame .owl-nav button:active {
  filter: brightness(1.2);
}
/* line 87, ../sass/selectGame.scss */
.sec-slectGame .owl-nav .owl-prev {
}
/* line 90, ../sass/selectGame.scss */
.sec-slectGame .owl-nav .owl-next {
}
/* line 94, ../sass/selectGame.scss */
.sec-slectGame .owl-theme .owl-dots .owl-dot {
  outline: unset;
}
/* line 97, ../sass/selectGame.scss */
.sec-slectGame .owl-theme .owl-dots .owl-dot.active span,
.sec-slectGame .owl-theme .owl-dots .owl-dot:hover span {
  background: #03ff1c;
}
/* line 102, ../sass/selectGame.scss */
.sec-slectGame .slectSlot_wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 95%;
  margin: 0 auto;
  max-height: 30vw;
  overflow: auto;
}
/* line 111, ../sass/selectGame.scss */
.sec-slectGame .slectSlot-item {
  text-align: center;
  text-decoration: none;
  width: 19%;
  margin: 10px 0.5%;
  transform: scale(0.95);
  transition: 0.3s;
}
/* line 118, ../sass/selectGame.scss */
.sec-slectGame .slectSlot-item:hover {
  transform: scale(1);
}
/* line 121, ../sass/selectGame.scss */
.sec-slectGame .slectSlot-item p {
  margin-top: 10px;
  font-size: 20px;
  color: #f3f3f3;
  letter-spacing: 4px;
}

/* line 129, ../sass/selectGame.scss */
.sec-navGame {
  margin-top: 20px;
}
/* line 131, ../sass/selectGame.scss */
.sec-navGame #myTab {
  background: linear-gradient(90deg, black 0%, #3d7135 50%, black 100%);
  justify-content: center;
}
/* line 135, ../sass/selectGame.scss */
.sec-navGame .nav-item {
  transition: 0.3s;
  z-index: 1;
}
/* line 138, ../sass/selectGame.scss */
.sec-navGame .nav-item:hover {
  filter: brightness(1.5);
}
/* line 141, ../sass/selectGame.scss */
.sec-navGame .nav-item a {
  width: 200px;
  display: flex;
  justify-content: center;
}
/* line 146, ../sass/selectGame.scss */
.sec-navGame .nav-item p {
  font-size: 24px;
  display: flex;
  align-items: center;
  color: #fff;
}
/* line 151, ../sass/selectGame.scss */
.sec-navGame .nav-item p::before {
  content: '';
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 10px;
}
/* line 159, ../sass/selectGame.scss */
.sec-navGame .nav-item .active {
  position: relative;
}
/* line 161, ../sass/selectGame.scss */
.sec-navGame .nav-item .active::before {
  content: '';
  background-color: #007a31;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
/* line 175, ../sass/selectGame.scss */
.sec-navGame .nav-item:nth-child(1) p::before {
  width: 35px;
  height: 35px;
}
/* line 182, ../sass/selectGame.scss */
.sec-navGame .nav-item:nth-child(2) {
  margin: 0 10px;
}
/* line 185, ../sass/selectGame.scss */
.sec-navGame .nav-item:nth-child(2) p::before {
  width: 50px;
  height: 35px;
}
/* line 194, ../sass/selectGame.scss */
.sec-navGame .nav-item:nth-child(3) p::before {
  width: 35px;
  height: 35px;
}
/* line 203, ../sass/selectGame.scss */
.sec-navGame .nav-item:nth-child(4) p::before {
  width: 35px;
  height: 35px;
}

@media only screen and (max-width: 1440px) {
  /* line 215, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item p {
    margin-top: 5px;
    font-size: 16px;
    color: #f3f3f3;
    letter-spacing: 2px;
  }

  /* line 221, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot_wrapper {
    width: 95%;
    max-height: 38vw;
  }
}
@media only screen and (max-width: 1200px) {
  /* line 227, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item {
    width: 45%;
  }

  /* line 230, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot_wrapper {
    max-height: 485px;
  }

  /* line 233, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item p {
    font-size: 20px;
  }
}
@media only screen and (max-width: 1023px) {
  /* line 238, ../sass/selectGame.scss */
  .sec-navGame .nav-item a {
    width: 160px;
  }
}
@media only screen and (max-width: 900px) {
  /* line 244, ../sass/selectGame.scss */
  .sec-slectGame {
    padding: 55px 3% 35px;
  }

  /* line 247, ../sass/selectGame.scss */
  .sec-slectGame .item .gameName {
    font-size: 16px;
  }

  /* line 250, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item {
    margin: 10px 1%;
  }
}
@media only screen and (max-width: 767px) {
  /* line 255, ../sass/selectGame.scss */
  .sec-navGame .nav-item a {
    width: 110px;
  }

  /* line 258, ../sass/selectGame.scss */
  .sec-navGame .nav-item p {
    font-size: 18px;
  }

  /* line 261, ../sass/selectGame.scss */
  .sec-navGame .nav-item:nth-child(1) p::before {
    width: 25px;
    height: 25px;
  }

  /* line 265, ../sass/selectGame.scss */
  .sec-navGame .nav-item:nth-child(2) p::before {
    width: 35px;
    height: 25px;
  }

  /* line 269, ../sass/selectGame.scss */
  .sec-navGame .nav-item:nth-child(3) p::before {
    width: 25px;
    height: 25px;
  }

  /* line 273, ../sass/selectGame.scss */
  .sec-navGame .nav-item:nth-child(4) p::before {
    width: 25px;
    height: 25px;
  }

  /* line 278, ../sass/selectGame.scss */
  .sec-slectGame .title-slide {
    top: -10%;
  }

  /* line 281, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item p {
    font-size: 2vw;
  }

  /* line 286, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item {
    transform: scale(1);
    filter: brightness(1);
  }
}
@media only screen and (max-width: 460px) {
  /* line 293, ../sass/selectGame.scss */
  .sec-slectGame .title-slide {
    font-size: 30px;
    top: 0%;
  }

  /* line 297, ../sass/selectGame.scss */
  .sec-slectGame .item .gameName {
    font-size: 18px;
    margin-bottom: 0px;
  }

  /* line 301, ../sass/selectGame.scss */
  .sec-slectGame .owl-nav button {
    width: 70px;
    height: 25px;
  }

  /* line 305, ../sass/selectGame.scss */
  .sec-slectGame {
    width: 100%;
    margin-top: 30px;
    position: absolute;
    top: 47%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /* line 313, ../sass/selectGame.scss */
  .sec-navGame {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 18vw;
    overflow: hidden;
    border-top: 1px solid #03ff1c;
    border-bottom: 1px solid #03ff1c;
  }

  /* line 323, ../sass/selectGame.scss */
  .sec-navGame #myTab {
    height: 100%;
    background-color: #000;
  }

  /* line 327, ../sass/selectGame.scss */
  .sec-navGame .nav-item {
    width: 25%;
    margin: 0 !important;
  }
  /* line 330, ../sass/selectGame.scss */
  .sec-navGame .nav-item a {
    width: 100%;
    height: 18.2vw;
  }

  /* line 335, ../sass/selectGame.scss */
  .sec-navGame .nav-item p {
    flex-direction: column;
  }

  /* line 338, ../sass/selectGame.scss */
  .sec-navGame .nav-item p::before {
    margin-right: 0px;
  }

  /* line 341, ../sass/selectGame.scss */
  .sec-slectGame .owl-theme .owl-dots .owl-dot span {
    width: 7px;
    height: 7px;
    margin: 5px 4px;
  }

  /* line 347, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot_wrapper {
    width: 100%;
    max-height: 60vh;
  }

  /* line 351, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item {
    margin: 5px 2% 5px 0;
  }

  /* line 354, ../sass/selectGame.scss */
  .sec-slectGame .slectSlot-item p {
    font-size: 4vw;
  }

  /* line 357, ../sass/selectGame.scss */
  .sec-navGame #myTab {
    flex-wrap: nowrap;
  }
}
/* line 1, ../sass/selectRoom.scss */
.selectRoom-container {
  display: flex;
  width: 95%;
  max-width: 1760px;
  margin: 0 auto;
  padding: 30px 0;
}

/* line 8, ../sass/selectRoom.scss */
.btn-back-mobile {
  display: none;
  text-decoration: none !important;
  transition: 0.3s;
}
/* line 12, ../sass/selectRoom.scss */
.btn-back-mobile:hover {
  filter: brightness(1.5);
}

/* line 16, ../sass/selectRoom.scss */
.btn-formulaDD {
  display: none;
}

@media only screen and (max-width: 767px) {
  /* line 20, ../sass/selectRoom.scss */
  .selectRoom-container {
    display: block;
    padding-top: 10px;
  }

  /* line 24, ../sass/selectRoom.scss */
  .btn-back-mobile {
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 0 10px;
    width: fit-content;
  }
  /* line 30, ../sass/selectRoom.scss */
  .btn-back-mobile::before {
    content: "";
    width: 20px;
    height: 20px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 10px;
  }
  /* line 40, ../sass/selectRoom.scss */
  .btn-back-mobile p {
    font-size: 12px;
    color: #fff;
  }

  /* line 45, ../sass/selectRoom.scss */
  .btn-formulaDD {
    display: flex;
    align-items: center;
    background-color: #383838;
    border: 1px solid #1cdf2e;
    padding: 0 10px;
    padding-right: 30px;
    position: relative;
    cursor: pointer;
  }
  /* line 54, ../sass/selectRoom.scss */
  .btn-formulaDD p {
    font-size: 12px;
    color: #a3a3a3;
  }
  /* line 57, ../sass/selectRoom.scss */
  .btn-formulaDD p::after {
    content: "";
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    right: 10px;
    top: 50%;
    width: 13px;
    height: 13px;
    filter: brightness(2);
    transform: translateY(-40%);
  }
}
/* line 75, ../sass/selectRoom.scss */
.sec-formula {
  width: 300px;
}
/* line 77, ../sass/selectRoom.scss */
.sec-formula .sec-formula_wrapper {
  border: 2px solid #1cdf2e;
}
/* line 81, ../sass/selectRoom.scss */
.sec-formula .formula-title {
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  padding: 15px 0 0px;
}
/* line 85, ../sass/selectRoom.scss */
.sec-formula .formula-title h1 {
  font-family: "Kanit-Light";
  color: #fff;
  font-size: 26px;
}
/* line 91, ../sass/selectRoom.scss */
.sec-formula .formula-group {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px 15px;
}
/* line 95, ../sass/selectRoom.scss */
.sec-formula .formula-item {
  text-align: center;
  position: relative;
  cursor: pointer;
  background-color: #00aa44;
  margin-bottom: 5px;
}
/* line 101, ../sass/selectRoom.scss */
.sec-formula .formula-item p {
  padding: 18px 0;
  color: #000;
  font-size: 18px;
  transition: 0.3s;
}
/* line 107, ../sass/selectRoom.scss */
.sec-formula .formula-item:hover {
  filter: brightness(2);
}
/* line 111, ../sass/selectRoom.scss */
.sec-formula .formula-item_active {
  background-color: #1cdf2e;
}

@media only screen and (max-width: 1024px) {
  /* line 116, ../sass/selectRoom.scss */
  .sec-formula .formula-title {
    padding: 5px 0 10px;
  }

  /* line 119, ../sass/selectRoom.scss */
  .sec-formula .formula-title h1 {
    font-size: 20px;
  }

  /* line 122, ../sass/selectRoom.scss */
  .sec-formula .formula-item p {
    padding: 10px 0;
    font-size: 15px;
  }

  /* line 126, ../sass/selectRoom.scss */
  .sec-formula {
    width: 275px;
  }
}
@media only screen and (max-width: 767px) {
  /* line 131, ../sass/selectRoom.scss */
  .sec-formula {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  /* line 137, ../sass/selectRoom.scss */
  .sec-formula .sec-formula_wrapper {
    display: flex;
    border: unset;
    padding: 5px;
    background-color: rgba(0, 0, 0, 0.8);
    position: relative;
  }

  /* line 144, ../sass/selectRoom.scss */
  .sec-formula .formula-title {
    background-color: unset;
    text-align: center;
    padding: 5px 10px;
    display: flex;
  }

  /* line 150, ../sass/selectRoom.scss */
  .sec-formula .formula-title h1 {
    font-size: 12px;
  }

  /* line 153, ../sass/selectRoom.scss */
  .sec-formula .formula-group {
    display: none;
  }

  /* line 156, ../sass/selectRoom.scss */
  .sec-formula .formula-item p {
    font-size: 12px;
  }

  /* line 159, ../sass/selectRoom.scss */
  .sec-formula .formula-group_active {
    background-color: black;
    display: block;
    position: absolute;
    top: 31px;
    width: 62%;
    right: -5px;
    z-index: 3;
  }
}
/* line 172, ../sass/selectRoom.scss */
.sec-selectRoom {
  border: 2px solid #1cdf2e;
  background-color: rgba(0, 0, 0, 0.5);
  margin-left: 20px;
  width: 100%;
  position: relative;
}
/* line 178, ../sass/selectRoom.scss */
.sec-selectRoom .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
}
/* line 183, ../sass/selectRoom.scss */
.sec-selectRoom .title h1 {
  color: #fff;
  font-size: 26px;
}
/* line 187, ../sass/selectRoom.scss */
.sec-selectRoom .title .btn-close {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: 0.3s;
}
/* line 195, ../sass/selectRoom.scss */
.sec-selectRoom .title .btn-close:hover {
  filter: brightness(1.5);
}
/* line 200, ../sass/selectRoom.scss */
.sec-selectRoom .title-group {
  overflow: hidden;
}
/* line 202, ../sass/selectRoom.scss */
.sec-selectRoom .title-group p {
  color: #fff;
  font-size: 24px;
  padding: 5px 30px;
  position: relative;
  z-index: 2;
  width: fit-content;
}
/* line 211, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group {
  margin-bottom: 10px;
}
/* line 213, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .inner_wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px 15px;
  padding: 20px;
}
/* line 219, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem {
  position: relative;
  overflow: hidden;
  text-decoration: none;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: grid;
  grid-template-columns: 170px 1fr 170px;
  align-items: center;
  height: 95px;
  padding: 20px 50px;
  transition: 0.3s;
}
/* line 232, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem .logoRoom {
  height: 45px;
  width: 120px;
  margin-left: 20px;
  display: flex;
  align-items: center;
}
/* line 238, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem .logoRoom img {
  max-height: 100%;
  filter: drop-shadow(0px 0px 2px #000);
}
/* line 243, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem .roomNum {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
/* line 249, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem .roomNum p {
  font-weight: bold;
  font-size: 20px;
}
/* line 254, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem .winrate {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
/* line 260, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem .winrate p:nth-child(1) {
  color: #fff;
  font-size: 16px;
  line-height: 1;
  filter: drop-shadow(0px 0px 2px #000);
}
/* line 266, ../sass/selectRoom.scss */
.sec-selectRoom .Room_group .roomItem .winrate p:nth-child(2) {
  color: #fff;
  font-size: 36px;
  filter: drop-shadow(0px 0px 2px #000);
}
/* line 275, ../sass/selectRoom.scss */
.sec-selectRoom .scrollBar {
  max-height: 640px;
  overflow: auto;
  padding-right: 15px;
}
/* line 279, ../sass/selectRoom.scss */
.sec-selectRoom .scrollBar::-webkit-scrollbar {
  width: 7px;
}

@media only screen and (max-width: 1599px) {
  /* line 286, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem {
    grid-template-columns: 130px 1fr 130px;
    padding: 20px 40px;
  }

  /* line 290, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .roomNum p {
    font-size: 16px;
  }

  /* line 293, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(2) {
    font-size: 32px;
  }

  /* line 296, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(1) {
    font-size: 12px;
  }

  /* line 299, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .logoRoom {
    width: 100px;
    margin-left: 0px;
  }
}
@media only screen and (max-width: 1299px) {
  /* line 305, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .inner_wrapper {
    grid-template-columns: 1fr;
  }

  /* line 308, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem {
    width: 470px;
    margin: 0 auto;
  }

  /* line 312, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .logoRoom {
    margin-left: 0px;
  }
}
@media only screen and (max-width: 1024px) {
  /* line 317, ../sass/selectRoom.scss */
  .sec-selectRoom .title-group p {
    font-size: 18px;
  }

  /* line 320, ../sass/selectRoom.scss */
  .sec-selectRoom .title h1 {
    font-size: 20px;
  }

  /* line 323, ../sass/selectRoom.scss */
  .sec-selectRoom {
    margin-left: 10px;
  }

  /* line 326, ../sass/selectRoom.scss */
  .sec-selectRoom .title {
    padding: 5px 15px 10px 30px;
  }

  /* line 329, ../sass/selectRoom.scss */
  .sec-selectRoom .title .btn-close {
    width: 25px;
    height: 25px;
  }

  /* line 333, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .inner_wrapper {
    padding: 10px;
  }

  /* line 336, ../sass/selectRoom.scss */
  .sec-selectRoom .selectRoom_wrapper {
    padding: 7px;
  }
}
@media only screen and (max-width: 767px) {
  /* line 342, ../sass/selectRoom.scss */
  .sec-selectRoom {
    margin-left: 0px;
  }

  /* line 345, ../sass/selectRoom.scss */
  .sec-selectRoom .title-group p::after,
  .sec-selectRoom .title-group p::before {
    width: 115%;
  }

  /* line 349, ../sass/selectRoom.scss */
  .sec-selectRoom .title .btn-close {
    display: none;
  }

  /* line 352, ../sass/selectRoom.scss */
  .sec-selectRoom .title {
    padding: 5px 15px 10px 15px;
  }

  /* line 355, ../sass/selectRoom.scss */
  .sec-selectRoom .title h1 {
    font-size: 16px;
  }

  /* line 358, ../sass/selectRoom.scss */
  .sec-selectRoom .title-group p {
    font-size: 14px;
    padding: 0px 15px;
  }

  /* line 362, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem {
    max-width: 470px;
    width: 100%;
    grid-template-columns: 80px 1fr 80px;
    padding: 12px 25px;
    height: 70px;
  }

  /* line 369, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .logoRoom {
    height: 32px;
    width: 70px;
  }

  /* line 373, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .roomNum p {
    font-size: 11px;
  }

  /* line 376, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .winrate {
    gap: 5px;
  }

  /* line 379, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(1) {
    font-size: 8px;
  }

  /* line 382, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(2) {
    font-size: 20px;
  }

  /* line 385, ../sass/selectRoom.scss */
  .sec-selectRoom .scrollBar {
    padding-right: 0px;
  }

  /* line 388, ../sass/selectRoom.scss */
  .sec-selectRoom .Room_group .inner_wrapper {
    max-width: 360px;
    margin: 0 auto;
    padding: 0px;
  }

  /* line 393, ../sass/selectRoom.scss */
  .sec-selectRoom .scrollBar {
    max-height: unset;
    overflow: unset;
  }
}
/* line 1, ../sass/innerRoom.scss */
.sec-innerRoom {
  border: 2px solid #1cdf2e;
  background-color: rgba(0, 0, 0, 0.5);
  margin-left: 20px;
  width: 100%;
  position: relative;
}
/* line 7, ../sass/innerRoom.scss */
.sec-innerRoom .title {
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px 0;
}
/* line 13, ../sass/innerRoom.scss */
.sec-innerRoom .title h1 {
  color: #fff;
  font-size: 26px;
}
/* line 17, ../sass/innerRoom.scss */
.sec-innerRoom .title .btn-close {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: 0.3s;
}
/* line 25, ../sass/innerRoom.scss */
.sec-innerRoom .title .btn-close:hover {
  filter: brightness(1.5);
}
/* line 30, ../sass/innerRoom.scss */
.sec-innerRoom .innerRoom_wrapper {
  padding: 20px;
}
/* line 33, ../sass/innerRoom.scss */
.sec-innerRoom .row-innerRoom {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  grid-gap: 20px;
}
/* line 38, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;
}
/* line 43, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room .winRate {
  background-color: #002201;
  text-align: center;
  padding: 10px;
}
/* line 47, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room .winRate .circle {
  max-width: 90px;
  margin: 0 auto 5px;
}
/* line 51, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room .winRate p {
  text-align: center;
  font-size: 20px;
  color: #fff;
}
/* line 57, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room .showTurn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #002201;
  padding: 7px;
  position: relative;
}
/* line 64, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room .showTurn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110px;
  height: 110px;
  background-size: 100% 100%;
  animation: showTurn_animate 10s linear infinite reverse;
}
/* line 76, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room .showTurn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(0deg);
  width: 110px;
  height: 110px;
  background-size: 100% 100%;
  animation: showTurn_animate 10s linear infinite;
}
@keyframes showTurn_animate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
/* line 101, ../sass/innerRoom.scss */
.sec-innerRoom .detail-room .showTurn .showTurn_item {
  width: 40px;
  height: 40px;
}
/* line 107, ../sass/innerRoom.scss */
.sec-innerRoom .sec-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}
/* line 111, ../sass/innerRoom.scss */
.sec-innerRoom .sec-card .group-card {
  background: #002201;
  padding: 10px 20px;
}
/* line 114, ../sass/innerRoom.scss */
.sec-innerRoom .sec-card .group-card h5 {
  margin-top: 5px;
  text-align: center;
  color: #fff;
  font-size: 18px;
}
/* line 121, ../sass/innerRoom.scss */
.sec-innerRoom .sec-card .wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 7px;
}
/* line 126, ../sass/innerRoom.scss */
.sec-innerRoom .sec-card .card-item {
  max-width: 80px;
  max-height: 110px;
  min-width: 60px;
  min-height: 85px;
  width: 3.8vw;
  height: 5vw;
  overflow: hidden;
  background: #000000;
  place-self: center;
}
/* line 138, ../sass/innerRoom.scss */
.sec-innerRoom .txt-wait {
  text-align: center;
  font-size: 18px;
  color: #fff;
  margin: 10px 0;
}
/* line 144, ../sass/innerRoom.scss */
.sec-innerRoom .chessboard {
  margin-bottom: 10px;
}
/* line 146, ../sass/innerRoom.scss */
.sec-innerRoom .chessboard .bg-chessboard {
  position: absolute;
  top: 0;
  display: grid;
  grid-template-columns: repeat(12, 40px);
  grid-template-rows: repeat(6, 25px);
  grid-gap: 2px;
  margin-top: 1px;
  margin-left: 1px;
}
/* line 156, ../sass/innerRoom.scss */
.sec-innerRoom .chessboard .bg-chessboard-item {
  width: 100%;
  height: 100%;
  background: #007e0a;
  border-radius: 1px;
}
/* line 162, ../sass/innerRoom.scss */
.sec-innerRoom .chessboard .wrapper {
  display: flex;
  width: 505px;
  height: 165px;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
}
/* line 173, ../sass/innerRoom.scss */
.sec-innerRoom .chessboard .chess-item {
  width: 42px;
  height: 23px;
  z-index: 2;
  margin: 2px 0;
}
/* line 180, ../sass/innerRoom.scss */
.sec-innerRoom .sum-result {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  color: #a3a3a3;
  background: #002201;
  padding: 2px 20px;
  border-radius: 10px;
}
/* line 188, ../sass/innerRoom.scss */
.sec-innerRoom .sum-result .sum-result_col-L {
  display: flex;
}
/* line 192, ../sass/innerRoom.scss */
.sec-innerRoom .sum-result .sum-result_col-R p {
  color: #fff;
}
/* line 196, ../sass/innerRoom.scss */
.sec-innerRoom .sum-result .sum-item {
  margin-right: 10px;
}
/* line 198, ../sass/innerRoom.scss */
.sec-innerRoom .sum-result .sum-item p {
  color: #fff;
}
/* line 203, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup {
  color: #fff;
  background-color: #00431b;
}
/* line 207, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .txt-win::before {
  content: "";
  width: 35px;
  height: 15px;
  display: inline-block;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
/* line 219, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .txt-lose::before {
  content: "";
  width: 35px;
  height: 15px;
  display: inline-block;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
/* line 230, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  place-items: center;
}
/* line 234, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-row p {
  width: 100%;
  text-align: center;
  padding: 5px 0;
}
/* line 240, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-turn {
  font-size: 18px;
}
/* line 242, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-turn .table-body {
  height: 200px;
  overflow: auto;
}
/* line 245, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-turn .table-body .table-row {
  background-color: #00431b;
  position: relative;
}
/* line 248, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-turn .table-body .table-row::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 90%;
  height: 1px;
  background-color: #adadad;
}
/* line 260, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-sum {
  font-size: 20px;
  margin-top: 5px;
}
/* line 265, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-sum p span {
  margin-left: 5px;
}
/* line 270, ../sass/innerRoom.scss */
.sec-innerRoom .table-turnGroup .table-title {
  background-color: #002201;
}
/* line 275, ../sass/innerRoom.scss */
.sec-innerRoom .graph {
  background-color: #002201;
  padding: 10px 0 30px;
}
/* line 278, ../sass/innerRoom.scss */
.sec-innerRoom .graph .graph-title {
  text-align: center;
  padding-bottom: 10px;
}
/* line 281, ../sass/innerRoom.scss */
.sec-innerRoom .graph .graph-title h1 {
  color: #fff;
  font-size: 24px;
}
/* line 286, ../sass/innerRoom.scss */
.sec-innerRoom .graph .graph-area {
  width: 90%;
  margin: 0 auto;
  height: 20vw;
  max-height: 415px;
  background: #c4c4c4;
}
/* line 294, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres {
  margin-top: 10px;
  background-color: #00431b;
}
/* line 297, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .graph-title {
  background-color: #002201;
  text-align: center;
  padding: 10px 0;
}
/* line 301, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .graph-title h1 {
  color: #fff;
  font-size: 20px;
}
/* line 306, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .groupProgress {
  padding: 15px 40px;
}
/* line 309, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .progress-item {
  color: #fff;
  margin-bottom: 5px;
  position: relative;
}
/* line 313, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .progress-item label {
  color: #fff;
  display: block;
  margin-bottom: 0px;
  font-size: 18px;
  line-height: 0.75;
}
/* line 320, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .progress-item progress {
  width: calc(100% - 50px);
  height: 13px;
  border-radius: 0;
  appearance: none;
}
/* line 326, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .progress-item progress::-webkit-progress-bar {
  background-color: rgba(0, 0, 0, 0.1);
  border: 1px solid #1e1e1e;
  padding: 2px;
}
/* line 331, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .progress-item progress::-webkit-progress-value {
  background-color: #00ff19;
}
/* line 335, ../sass/innerRoom.scss */
.sec-innerRoom .sec-progres .progress-item span {
  position: absolute;
  right: 0;
  font-size: 24px;
  line-height: 0.75;
}

@media only screen and (max-width: 1440px) {
  /* line 345, ../sass/innerRoom.scss */
  .sec-innerRoom .sec-progres .graph-title h1 {
    font-size: 14px;
  }

  /* line 348, ../sass/innerRoom.scss */
  .sec-innerRoom .sec-progres .groupProgress {
    padding: 15px 20px;
  }
}
@media only screen and (max-width: 1240px) {
  /* line 353, ../sass/innerRoom.scss */
  .sec-innerRoom {
    width: 100%;
    margin-left: 10px;
  }

  /* line 357, ../sass/innerRoom.scss */
  .sec-innerRoom .row-innerRoom {
    grid-template-columns: 1fr;
    width: fit-content;
    margin: 0 auto;
  }

  /* line 362, ../sass/innerRoom.scss */
  .sec-innerRoom .graph .graph-area {
    height: 300px;
  }
}
@media only screen and (max-width: 1024px) {
  /* line 368, ../sass/innerRoom.scss */
  .sec-innerRoom .title h1 {
    font-size: 20px;
  }

  /* line 371, ../sass/innerRoom.scss */
  .sec-innerRoom .title .btn-close {
    width: 25px;
    height: 25px;
  }

  /* line 376, ../sass/innerRoom.scss */
  .sec-innerRoom .detail-room .winRate p {
    font-size: 14px;
  }

  /* line 380, ../sass/innerRoom.scss */
  .sec-innerRoom .detail-room .showTurn p {
    font-size: 16px;
  }

  /* line 383, ../sass/innerRoom.scss */
  .sec-innerRoom .chessboard .bg-chessboard {
    grid-template-columns: repeat(12, 35px);
    grid-template-rows: repeat(6, 20px);
  }

  /* line 387, ../sass/innerRoom.scss */
  .sec-innerRoom .chessboard .wrapper {
    width: 448px;
    height: 135px;
  }

  /* line 391, ../sass/innerRoom.scss */
  .sec-innerRoom .chessboard .chess-item {
    width: 37.5px;
    height: 18px;
  }

  /* line 395, ../sass/innerRoom.scss */
  .sec-innerRoom .sec-card .card-item {
    min-width: 57px;
    min-height: 80px;
  }
}
@media only screen and (max-width: 767px) {
  /* line 401, ../sass/innerRoom.scss */
  .sec-innerRoom {
    width: 100%;
    margin: 0 auto;
  }

  /* line 405, ../sass/innerRoom.scss */
  .sec-innerRoom .chessboard .bg-chessboard {
    grid-template-columns: repeat(10, 7.9vw);
    grid-template-rows: repeat(6, 5.5vw);
  }

  /* line 409, ../sass/innerRoom.scss */
  .sec-innerRoom .chessboard .wrapper {
    width: 84vw;
    height: 37vw;
  }

  /* line 413, ../sass/innerRoom.scss */
  .sec-innerRoom .chessboard .chess-item {
    width: 8.6vw;
    height: 5vw;
  }

  /* line 417, ../sass/innerRoom.scss */
  .sec-innerRoom .innerRoom_wrapper {
    padding: 10px 10px;
  }

  /* line 420, ../sass/innerRoom.scss */
  .sec-innerRoom .row-innerRoom {
    width: 99%;
  }

  /* line 423, ../sass/innerRoom.scss */
  .sec-innerRoom .sec-card .card-item {
    width: 10.5vw;
    height: 15vw;
    min-width: 39px;
    min-height: 55px;
  }

  /* line 429, ../sass/innerRoom.scss */
  .sec-innerRoom .sec-card .group-card {
    padding: 10px;
  }

  /* line 432, ../sass/innerRoom.scss */
  .sec-innerRoom .title h1 {
    font-size: 4vw;
  }

  /* line 435, ../sass/innerRoom.scss */
  .sec-innerRoom .title {
    padding: 10px 10px;
  }

  /* line 438, ../sass/innerRoom.scss */
  .sec-innerRoom .title .btn-close {
    width: 5vw;
    height: 5vw;
  }

  /* line 442, ../sass/innerRoom.scss */
  .sec-innerRoom .detail-room .showTurn p {
    font-size: 3vw;
  }

  /* line 445, ../sass/innerRoom.scss */
  .sec-innerRoom .sum-result {
    font-size: 4vw;
  }

  /* line 448, ../sass/innerRoom.scss */
  .sec-innerRoom .graph .graph-area {
    height: 55vw;
  }

  /* line 451, ../sass/innerRoom.scss */
  .sec-innerRoom .detail-room .winRate p:nth-child(3) {
    font-size: 4vw;
  }
}
/* line 1, ../sass/slot.scss */
.slot-2-page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  position: relative;
}
/* line 7, ../sass/slot.scss */
.slot-2-page .wrapper {
  max-width: 1350px;
  margin: 0 auto;
}
/* line 11, ../sass/slot.scss */
.slot-2-page .titlePage {
  text-align: center;
}
/* line 13, ../sass/slot.scss */
.slot-2-page .titlePage h1 {
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  padding: 20px 0;
}
/* line 20, ../sass/slot.scss */
.slot-2-page .menosary_wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 10px;
  margin: 0 auto;
  padding: 0 50px 40px;
}
/* line 27, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item {
  text-decoration: none;
  background-size: 100% 100%;
  color: #fff;
  float: left;
  width: 100%;
  position: relative;
  page-break-inside: avoid;
  break-inside: avoid;
  margin-bottom: 5px;
  padding: 30px 40px;
  transition: 0.3s;
}
/* line 42, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item p {
  font-size: 14px;
  text-align: center;
}
/* line 47, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item .winrate-bar {
  height: 16px;
  width: 100%;
  background: #c4c4c4;
  border-radius: 20px;
  position: relative;
}
/* line 54, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item .winrate-bar p {
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0;
  z-index: 2;
  display: grid;
  place-content: center;
}
/* line 65, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item .winrate-bar .winrate-bar_inner {
  height: inherit;
  background-color: #ff0600;
  border-radius: inherit;
  position: relative;
  transform-origin: left;
  transform: scaleX(0);
  animation: winrate-bar_inner 1s forwards;
  animation-delay: 1.3s;
}
@keyframes winrate-bar_inner {
  100% {
    transform: scaleX(1);
  }
}
/* line 80, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item .winrate-bar .winrate-bar_inner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: repeat;
  border-radius: inherit;
  animation: bg-processbar 50s linear infinite;
}
@keyframes bg-processbar {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100vw 0;
  }
}
/* line 106, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item_wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
}
/* line 111, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game {
  width: 120px;
}
/* line 114, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game .img-game-inner {
  text-align: center;
}
/* line 117, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game img {
  max-width: 100%;
  height: 76px;
}
/* line 123, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent {
  padding-left: 20px;
}
/* line 126, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h4 {
  font-size: 18px;
  line-height: 0.8;
}
/* line 131, ../sass/slot.scss */
.slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h3 {
  margin-top: 10px;
  line-height: 0.9;
  font-size: 38px;
  font-weight: 700;
  color: #ff0600;
}

@media only screen and (max-width: 1349px) {
  /* line 144, ../sass/slot.scss */
  .slot-2-page .wrapper {
    max-width: 1024px;
  }

  /* line 147, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 1023px) {
  /* line 152, ../sass/slot.scss */
  .slot-2-page .wrapper {
    max-width: 700px;
  }

  /* line 155, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 767px) {
  /* line 160, ../sass/slot.scss */
  .slot-2-page .wrapper {
    max-width: 375px;
  }

  /* line 163, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper {
    padding: 10px;
  }

  /* line 166, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item {
    padding: 20px 25px;
  }

  /* line 169, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent {
    padding-left: 10px;
  }

  /* line 172, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h4 {
    font-size: 12px;
  }

  /* line 175, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game {
    width: 62px;
  }

  /* line 178, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game img {
    height: 51px;
  }

  /* line 181, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h3 {
    margin-top: 5px;
    font-size: 24px;
  }

  /* line 185, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item p {
    font-size: 10px;
  }

  /* line 188, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item .winrate-bar p {
    font-size: 10px;
  }

  /* line 191, ../sass/slot.scss */
  .slot-2-page .menosary_wrapper .box-room-item .winrate-bar {
    height: 10px;
  }

  /* line 194, ../sass/slot.scss */
  .slot-2-page .btn-back-mobile p {
    font-size: 16px;
  }

  /* line 197, ../sass/slot.scss */
  .slot-2-page .btn-back-mobile::before {
    width: 30px;
    height: 30px;
    margin-left: 10px;
  }

  /* line 202, ../sass/slot.scss */
  .slot-2-page .titlePage h1 {
    padding: 10px 0;
  }

  /* line 205, ../sass/slot.scss */
  .slot-2-page {
    padding-top: 15px;
  }
}
.login-page{
  overflow-y: hidden;

}
/* line 2, ../sass/login.scss */
.login-page .bgLogin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-position: center;
  z-index: -1;
}
/* line 13, ../sass/login.scss */
.login-page .index-page_wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  overflow: hidden;
}
/* line 23, ../sass/login.scss */
.login-page .logo {
  margin: 0 auto;
  text-align: center;
  position: relative;
  width: 1000px;
  height: 600px;
}
/* line 29, ../sass/login.scss */
.login-page .logo .logo_main {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
/* line 38, ../sass/login.scss */
.login-page .wrapper-content {
  width: 100%;
  padding: 30px 0;
  text-align: center;
  position: absolute;
  bottom: 10%;
  z-index: 2;
}
/* line 45, ../sass/login.scss */
.login-page .wrapper-content h1 {
  color: #fff;
  margin-bottom: 10px;
}
/* line 48, ../sass/login.scss */
.login-page .wrapper-content h1::before {
  content: ">>";
  margin-right: 15px;
}
/* line 52, ../sass/login.scss */
.login-page .wrapper-content h1::after {
  content: "<<";
  margin-left: 15px;
}
/* line 57, ../sass/login.scss */
.login-page .wrapper-content .group-btn {
  display: flex;
  justify-content: center;
}
/* line 61, ../sass/login.scss */
.login-page .wrapper-content .btn-item {
  width: 220px;
  height: 65px;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 20px;
  cursor: pointer;
  transition: 0.3s;
}
/* line 70, ../sass/login.scss */
.login-page .wrapper-content .btn-item:last-child {
  margin-right: 0;
}
/* line 73, ../sass/login.scss */
.login-page .wrapper-content .btn-item:hover {
  filter: brightness(2);
}
/* line 77, ../sass/login.scss */
.login-page .wrapper-content .btn-login {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 308px;
  height: 85px;
}
/* line 82, ../sass/login.scss */
.login-page .wrapper-content .btn-register {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  width: 308px;
  height: 85px;
}
/* line 85, ../sass/login.scss */
.login-page .wrapper-content .contact-txt {
  font-family: "Kanit-Light";
  font-size: 26px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}
/* line 93, ../sass/login.scss */
.login-page .wrapper-content .contact-txt a {
  margin-left: 15px;
  font-size: 20px;
  display: flex;
  align-items: center;
  color: #fff;
  background-color: #017008;
  text-decoration: none;
  padding-right: 20px;
  border-radius: 7px;
  overflow: hidden;
  transition: 0.3s;
}
/* line 105, ../sass/login.scss */
.login-page .wrapper-content .contact-txt a::before {
  content: "";
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 35px;
  height: 35px;
  margin-right: 15px;
}
/* line 115, ../sass/login.scss */
.login-page .wrapper-content .contact-txt a:hover {
  filter: brightness(1.5);
}
/* line 121, ../sass/login.scss */
.login-page #bg-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
}

/* line 129, ../sass/login.scss */
.model-login {
  display: none;
  max-width: 550px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
  padding-top: 60px;
}
/* line 135, ../sass/login.scss */
.model-login .miniTxt {
  position: absolute;
  top: 8px;
  left: 50%;
  color: #05f31c;
  font-size: 22px;
  transform: translateX(-50%);
}
/* line 143, ../sass/login.scss */
.model-login .wrapper {
  border: unset;
  background-color: unset;
}
/* line 147, ../sass/login.scss */
.model-login .title {
  text-align: left;
}
/* line 149, ../sass/login.scss */
.model-login .title p {
  text-indent: 50px;
  color: #fff;
  font-size: 20px;
}
/* line 153, ../sass/login.scss */
.model-login .title p a {
  color: #05f31c;
  text-decoration: underline;
}
/* line 159, ../sass/login.scss */
.model-login form {
  text-align: center;
}
/* line 161, ../sass/login.scss */
.model-login form input {
  background-color: unset;
  border: unset;
  outline: unset;
  font-family: "Kanit-Light";
  color: #f3f3f3;
  text-align: center;
  width: 80%;
  font-size: 24px;
  padding: 5px 25px;
}
/* line 173, ../sass/login.scss */
.model-login .txt-swith {
  color: #a3a3a3;
  font-size: 22px;
  text-align: center;
}
/* line 177, ../sass/login.scss */
.model-login .txt-swith .link-register {
  margin-left: 10px;
  font-size: 24px;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}

/* line 186, ../sass/login.scss */
.model-login_active {
  display: block;
}

/* line 190, ../sass/login.scss */
.model-login .group-btn {
  position: relative;
  bottom: 0px;
  left: 0px;
}
/* line 195, ../sass/login.scss */
.model-login .recapcha {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* line 199, ../sass/login.scss */
.model-login .recapcha .cf-code {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* line 203, ../sass/login.scss */
.model-login .recapcha .cf-code p {
  color: #05f31c;
  font-size: 24px;
}
/* line 207, ../sass/login.scss */
.model-login .recapcha .cf-code .refreshCode {
  background-color: unset;
  border: unset;
  outline: unset;
  width: 30px;
  height: 30px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 15px;
}
/* line 217, ../sass/login.scss */
.model-login .recapcha .cf-code .refreshCode.active {
  transform: rotate(360deg);
  transition: 0.7s;
}
/* line 222, ../sass/login.scss */
.model-login .recapcha input {
  width: 140px;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
}

/* line 230, ../sass/login.scss */
.model-register {
  display: none;
}
/* line 232, ../sass/login.scss */
.model-register .title {
  text-align: center;
}
/* line 235, ../sass/login.scss */
.model-register form {
  text-align: center;
}
/* line 237, ../sass/login.scss */
.model-register form input {
  background-color: unset;
  border: unset;
  outline: unset;
  font-family: "Kanit-Light";
  color: #f3f3f3;
  text-align: center;
  width: 80%;
  font-size: 26px;
  padding: 7px 25px;
}
/* line 249, ../sass/login.scss */
.model-register .txt-swith {
  color: #a3a3a3;
  font-size: 22px;
  text-align: center;
}
/* line 253, ../sass/login.scss */
.model-register .txt-swith .link-login {
  margin-left: 10px;
  font-size: 24px;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}
/* line 261, ../sass/login.scss */
.model-register .recapcha {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* line 265, ../sass/login.scss */
.model-register .recapcha .cf-code {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* line 269, ../sass/login.scss */
.model-register .recapcha .cf-code p {
  color: #00ffff;
  font-size: 32px;
}
/* line 273, ../sass/login.scss */
.model-register .recapcha .cf-code .refreshCode {
  background-color: unset;
  border: unset;
  outline: unset;
  width: 30px;
  height: 30px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 15px;
}
/* line 283, ../sass/login.scss */
.model-register .recapcha .cf-code .refreshCode.active {
  transform: rotate(360deg);
  transition: 0.7s;
}
/* line 288, ../sass/login.scss */
.model-register .recapcha input {
  width: 140px;
  border: 1px solid #00ffff;
  font-size: 20px;
}

/* line 295, ../sass/login.scss */
.model-register_active {
  display: block;
}

/* line 302, ../sass/login.scss */
.model-register .group-btn {
  position: relative;
  bottom: 0px;
  left: 0px;
}

/* line 308, ../sass/login.scss */
/*canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
*/
@media only screen and (max-width: 1300px) {
  /* line 317, ../sass/login.scss */
  .login-page .logo {
    width: 600px;
    height: 530px;
  }
}
@media only screen and (max-width: 767px) {
  /* line 325, ../sass/login.scss */
  .model-register form input {
    width: 95%;
    font-size: 20px;
    padding: 7px 10px;
  }

  /* line 330, ../sass/login.scss */
  .model-register .recapcha input {
    width: 80px;
    font-size: 14px;
  }

  /* line 334, ../sass/login.scss */
  .model-register .recapcha .cf-code .refreshCode {
    width: 20px;
    height: 20px;
  }

  /* line 338, ../sass/login.scss */
  .model-register .recapcha .cf-code p {
    font-size: 14px;
  }

  /* line 341, ../sass/login.scss */
  .model-register .recapcha .cf-code p:nth-child(2) {
    font-size: 20px;
  }

  /* line 344, ../sass/login.scss */
  .model-register .txt-swith {
    font-size: 12px;
  }

  /* line 347, ../sass/login.scss */
  .model-register .txt-swith .link-login {
    font-size: 16px;
  }

  /* line 350, ../sass/login.scss */
  .model-register .group-btn {
    bottom: -30px;
    left: 0;
  }

  /* line 354, ../sass/login.scss */
  .model-register .wrapper {
    padding: 50px 45px;
  }

  /* line 358, ../sass/login.scss */
  .login-page .logo {
    max-width: 80vw;
  }

  /* line 361, ../sass/login.scss */
  .login-page .wrapper-content .group-btn {
    display: block;
    margin-top: 30px;
  }

  /* line 365, ../sass/login.scss */
  .login-page .wrapper-content h1 {
    font-size: 26px;
  }

  /* line 368, ../sass/login.scss */
  .login-page .wrapper-content .btn-item:last-child {
    margin-right: auto;
  }

  /* line 371, ../sass/login.scss */
  .login-page .wrapper-content .btn-item {
    width: 200px;
    height: 55px;
    margin: 15px auto;
  }

  /* line 377, ../sass/login.scss */
  .login-page .wrapper-content::before {
    top: 5%;
    width: 90%;
    border-top: 5px dotted #f2ab17;
  }

  /* line 382, ../sass/login.scss */
  .login-page .wrapper-content .contact-txt {
    font-family: "Kanit-Light";
    font-size: 18px;
    color: #fff;
    display: inline-block;
  }

  /* line 388, ../sass/login.scss */
  .login-page .wrapper-content .contact-txt a {
    margin-left: 0px;
    margin-top: 20px;
  }

  /* line 392, ../sass/login.scss */
  .login-page .wrapper-content {
    padding: 0px;
  }

  /* line 397, ../sass/login.scss */
  .login-page .logo {
    width: 400px;
    height: 400px;
  }

  /* line 401, ../sass/login.scss */
  .login-page .logo .logo_main {
    max-width: 270px;
  }
}
@media only screen and (max-width: 550px) {
  /* line 406, ../sass/login.scss */
  .model-login {
    max-width: 360px !important;
  }

  /* line 409, ../sass/login.scss */
  .model-login form input {
    width: 90%;
    font-size: 18px;
    padding: 5px 10px;
  }

  /* line 414, ../sass/login.scss */
  .model-login .recapcha .cf-code p {
    font-size: 16px;
  }

  /* line 417, ../sass/login.scss */
  .model-login .recapcha input {
    width: 90px;
    font-size: 16px;
  }

  /* line 421, ../sass/login.scss */
  .model-login .miniTxt {
    top: 8px;
    right: 80px;
    font-size: 20px;
  }

  /* line 426, ../sass/login.scss */
  .model-login .title p {
    text-indent: 20px;
    font-size: 14px;
  }
}
/* line 1, ../sass/_hilo.scss */
.ico-hilo-h {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center 0px;
  background-size: contain;
}

/* line 10, ../sass/_hilo.scss */
.ico-hilo-l {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center 0px;
  background-size: contain;
}

/* line 19, ../sass/_hilo.scss */
.ico-hilo-s {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center 0px;
  background-size: contain;
}

/* line 28, ../sass/_hilo.scss */
.dice_1 {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 280%;
}

/* line 37, ../sass/_hilo.scss */
.dice_2 {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 280%;
}

/* line 46, ../sass/_hilo.scss */
.dice_3 {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 280%;
}

/* line 55, ../sass/_hilo.scss */
.dice_4 {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 280%;
}

/* line 64, ../sass/_hilo.scss */
.dice_5 {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 280%;
}

/* line 73, ../sass/_hilo.scss */
.dice_6 {
  width: 40px;
  height: 40px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 280%;
}

/* line 82, ../sass/_hilo.scss */
.group-diceHilo {
  display: grid;
  background-color: #002201;
  grid-template-columns: 1fr 1fr 1fr;
  overflow: hidden;
}
/* line 87, ../sass/_hilo.scss */
.group-diceHilo .diceHilo_item {
  text-align: center;
}
/* line 89, ../sass/_hilo.scss */
.group-diceHilo .diceHilo_item img {
  max-height: 130px;
  max-width: 100%;
  transform: scale(1.8);
}

/* line 96, ../sass/_hilo.scss */
.sec-resultHilo {
  height: 180px;
  margin: 10px auto 20px;
  overflow: hidden;
  width: 90%;
}
/* line 101, ../sass/_hilo.scss */
.sec-resultHilo .resultHilo-item {
  float: left;
  width: 10%;
  padding: 10px 0;
}
/* line 105, ../sass/_hilo.scss */
.sec-resultHilo .resultHilo-item:last-child {
  background-color: #002201;
}
/* line 109, ../sass/_hilo.scss */
.sec-resultHilo .resultHilo-inner {
  margin-top: 5px;
}
/* line 112, ../sass/_hilo.scss */
.sec-resultHilo .dice-item {
  width: 40px;
  height: 40px;
  margin: 0 auto;
}
/* line 117, ../sass/_hilo.scss */
.sec-resultHilo .icon-hilo {
  margin: 0 auto;
}

@media only screen and (max-width: 1300px) {
  /* line 122, ../sass/_hilo.scss */
  .sec-resultHilo .icon-hilo {
    width: 30px;
    height: 30px;
  }

  /* line 126, ../sass/_hilo.scss */
  .sec-resultHilo .resultHilo-item {
    padding: 5px 0;
  }

  /* line 129, ../sass/_hilo.scss */
  .sec-resultHilo .dice-item {
    width: 35px;
    height: 35px;
  }

  /* line 133, ../sass/_hilo.scss */
  .sec-resultHilo {
    height: 150px;
  }
}
@media only screen and (max-width: 1200px) {
  /* line 138, ../sass/_hilo.scss */
  .sec-resultHilo .icon-hilo {
    width: 40px;
    height: 40px;
  }

  /* line 142, ../sass/_hilo.scss */
  .sec-resultHilo .dice-item {
    width: 40px;
    height: 40px;
  }

  /* line 146, ../sass/_hilo.scss */
  .sec-resultHilo .resultHilo-item {
    padding: 10px 0;
  }

  /* line 149, ../sass/_hilo.scss */
  .sec-resultHilo {
    height: 185px;
  }
}
@media only screen and (max-width: 600px) {
  /* line 154, ../sass/_hilo.scss */
  .sec-resultHilo .icon-hilo {
    width: 6.5vw;
    height: 6.5vw;
  }

  /* line 158, ../sass/_hilo.scss */
  .sec-resultHilo .resultHilo-item {
    padding: 5px 0;
  }

  /* line 161, ../sass/_hilo.scss */
  .sec-resultHilo .dice-item {
    width: 7vw;
    height: 7vw;
  }

  /* line 165, ../sass/_hilo.scss */
  .sec-resultHilo {
    height: 31vw;
  }
}
/* line 1, ../sass/_RdProgress.scss */
svg.radial-progress {
  height: auto;
  max-width: 160px;
  transform: rotate(-90deg);
  width: 100%;
}

/* line 8, ../sass/_RdProgress.scss */
svg.radial-progress circle {
  fill: transparent;
  stroke: #fff;
  stroke-dashoffset: 219.91148575129;
  /* Circumference */
  stroke-width: 5;
}

/* line 16, ../sass/_RdProgress.scss */
svg.radial-progress circle.incomplete {
  opacity: 0.25;
}

/* line 20, ../sass/_RdProgress.scss */
svg.radial-progress circle.complete {
  stroke-dasharray: 219.91148575129;
  /* Circumference */
}

/* line 25, ../sass/_RdProgress.scss */
svg.radial-progress text {
  fill: #fff;
  text-anchor: middle;
}

/*** COLORS ***/
/* Primary */
/* line 34, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 1) circle {
  stroke: #dbcc95;
}

/* line 38, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 1) circle.green {
  stroke: #00ff19;
}

/* line 41, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 1) circle.yellow {
  stroke: #ffc107;
}

/* line 44, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 1) circle.red {
  stroke: #dc3545;
}

/* Secondary */
/* line 50, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 2) circle {
  stroke: #83e4e2;
}

/* Tertiary */
/* line 56, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 3) circle {
  stroke: #fd6470;
}

/* Quaternary */
/* line 62, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 4) circle {
  stroke: #fca858;
}

/* Quinary */
/* line 68, ../sass/_RdProgress.scss */
svg.radial-progress:nth-of-type(6n + 5) circle {
  stroke: #fddc32;
}

/* line 73, ../sass/_RdProgress.scss */
.stork-Gray {
  stroke: #333333 !important;
}

/* line 76, ../sass/_RdProgress.scss */
svg.radial-progress .txtWin {
  fill: #fff;
  font-size: 10px;
}

/* line 80, ../sass/_RdProgress.scss */
svg.radial-progress .percentage {
  font-size: 16px;
}

/* line 85, ../sass/_RdProgress.scss */
.SlotInnerRoom svg.radial-progress {
  max-width: 100px;
}

@media only screen and (max-width: 550px) {
  /* line 91, ../sass/_RdProgress.scss */
  svg.radial-progress {
    max-width: 100px;
  }
}
/* line 1, ../sass/LinkPage.scss */
.linkPage {
  padding: 15px 20px;
}
/* line 3, ../sass/LinkPage.scss */
.linkPage .title {
  text-align: center;
}
/* line 5, ../sass/LinkPage.scss */
.linkPage .title h1 {
  color: #fff;
  font-size: 36px;
  padding: 20px 0;
}

/* line 12, ../sass/LinkPage.scss */
.linkPage_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 2px solid #1cdf2e;
  background-color: rgba(0, 0, 0, 0.7);
  max-width: 1300px;
  margin: 0 auto;
  padding: 30px;
  gap: 30px;
  overflow: hidden;
}

/* line 25, ../sass/LinkPage.scss */
.sec-iframe {
  height: 560px;
  max-width: 455px;
  padding: 50px 15px 45px 20px;
  background-size: 100% 100%;
  background-position: center;
}
/* line 32, ../sass/LinkPage.scss */
.sec-iframe iframe {
  width: 100%;
  height: 100%;
  background: #878787;
  border: unset;
}

/* line 39, ../sass/LinkPage.scss */
.boxGame {
  background-size: 100% 100%;
  background-position: center;
  padding: 25px;
  text-align: center;
  margin-bottom: 10px;
}
/* line 46, ../sass/LinkPage.scss */
.boxGame img {
  max-width: 300px;
  margin-bottom: 5px;
}
/* line 50, ../sass/LinkPage.scss */
.boxGame p {
  color: #fff;
  font-size: 20px;
}

/* line 55, ../sass/LinkPage.scss */
.resetTime {
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
}
/* line 64, ../sass/LinkPage.scss */
.resetTime .time-icon {
  width: 30px;
  height: 50px;
  background-position: center;
  background-size: 100% 100%;
  margin-right: 10px;
}
/* line 72, ../sass/LinkPage.scss */
.resetTime p {
  font-size: 18px;
  color: #fff;
}
/* line 76, ../sass/LinkPage.scss */
.resetTime h2 {
  line-height: 1;
  font-size: 30px;
  color: #fff;
}

/* line 82, ../sass/LinkPage.scss */
.winRateGame {
  width: 270px;
  height: 270px;
  display: grid;
  place-content: center;
  text-align: center;
  position: relative;
  background-position: center;
  background-size: 100% 100%;
  z-index: 1;
}
/* line 93, ../sass/LinkPage.scss */
.winRateGame::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: 100% 100%;
  animation: winRateGame_animate 10s linear infinite;
  z-index: -1;
}
@keyframes winRateGame_animate {
  100% {
    transform: rotate(360deg);
  }
}
/* line 111, ../sass/LinkPage.scss */
.winRateGame::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: 100% 100%;
  animation: winRateGame_animate 10s linear infinite reverse;
  z-index: -1;
}
@keyframes winRateGame_animate {
  100% {
    transform: rotate(360deg);
  }
}
/* line 129, ../sass/LinkPage.scss */
.winRateGame p {
  font-size: 18px;
  color: #fff;
}
/* line 133, ../sass/LinkPage.scss */
.winRateGame h2 {
  font-size: 36px;
  color: #fff;
}

@media only screen and (max-width: 1149px) {
  /* line 139, ../sass/LinkPage.scss */
  .linkPage_wrapper {
    flex-direction: column;
  }
}
@media only screen and (max-width: 767px) {
  /* line 144, ../sass/LinkPage.scss */
  .linkPage_wrapper {
    padding: 10px;
  }

  /* line 147, ../sass/LinkPage.scss */
  .sec-iframe {
    height: 445px;
    padding: 0px;
    background-image: unset;
    border: 1px solid #03ff1c;
  }

  /* line 153, ../sass/LinkPage.scss */
  .linkPage .btn-back-mobile {
    padding: 5px 10px;
  }

  /* line 156, ../sass/LinkPage.scss */
  .linkPage .btn-back-mobile::before {
    width: 30px;
    height: 30px;
  }

  /* line 160, ../sass/LinkPage.scss */
  .linkPage .btn-back-mobile p {
    font-size: 16px;
  }

  /* line 163, ../sass/LinkPage.scss */
  .linkPage .title h1 {
    padding: 10px 0;
  }
}
/* line 1, ../sass/ball.scss */
.ballPage {
  color: #000;
  margin: 0 auto;
  margin-top: 30px;
  max-width: 1300px;
  border: 2px solid #1cdf2e;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
}
/* line 9, ../sass/ball.scss */
.ballPage .ballPage_title {
  padding-left: 5px;
  margin-bottom: 15px;
}
/* line 12, ../sass/ball.scss */
.ballPage .ballPage_title h1 {
  font-size: 34px;
  color: #fff;
}
/* line 16, ../sass/ball.scss */
.ballPage .ballPage_title p {
  font-size: 20px;
  color: #fff;
}
/* line 21, ../sass/ball.scss */
.ballPage .ballPage-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  grid-gap: 15px;
}
/* line 26, ../sass/ball.scss */
.ballPage .ballPage-col {
  display: grid;
  grid-template-rows: 1fr;
}
/* line 29, ../sass/ball.scss */
.ballPage .ballPage-col .colTitle {
  margin-bottom: 15px;
}
/* line 31, ../sass/ball.scss */
.ballPage .ballPage-col .colTitle h1 {
  font-size: 24px;
  line-height: 0.75;
}
/* line 36, ../sass/ball.scss */
.ballPage .ballPage-col .ballPage-colWrapper {
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  padding: 15px;
}
/* line 44, ../sass/ball.scss */
.ballPage .select-item {
  position: relative;
}
/* line 46, ../sass/ball.scss */
.ballPage .select-item label {
  color: #fff;
}
/* line 49, ../sass/ball.scss */
.ballPage .select-item select {
  background-color: #00aa44;
  border: unset;
  outline: unset;
  border-radius: 7px;
  font-size: 16px;
  padding: 3px 20px;
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  color: #fff;
}
/* line 63, ../sass/ball.scss */
.ballPage .select-item .select-itemInner {
  position: relative;
}
/* line 65, ../sass/ball.scss */
.ballPage .select-item .select-itemInner::after {
  content: "";
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0, -50%);
  width: 0.8em;
  height: 0.5em;
  background-color: #818181;
  clip-path: polygon(100% 0%, 0 0%, 50% 100%);
}
/* line 79, ../sass/ball.scss */
.ballPage .selectLeague .pic {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  height: 200px;
  border: 1px solid #d8d8d8;
  border-radius: 5px;
  padding: 20px;
  background-color: #fff;
}
/* line 88, ../sass/ball.scss */
.ballPage .selectLeague .pic img {
  object-fit: contain;
}
/* line 94, ../sass/ball.scss */
.ballPage .selectTeam .groupTeam {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-top: 15px;
  margin-bottom: 20px;
}
/* line 101, ../sass/ball.scss */
.ballPage .selectTeam .teamItem {
  text-align: center;
}
/* line 103, ../sass/ball.scss */
.ballPage .selectTeam .teamItem .pic {
  border: 1px solid #17f29b;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 20px;
}
/* line 108, ../sass/ball.scss */
.ballPage .selectTeam .teamItem .pic img {
  height: 110px;
  object-fit: contain;
}
/* line 112, ../sass/ball.scss */
.ballPage .selectTeam .teamItem .pic p {
  background: linear-gradient(90deg, #163432 0%, #225851 50%, #163432 100%);
  color: #fff;
  padding: 10px 0;
  font-size: 18px;
  margin-bottom: 15px;
}
/* line 120, ../sass/ball.scss */
.ballPage .selectTeam .teamItem h3 {
  color: #fff;
  margin-top: 10px;
  font-size: 12px;
}
/* line 126, ../sass/ball.scss */
.ballPage .selectTeam .teamItem:nth-child(2) .pic p {
  color: #fff;
  background: linear-gradient(90deg, #168032 0%, #22ec51 50%, #168032 100%);
}
/* line 132, ../sass/ball.scss */
.ballPage .selectTeam .graoup-startTime {
  text-align: center;
}
/* line 134, ../sass/ball.scss */
.ballPage .selectTeam .graoup-startTime p {
  color: #fff;
  font-size: 20px;
}
/* line 138, ../sass/ball.scss */
.ballPage .selectTeam .graoup-startTime .startTime {
  display: flex;
  justify-content: center;
  width: 100%;
}
/* line 142, ../sass/ball.scss */
.ballPage .selectTeam .graoup-startTime .startTime h4 {
  padding: 5px 10px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
/* line 152, ../sass/ball.scss */
.ballPage .calBall .btn-calBall {
  background-color: unset;
  border: unset;
  outline: unset;
  font-size: 16px;
  background-color: #00aa44;
  color: #fff;
  width: 100%;
  border-radius: 7px;
  padding: 4px 0;
  border: 2px solid #000;
}
/* line 162, ../sass/ball.scss */
.ballPage .calBall .groupTeam {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-top: 15px;
  margin-bottom: 20px;
}
/* line 169, ../sass/ball.scss */
.ballPage .calBall .teamItem {
  text-align: center;
}
/* line 171, ../sass/ball.scss */
.ballPage .calBall .teamItem .pic {
  border: 1px solid #17f29b;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 20px;
}
/* line 176, ../sass/ball.scss */
.ballPage .calBall .teamItem .pic img {
  height: 110px;
  object-fit: contain;
}
/* line 180, ../sass/ball.scss */
.ballPage .calBall .teamItem .pic p {
  background: linear-gradient(90deg, #163432 0%, #225851 50%, #163432 100%);
  color: #fff;
  padding: 10px 0;
  font-size: 18px;
  margin-bottom: 15px;
}
/* line 189, ../sass/ball.scss */
.ballPage .calBall .teamItem h3 {
  color: #fff;
  margin-top: 10px;
  font-size: 12px;
}
/* line 194, ../sass/ball.scss */
.ballPage .calBall .teamItem h1 {
  color: #fff;
  font-size: 65px;
}
/* line 199, ../sass/ball.scss */
.ballPage .calBall .teamItem:nth-child(2) .pic p {
  color: #fff;
  background: linear-gradient(90deg, #168032 0%, #22ec51 50%, #168032 100%);
}

@media only screen and (max-width: 1260px) {
  /* line 209, ../sass/ball.scss */
  .ballPage .ballPage-row {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (max-width: 960px) {
  /* line 214, ../sass/ball.scss */
  .ballPage .ballPage-row {
    grid-template-columns: 1fr;
  }

  /* line 217, ../sass/ball.scss */
  .ballPage .selectLeague .pic {
    height: 150px;
  }
  /* line 219, ../sass/ball.scss */
  .ballPage .selectLeague .pic img {
    max-height: 100%;
  }

  /* line 224, ../sass/ball.scss */
  .ballPage .calBall .teamItem .pic h1 {
    font-size: 70px;
    line-height: 1;
  }

  /* line 228, ../sass/ball.scss */
  .ballPage .selectTeam .teamItem .pic h3 {
    margin-top: 10px;
    font-size: 16px;
  }

  /* line 232, ../sass/ball.scss */
  .ballPage {
    margin-top: 10px;
  }
}
@media only screen and (max-width: 767px) {
  /* line 237, ../sass/ball.scss */
  .ballPage .ballPage_title h1 {
    font-size: 24px;
  }

  /* line 240, ../sass/ball.scss */
  .ballPage {
    padding-bottom: 80px;
  }

  /* line 243, ../sass/ball.scss */
  .ballPage .select-item select {
    font-size: 16px;
  }

  /* line 247, ../sass/ball.scss */
  .ballPage .selectTeam .teamItem p {
    font-size: 16px;
  }

  /* line 250, ../sass/ball.scss */
  .ballPage .selectTeam .teamItem .pic h3 {
    font-size: 12px;
  }

  /* line 253, ../sass/ball.scss */
  .ballPage .selectTeam .graoup-startTime p {
    font-size: 20px;
  }

  /* line 256, ../sass/ball.scss */
  .ballPage .selectTeam .graoup-startTime .startTime h4 {
    font-size: 18px;
  }

  /* line 259, ../sass/ball.scss */
  .ballPage .calBall .btn-calBall {
    font-size: 18px;
  }

  /* line 262, ../sass/ball.scss */
  .ballPage .calBall .teamItem p {
    font-size: 16px;
  }

  /* line 265, ../sass/ball.scss */
  .ballPage .calBall .teamItem .pic h3 {
    font-size: 14px;
  }

  /* line 268, ../sass/ball.scss */
  .ballPage .calBall .teamItem .pic h1 {
    font-size: 54px;
  }
}
.floating-btns{
  position: fixed;
  bottom: 40px;
  z-index: 1;
  right: 40px;
  color: white;
  border-radius: 10px;
  outline: none;
  border: none;
  display: flex;
  justify-content: space-between;
}
.floating-btns>a:hover{
  cursor: pointer;
}
.swal2-popup {
  background-size: 100% 100% !important;
  padding: 40px 0px !important;
  border-radius: 10px !important;
  background-color: #000000bd !important;
}
#swal2-title {
  color: #fff;
}
#swal2-content {
  color: #fff;
}

/*.swal2-confirm {*/
/*    background-color: #147e4f !important; !* Button background color *!*/

/*}*/

/*.swal2-confirm:hover {*/
/*    background-color: #0e5214 !important; !* Hover effect *!*/
/*}*/


body {
  background-position: left top;
  background-size: auto;
  background-repeat: repeat;
  background-attachment: scroll;
}

.box-goto-lobby {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: 100% 100%;
  padding: 10px;
  transition: 0.3s ease all;
  text-align: center;
  margin: auto;
}

.box-goto-lobby:hover{
  transform: scale(1.1);
}

.bg-custom-image{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.menu-lobby{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: cover;
  filter: drop-shadow(0px 0px 10px #00ff9c);
}

.room-box {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: 100% 100%;
  padding: 35px 10px 35px 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: 0.4s ease;
}
.room-box:hover{
  transform: scale(0.95);
}
.score-board{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: 100% 100%;

}
 .sec-formula_wrapper {
  border-width: 2px;
  border-style: solid;
  border-color: rgb(28, 223, 46);
  border-image: initial;
}

.box-winlose-percent {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: 100% 100%;
  padding: 30px;
}

.box-statistic {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: 100% 100%;
  padding: 4rem;
  filter: drop-shadow(2px 4px 6px black);
}

.chart-board {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: 100% 100%;
  padding: 80px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/css/main.login.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;AACb;;;;AAIA,+BAA+B;AAC/B;EACE,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;AACnC;;;AAGA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;;;;;;;;;;;;EAYE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gCAAgC;EAChC;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gCAAgC;EAChC;IACE,iBAAiB;EACnB;AACF;AACA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;AACA,iCAAiC;AACjC;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;AACX;AACA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA,kCAAkC;AAClC;EACE,uBAAuB;AACzB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;EACtB,yEAAyE;EACzE,sCAAsC;EACtC,kCAAkC;AACpC;AACA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA,kCAAkC;;AAElC,mCAAmC;AACnC;EACE,wBAAwB;AAC1B;AACA,mCAAmC;AACnC;AACA;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,mCAAmC;AACnC;;;EAGE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EAEE,8CAA8C;AAChD;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EAEE,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,cAAc;IACd,iBAAiB;EACnB;EACA,mCAAmC;EACnC;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,mCAAmC;EACnC;;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE,mCAAmC;EACnC;IACE,wBAAwB;EAC1B;;EAEA,mCAAmC;EACnC;IACE,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,gBAAgB;EAClB;AACF;AACA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;AACA,iCAAiC;AACjC;EACE,WAAW;AACb;AACA,iCAAiC;AACjC;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,WAAW;AACb;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,yBAAyB;EACzB,oCAAoC;AACtC;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;AACjB;AACA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,yDAA4C;EAC5C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA,iCAAiC;AACjC;EACE,qBAAqB;AACvB;AACA,iCAAiC;AACjC;EACE,qBAAqB;AACvB;AACA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,yDAA6C;EAC7C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA,iCAAiC;AACjC;EACE,uBAAuB;AACzB;AACA,iCAAiC;AACjC;EACE,uBAAuB;AACzB;AACA,iCAAiC;AACjC;;EAEE,YAAY;EACZ,YAAY;AACd;AACA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,kCAAkC;AAClC;EACE,aAAa;AACf;AACA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;AACA,kCAAkC;AAClC;EACE,+BAA+B;AACjC;AACA,kCAAkC;AAClC;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA,kCAAkC;AAClC;EACE,cAAc;AAChB;AACA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;AACA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;AACA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,eAAe;AACjB;AACA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;AACA,kCAAkC;AAClC;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA,kCAAkC;AAClC;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;AACb;AACA,kCAAkC;AAClC;EACE,cAAc;AAChB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yDAA0D;EAC1D,0BAA0B;EAC1B,iBAAiB;AACnB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;AACzB;AACA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA,kCAAkC;AAClC;EACE,cAAc;EACd,cAAc;AAChB;AACA,kCAAkC;AAClC;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA,kCAAkC;AAClC;EACE,uBAAuB;AACzB;AACA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,gBAAgB;EAChB,yDAA0D;EAC1D,0BAA0B;AAC5B;AACA,kCAAkC;AAClC;EACE,eAAe;AACjB;AACA,kCAAkC;AAClC;EACE,eAAe;AACjB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;AACzB;AACA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC;IACE,0BAA0B;EAC5B;;EAEA,kCAAkC;EAClC;IACE,gCAAgC;EAClC;AACF;AACA;EACE,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,iBAAiB;EACnB;EACA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,gCAAgC;EAClC;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,8BAA8B;EAChC;EACA,kCAAkC;EAClC;IACE,8BAA8B;EAChC;EACA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;AACF;AACA;EACE,kCAAkC;EAClC;IACE,OAAO;IACP,WAAW;EACb;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;;IAEE,+BAA+B;EACjC;;EAEA,kCAAkC;EAClC;IACE,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;;IAEE,YAAY;IACZ,YAAY;EACd;;EAEA,kCAAkC;EAClC;IACE,8BAA8B;EAChC;;EAEA,kCAAkC;EAClC;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA,kCAAkC;EAClC;IACE,yBAAyB;EAC3B;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;IACE,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,WAAW;EACb;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;IACE,QAAQ;IACR,WAAW;IACX,eAAe;EACjB;AACF;AACA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,yDAA+C;EAC/C,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,cAAc;AAChB;AACA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,cAAc;EAEd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA,kCAAkC;AAClC;EACE,uBAAuB;AACzB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA,kCAAkC;AAClC;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;AACA,kCAAkC;AAClC;EACE,UAAU;EAEV,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,yDAA+C;EAC/C,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA,kCAAkC;AAClC;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA,kCAAkC;AAClC;EACE,aAAa;AACf;AACA,kCAAkC;AAClC;;EAEE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;AACA,kCAAkC;AAClC;;EAEE,eAAe;EACf,WAAW;AACb;AACA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;AACA,kCAAkC;AAClC;EACE,WAAW;AACb;AACA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA,oCAAoC;AACpC;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,oCAAoC;AACpC;EACE,wBAAwB;AAC1B;AACA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA,qCAAqC;AACrC;EACE,uBAAuB;AACzB;AACA,qCAAqC;AACrC;EACE,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA,qCAAqC;AACrC;EACE,qBAAqB;AACvB;AACA,qCAAqC;AACrC;EACE,uBAAuB;AACzB;AACA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA,qCAAqC;AACrC;EACE,qBAAqB;AACvB;AACA,qCAAqC;AACrC;;EAEE,mBAAmB;AACrB;AACA,qCAAqC;AACrC;;EAEE,sDAAsD;AACxD;AACA,qCAAqC;AACrC;;EAEE,sDAAsD;AACxD;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;AAChC;AACA,qCAAqC;AACrC;EACE,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,mCAAmC;EACnC,uCAAuC;EACvC,kCAAkC;EAClC,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,aAAa;AACf;AACA,qCAAqC;AACrC;EACE,uBAAuB;AACzB;AACA,qCAAqC;AACrC;AACA;AACA,qCAAqC;AACrC;AACA;AACA,qCAAqC;AACrC;EACE,cAAc;AAChB;AACA,qCAAqC;AACrC;;EAEE,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,qEAAqE;EACrE,uBAAuB;AACzB;AACA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA,sCAAsC;AACtC;EACE,uBAAuB;AACzB;AACA,sCAAsC;AACtC;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA,sCAAsC;AACtC;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;AACd;AACA,sCAAsC;AACtC;EACE,cAAc;AAChB;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;AACd;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;AACd;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC;IACE,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;AACA;EACE,sCAAsC;EACtC;IACE,UAAU;EACZ;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;AACF;AACA;EACE,sCAAsC;EACtC;IACE,YAAY;EACd;AACF;AACA;EACE,sCAAsC;EACtC;IACE,qBAAqB;EACvB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;AACF;AACA;EACE,sCAAsC;EACtC;IACE,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,SAAS;EACX;;EAEA,sCAAsC;EACtC;IACE,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;AACA;EACE,sCAAsC;EACtC;IACE,eAAe;IACf,OAAO;EACT;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA,sCAAsC;EACtC;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA,sCAAsC;EACtC;IACE,UAAU;IACV,oBAAoB;EACtB;EACA,sCAAsC;EACtC;IACE,WAAW;IACX,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;EACxB;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,sCAAsC;EACtC;IACE,oBAAoB;EACtB;;EAEA,sCAAsC;EACtC;IACE,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;EACnB;AACF;AACA,oCAAoC;AACpC;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;AACA,qCAAqC;AACrC;EACE,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,eAAe;IACf,kBAAkB;EACpB;EACA,qCAAqC;EACrC;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;EACpB;EACA,qCAAqC;EACrC;IACE,eAAe;IACf,WAAW;EACb;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA,qCAAqC;EACrC;IACE,eAAe;IACf,cAAc;EAChB;EACA,qCAAqC;EACrC;IACE,WAAW;IACX,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;EAC7B;AACF;AACA,qCAAqC;AACrC;EACE,YAAY;AACd;AACA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;AACA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,qBAAqB;AACvB;AACA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC;IACE,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,YAAY;EACd;AACF;AACA;EACE,sCAAsC;EACtC;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,aAAa;IACb,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,UAAU;EACZ;AACF;AACA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,eAAe;AACjB;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,yDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,uBAAuB;AACzB;AACA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;AACA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,qCAAqC;AACvC;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,qCAAqC;AACvC;AACA,sCAAsC;AACtC;EACE,WAAW;EACX,eAAe;EACf,qCAAqC;AACvC;AACA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC;IACE,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,sCAAsC;EACtC;IACE,0BAA0B;EAC5B;;EAEA,sCAAsC;EACtC;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,gBAAgB;EAClB;AACF;AACA;EACE,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,2BAA2B;EAC7B;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,YAAY;EACd;AACF;AACA;EACE,sCAAsC;EACtC;IACE,gBAAgB;EAClB;;EAEA,sCAAsC;EACtC;;IAEE,WAAW;EACb;;EAEA,sCAAsC;EACtC;IACE,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,2BAA2B;EAC7B;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,gBAAgB;IAChB,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,YAAY;IACZ,WAAW;EACb;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,QAAQ;EACV;;EAEA,sCAAsC;EACtC;IACE,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA,mCAAmC;AACnC;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA,oCAAoC;AACpC;EACE,WAAW;EACX,eAAe;AACjB;AACA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,yDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA,oCAAoC;AACpC;EACE,uBAAuB;AACzB;AACA,oCAAoC;AACpC;EACE,aAAa;AACf;AACA,oCAAoC;AACpC;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;AACA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA,oCAAoC;AACpC;EACE,eAAe;EACf,kBAAkB;AACpB;AACA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,uDAAuD;AACzD;AACA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,+CAA+C;AACjD;AACA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,+CAA+C;EACjD;AACF;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;AACd;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,kCAAkC;EAClC,aAAa;AACf;AACA,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA,qCAAqC;AACrC;EACE,mBAAmB;AACrB;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,uCAAuC;EACvC,mCAAmC;EACnC,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;AACf;AACA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,qCAAqC;AACrC;EACE,aAAa;AACf;AACA,qCAAqC;AACrC;EACE,WAAW;AACb;AACA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,WAAW;AACb;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA,qCAAqC;AACrC;EACE,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,cAAc;AAChB;AACA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,eAAe;EACf,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,gBAAgB;AAClB;AACA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA,qCAAqC;AACrC;EACE,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAEhB,gBAAgB;AAClB;AACA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;AACd;AACA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC;IACE,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,kBAAkB;EACpB;AACF;AACA;EACE,qCAAqC;EACrC;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,aAAa;EACf;AACF;AACA;EACE,qCAAqC;EACrC;IACE,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,uCAAuC;IACvC,mCAAmC;EACrC;;EAEA,qCAAqC;EACrC;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,qCAAqC;EACrC;IACE,WAAW;IACX,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,wCAAwC;IACxC,oCAAoC;EACtC;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,YAAY;IACZ,WAAW;EACb;;EAEA,qCAAqC;EACrC;IACE,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,UAAU;EACZ;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA,qCAAqC;EACrC;IACE,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,UAAU;IACV,WAAW;EACb;;EAEA,qCAAqC;EACrC;IACE,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,cAAc;EAChB;AACF;AACA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;AACA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAElB,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,+BAA+B;AAC/B;EACE,eAAe;EACf,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB;AACA,+BAA+B;AAC/B;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;AAC9C;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,YAAY;AACd;AACA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,eAAe;EACf,YAAY;AACd;AACA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC;IACE,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,qCAAqC;EACvC;AACF;AACA;EACE,gCAAgC;EAChC;IACE,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,qCAAqC;EACvC;AACF;AACA;EACE,gCAAgC;EAChC;IACE,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,aAAa;EACf;;EAEA,gCAAgC;EAChC;IACE,kBAAkB;EACpB;;EAEA,gCAAgC;EAChC;IACE,kBAAkB;EACpB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,YAAY;EACd;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,YAAY;EACd;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;;AAEpB;AACA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;AACA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;AACA,gCAAgC;AAChC;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;AACA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,iBAAiB;AACnB;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;AACzB;AACA,gCAAgC;AAChC;EACE,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA,gCAAgC;AAChC;EACE,eAAe;AACjB;AACA,gCAAgC;AAChC;EACE,qBAAqB;AACvB;AACA,gCAAgC;AAChC;EACE,yDAAgD;EAChD,YAAY;EACZ,YAAY;AACd;AACA,gCAAgC;AAChC;EACE,yDAAmD;EACnD,YAAY;EACZ,YAAY;AACd;AACA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,iCAAiC;AACjC;EACE,WAAW;EACX,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,iCAAiC;AACjC;EACE,uBAAuB;AACzB;AACA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;AAEd;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2BAA2B;EAC3B,yDAA0D;EAC1D,0BAA0B;EAC1B,iBAAiB;AACnB;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;AACzB;AACA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;AACA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;AACA,iCAAiC;AACjC;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;AACA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA,iCAAiC;AACjC;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,iCAAiC;AACjC;EACE,cAAc;EACd,eAAe;AACjB;AACA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;AAChB;AACA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA,iCAAiC;AACjC;EACE,YAAY;EACZ,oCAAoC;EACpC,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;AACA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;AACA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;AACA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA,iCAAiC;AACjC;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,iCAAiC;AACjC;EACE,cAAc;EACd,eAAe;AACjB;AACA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;AAChB;AACA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA,iCAAiC;AACjC;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA,iCAAiC;AACjC;;;;;;;CAOC;AACD;EACE,iCAAiC;EACjC;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE,iCAAiC;EACjC;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,OAAO;EACT;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,OAAO;IACP,UAAU;IACV,8BAA8B;EAChC;;EAEA,iCAAiC;EACjC;IACE,0BAA0B;IAC1B,eAAe;IACf,WAAW;IACX,qBAAqB;EACvB;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;EAClB;AACF;AACA;EACE,iCAAiC;EACjC;IACE,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,QAAQ;IACR,WAAW;IACX,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;AAClB;AACA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;AACA,iCAAiC;AACjC;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;AACA,iCAAiC;AACjC;EACE,eAAe;AACjB;AACA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA,iCAAiC;AACjC;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,cAAc;EAChB;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,aAAa;EACf;AACF;AACA;EACE,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,aAAa;EACf;AACF;AACA;EACE,iCAAiC;EACjC;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,iCAAiC;EACjC;IACE,cAAc;EAChB;;EAEA,iCAAiC;EACjC;IACE,UAAU;IACV,WAAW;EACb;;EAEA,iCAAiC;EACjC;IACE,YAAY;EACd;AACF;AACA,qCAAqC;AACrC;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,eAAe;AACf,YAAY;AACZ,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,cAAc;AACd,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,aAAa;AACb,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,eAAe;AACf,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,YAAY;AACZ,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC;IACE,gBAAgB;EAClB;AACF;AACA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA,mCAAmC;AACnC;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;AACA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,mCAAmC;AACnC;EACE,eAAe;EACf,WAAW;AACb;AACA,mCAAmC;AACnC;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,UAAU;AACZ;AACA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,kDAAkD;EAClD,WAAW;AACb;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,0DAA0D;EAC1D,WAAW;AACb;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA,oCAAoC;AACpC;EACE,eAAe;EACf,WAAW;AACb;AACA,oCAAoC;AACpC;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC;IACE,sBAAsB;EACxB;AACF;AACA;EACE,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA,oCAAoC;EACpC;IACE,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,oCAAoC;EACpC;IACE,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,eAAe;EACjB;AACF;AACA,8BAA8B;AAC9B;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;AACf;AACA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,+BAA+B;AAC/B;EACE,eAAe;EACf,WAAW;AACb;AACA,+BAA+B;AAC/B;EACE,eAAe;EACf,WAAW;AACb;AACA,+BAA+B;AAC/B;EACE,aAAa;EACb,oCAAoC;EACpC,cAAc;AAChB;AACA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;AACzB;AACA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;AACA,+BAA+B;AAC/B;EACE,eAAe;EACf,iBAAiB;AACnB;AACA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;AACA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,WAAW;AACb;AACA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;AACb;AACA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,2CAA2C;AAC7C;AACA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;AACA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,yEAAyE;EACzE,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,yEAAyE;AAC3E;AACA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,eAAe;AACjB;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA,gCAAgC;AAChC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,yEAAyE;EACzE,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,eAAe;AACjB;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,gCAAgC;EAChC;IACE,8BAA8B;EAChC;AACF;AACA;EACE,gCAAgC;EAChC;IACE,0BAA0B;EAC5B;;EAEA,gCAAgC;EAChC;IACE,aAAa;EACf;EACA,gCAAgC;EAChC;IACE,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,cAAc;EAChB;;EAEA,gCAAgC;EAChC;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,oBAAoB;EACtB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB,0EAA0E;;AAE1E,IAAI;;AAEJ,yBAAyB;AACzB,+DAA+D;AAC/D,IAAI;;;AAGJ;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mDAA2C;EAC3C,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE,mDAAkD;EAClD,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,oDAA4D;EAC5D,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0DAAsD;EACtD,0BAA0B;;AAE5B;CACC;EACC,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,oDAA4C;EAC5C,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,oDAA4C;EAC5C,0BAA0B;EAC1B,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,oDAA4C;EAC5C,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/* line 8, ../sass/main.scss */\nbody {\n  font-family: \"Kanit-Regular\", sans-serif;\n}\n\n/* line 14, ../sass/main.scss */\n.bg-site {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: cover;\n  z-index: -2;\n}\n\n\n\n/* line 46, ../sass/main.scss */\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* line 49, ../sass/main.scss */\n::-webkit-scrollbar-thumb {\n  background: #03ff1c;\n}\n\n/* line 52, ../sass/main.scss */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px #03ff1c;\n}\n\n\n/* line 89, ../sass/main.scss */\np {\n  margin-bottom: 0;\n}\n\n/* line 92, ../sass/main.scss */\n.circle-p {\n  max-width: 60px;\n  max-height: 60px;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: center 0px;\n  background-size: contain;\n}\n\n/* line 102, ../sass/main.scss */\n.circle-b {\n  max-width: 60px;\n  max-height: 60px;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: center 0px;\n  background-size: contain;\n}\n\n/* line 112, ../sass/main.scss */\n.circle-t {\n  max-width: 60px;\n  max-height: 60px;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: center 0px;\n  background-size: contain;\n}\n\n/* line 123, ../sass/main.scss */\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 0;\n}\n\n/* line 137, ../sass/main.scss */\nimg {\n  max-width: 100%;\n}\n\n/* line 140, ../sass/main.scss */\n.pd-site {\n  padding-top: 100px;\n}\n\n@media only screen and (max-width: 1440px) {\n  /* line 144, ../sass/main.scss */\n  .pd-site {\n    padding-top: 80px;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  /* line 149, ../sass/main.scss */\n  .pd-site {\n    padding-top: 70px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 154, ../sass/main.scss */\n  .pd-site {\n    padding-top: 60px;\n  }\n}\n/* line 1, ../sass/_header.scss */\nheader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: #000;\n  z-index: 9;\n}\n/* line 8, ../sass/_header.scss */\nheader .wrapper {\n  max-width: 95%;\n  margin: 0 auto;\n  padding: 10px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n/* line 16, ../sass/_header.scss */\nheader .logo {\n  max-width: 170px;\n  margin-right: 20px;\n}\n/* line 19, ../sass/_header.scss */\nheader .logo img {\n  max-height: 100%;\n}\n/* line 23, ../sass/_header.scss */\nheader .menu {\n  display: flex;\n  position: relative;\n  min-width: fit-content;\n}\n/* line 27, ../sass/_header.scss */\nheader .menu .menu_wrapper {\n  display: flex;\n  gap: 10px;\n}\n/* line 31, ../sass/_header.scss */\nheader .menu .menu-item {\n  position: relative;\n  display: flex;\n  cursor: pointer;\n}\n/* line 35, ../sass/_header.scss */\nheader .menu .menu-item:hover {\n  filter: brightness(1.5);\n}\n/* line 39, ../sass/_header.scss */\nheader .menu .menu-item p {\n  color: #fff;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  padding: 5px 30px;\n}\n/* line 45, ../sass/_header.scss */\nheader .menu .menu-item p::before {\n  content: \"\";\n  width: 40px;\n  height: 40px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-right: 15px;\n}\n/* line 55, ../sass/_header.scss */\nheader .menu .menu-item::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  z-index: -1;\n  transform: scaleY(0.6);\n  background: linear-gradient(90deg, #3c6a35 0%, #5ea753 50%, #3c6a35 100%);\n  border-bottom-right-radius: 50px 100px;\n  border-top-left-radius: 50px 100px;\n}\n/* line 72, ../sass/_header.scss */\nheader .btn-back {\n  text-decoration: none;\n  margin-right: 10px;\n}\n/* line 76, ../sass/_header.scss */\n\n/* line 110, ../sass/_header.scss */\nheader .btn-home {\n  display: none !important;\n}\n/* line 113, ../sass/_header.scss */\nheader .btn-home p::before {\n}\n\n/* line 121, ../sass/_header.scss */\n.menu-icon {\n  display: none;\n  cursor: pointer;\n}\n\n/* line 127, ../sass/_header.scss */\n.bar1,\n.bar2,\n.bar3 {\n  width: 35px;\n  height: 5px;\n  background-color: #1cdf2e;\n  margin: 6px 0;\n  transition: 0.4s;\n}\n\n/* line 137, ../sass/_header.scss */\n.change .bar1 {\n  -webkit-transform: rotate(-45deg) translate(-9px, 6px);\n  transform: rotate(-45deg) translate(-9px, 6px);\n}\n\n/* line 142, ../sass/_header.scss */\n.change .bar2 {\n  opacity: 0;\n}\n\n/* line 146, ../sass/_header.scss */\n.change .bar3 {\n  -webkit-transform: rotate(45deg) translate(-8px, -8px);\n  transform: rotate(45deg) translate(-8px, -8px);\n}\n\n@media only screen and (max-width: 1200px) {\n  /* line 152, ../sass/_header.scss */\n  header .menu .menu_wrapper {\n    display: none;\n  }\n\n  /* line 155, ../sass/_header.scss */\n  .menu-icon {\n    display: block;\n    margin-left: 30px;\n  }\n\n  /* line 162, ../sass/_header.scss */\n  header .menu .menu_wrapper_active {\n    display: grid;\n    position: fixed;\n    align-items: center;\n    justify-content: center;\n    grid-template-rows: 55px 55px 55px 55px;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.9);\n    overflow: auto;\n    padding-top: 15vh;\n  }\n  /* line 175, ../sass/_header.scss */\n  header .menu .menu_wrapper_active .menu-item {\n    margin-left: 0 !important;\n    padding: 0px;\n  }\n\n  /* line 181, ../sass/_header.scss */\n  header .btn-home,\n  header .btn-contact {\n    display: flex !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 187, ../sass/_header.scss */\n  .btn-back {\n    display: none !important;\n  }\n\n  /* line 190, ../sass/_header.scss */\n  header .wrapper {\n    padding: 10px 15px;\n  }\n\n  /* line 193, ../sass/_header.scss */\n  header .logo {\n    max-width: 140px;\n  }\n}\n/* line 1, ../sass/_model.scss */\n.model-group {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  transition: 0.5s;\n  visibility: hidden;\n  opacity: 0;\n  z-index: 10;\n}\n/* line 15, ../sass/_model.scss */\n.model-group .overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  z-index: -1;\n}\n/* line 26, ../sass/_model.scss */\n.model-group .title h1 {\n  color: #fff;\n}\n/* line 29, ../sass/_model.scss */\n.model-group .title h3 {\n  font-family: \"Kanit-Light\";\n  color: #fff;\n}\n/* line 32, ../sass/_model.scss */\n.model-group .title h3 span {\n  margin-left: 20px;\n  color: #fff;\n}\n/* line 38, ../sass/_model.scss */\n.model-group .wrapper {\n  padding: 20px;\n  border: 1px solid #1cdf2e;\n  background-color: rgba(0, 0, 0, 0.8);\n}\n/* line 43, ../sass/_model.scss */\n.model-group .group-btn {\n  text-align: center;\n  position: absolute;\n  left: 0;\n  width: 100%;\n}\n/* line 49, ../sass/_model.scss */\n.model-group .btn-closeModel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 35px;\n  height: 35px;\n  margin-left: auto;\n  background-image: url('../images/close_bt.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: pointer;\n}\n/* line 62, ../sass/_model.scss */\n.model-group .btn-cancel {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  background-image: url('../images/no_bt.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: 0.3s;\n}\n/* line 69, ../sass/_model.scss */\n.model-group .btn-cancel:hover {\n  filter: brightness(2);\n}\n/* line 72, ../sass/_model.scss */\n.model-group .btn-cancel:active {\n  filter: brightness(2);\n}\n/* line 76, ../sass/_model.scss */\n.model-group .btn-confirm {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  background-image: url('../images/yes_bt.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: 0.3s;\n}\n/* line 83, ../sass/_model.scss */\n.model-group .btn-confirm:hover {\n  filter: brightness(1.3);\n}\n/* line 86, ../sass/_model.scss */\n.model-group .btn-confirm:active {\n  filter: brightness(1.3);\n}\n/* line 90, ../sass/_model.scss */\n.model-group .btn-cancel,\n.model-group .btn-confirm {\n  width: 200px;\n  height: 45px;\n}\n/* line 95, ../sass/_model.scss */\n.model-group .model-item {\n  width: calc(100vw - 35px);\n  max-width: 800px;\n  position: relative;\n  padding: 40px 0;\n}\n/* line 102, ../sass/_model.scss */\n.model-group .model-user {\n  display: none;\n}\n/* line 104, ../sass/_model.scss */\n.model-group .model-user .title {\n  text-align: center;\n}\n/* line 107, ../sass/_model.scss */\n.model-group .model-user .user-info {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  grid-gap: 15px 20px;\n}\n/* line 112, ../sass/_model.scss */\n.model-group .model-user .info-item {\n  display: grid;\n  grid-template-columns: 125px 1fr;\n  align-items: center;\n}\n/* line 116, ../sass/_model.scss */\n.model-group .model-user .info-item:nth-child(even) {\n  grid-template-columns: 80px 1fr;\n}\n/* line 119, ../sass/_model.scss */\n.model-group .model-user .info-item p {\n  font-family: \"Kanit-Light\";\n  font-size: 20px;\n}\n/* line 122, ../sass/_model.scss */\n.model-group .model-user .info-item p:nth-child(1) {\n  color: #f3f3f3;\n}\n/* line 125, ../sass/_model.scss */\n.model-group .model-user .info-item p:nth-child(2) {\n  padding: 3px 20px;\n  color: #1cdf2e;\n  border: 1px solid #1cdf2e;\n}\n/* line 132, ../sass/_model.scss */\n.model-group .model-user .wrapper_form {\n  border: 1px solid #1cdf2e;\n}\n/* line 133, ../sass/_model.scss */\n.model-group .model-user .wrapper_form .title-form {\n  background-color: #1cdf2e;\n  padding: 8px 20px;\n}\n/* line 136, ../sass/_model.scss */\n.model-group .model-user .wrapper_form .title-form p {\n  color: #fff;\n  font-size: 24px;\n}\n/* line 143, ../sass/_model.scss */\n.model-group .model-user .group-input {\n  padding: 20px 23px;\n}\n/* line 146, ../sass/_model.scss */\n.model-group .model-user .input-item {\n  display: grid;\n  grid-template-columns: 125px 1fr;\n  grid-gap: 10px;\n  margin-bottom: 10px;\n  align-items: center;\n}\n/* line 152, ../sass/_model.scss */\n.model-group .model-user .input-item:last-child {\n  margin-bottom: 0;\n}\n/* line 155, ../sass/_model.scss */\n.model-group .model-user .input-item label {\n  color: #f3f3f3;\n  font-family: \"Kanit-Light\";\n  font-size: 20px;\n  margin-bottom: 0;\n}\n/* line 161, ../sass/_model.scss */\n.model-group .model-user .input-item input {\n  font-size: 20px;\n  padding: 3px 20px;\n  font-family: \"Kanit-Light\";\n  width: 100%;\n}\n/* line 166, ../sass/_model.scss */\n.model-group .model-user .input-item input::placeholder {\n  color: #a3a3a3;\n}\n/* line 173, ../sass/_model.scss */\n.model-group .model-redeem {\n  display: none;\n  text-align: center;\n  max-width: 550px;\n  background-image: url('../images/frame_popup-desktop.png');\n  background-size: 100% 100%;\n  padding-top: 60px;\n}\n/* line 180, ../sass/_model.scss */\n.model-group .model-redeem .wrapper {\n  border: unset;\n  background-color: unset;\n}\n/* line 185, ../sass/_model.scss */\n.model-group .model-redeem .title h1 {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  color: #05f31c;\n  font-size: 24px;\n  transform: translateX(-50%);\n}\n/* line 194, ../sass/_model.scss */\n.model-group .model-redeem .btn-pastCredit {\n  display: block;\n  margin: 0 auto;\n}\n/* line 199, ../sass/_model.scss */\n.model-group .model-redeem form p {\n  font-family: \"Kanit-Light\";\n  color: #a3a3a3;\n}\n/* line 203, ../sass/_model.scss */\n.model-group .model-redeem form input {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  font-family: \"Kanit-Light\";\n  color: #f3f3f3;\n  text-align: center;\n  width: 85%;\n  font-size: 22px;\n  padding: 5px 25px;\n}\n/* line 213, ../sass/_model.scss */\n.model-group .model-redeem .btn-pastCredit {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  background-color: #1cdf2e;\n  padding: 5px 15px;\n  font-size: 20px;\n  border-radius: 5px;\n  color: #fff;\n}\n/* line 220, ../sass/_model.scss */\n.model-group .model-redeem .btn-pastCredit:active {\n  filter: brightness(1.3);\n}\n/* line 224, ../sass/_model.scss */\n.model-group .model-redeem .group-btn {\n  position: relative;\n}\n/* line 229, ../sass/_model.scss */\n.model-group .model-logout {\n  display: none;\n  max-width: 500px;\n  background-image: url('../images/frame_popup-desktop.png');\n  background-size: 100% 100%;\n}\n/* line 236, ../sass/_model.scss */\n.model-group .model-logout .title h1 {\n  font-size: 32px;\n}\n/* line 239, ../sass/_model.scss */\n.model-group .model-logout .title h3 {\n  font-size: 26px;\n}\n/* line 243, ../sass/_model.scss */\n.model-group .model-logout .wrapper {\n  border: unset;\n  background-color: unset;\n}\n/* line 247, ../sass/_model.scss */\n.model-group .model-logout .group-btn {\n  position: relative;\n}\n\n/* line 252, ../sass/_model.scss */\n.bg-input {\n  background-color: #2b2b2b !important;\n  border: 1px solid #474747 !important;\n  border-radius: 5px;\n}\n\n/* line 259, ../sass/_model.scss */\n.model-group.active {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* line 263, ../sass/_model.scss */\n.model-user_active {\n  display: block !important;\n}\n\n/* line 266, ../sass/_model.scss */\n.model-redeem_active {\n  display: block !important;\n}\n\n/* line 269, ../sass/_model.scss */\n.model-logout_active {\n  display: block !important;\n}\n\n@media only screen and (max-width: 900px) {\n  /* line 276, ../sass/_model.scss */\n  .model-group .model-user .user-info {\n    grid-template-columns: 1fr;\n  }\n\n  /* line 279, ../sass/_model.scss */\n  .model-group .model-user .info-item:nth-child(even) {\n    grid-template-columns: 125px 1fr;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 284, ../sass/_model.scss */\n  .model-group .title h1 {\n    font-size: 30px;\n  }\n\n  /* line 287, ../sass/_model.scss */\n  .model-group .model-user .user-info {\n    grid-gap: 10px 20px;\n  }\n\n  /* line 290, ../sass/_model.scss */\n  .model-group .model-user .input-item label {\n    font-size: 18px;\n  }\n\n  /* line 293, ../sass/_model.scss */\n  .model-group .model-user .input-item input {\n    font-size: 18px;\n    padding: 2px 15px;\n  }\n  /* line 296, ../sass/_model.scss */\n  .model-group .model-user .input-item input::placeholder {\n    font-size: 14px;\n  }\n\n  /* line 300, ../sass/_model.scss */\n  .model-group .model-user .input-item {\n    grid-template-columns: 110px 1fr;\n  }\n\n  /* line 304, ../sass/_model.scss */\n  .model-group .title h3 {\n    font-size: 24px;\n  }\n\n  /* line 308, ../sass/_model.scss */\n  .model-redeem .title {\n    margin-bottom: 10px !important;\n  }\n  /* line 310, ../sass/_model.scss */\n  .model-redeem .title h1 {\n    margin-bottom: 10px !important;\n  }\n  /* line 313, ../sass/_model.scss */\n  .model-redeem .title h3 {\n    font-size: 24px;\n  }\n\n  /* line 318, ../sass/_model.scss */\n  .model-group .model-redeem form input {\n    font-size: 26px;\n    padding: 3px 20px;\n  }\n\n  /* line 322, ../sass/_model.scss */\n  .model-group .model-redeem .btn-pastCredit {\n    font-size: 16px;\n  }\n}\n@media only screen and (max-width: 550px) {\n  /* line 329, ../sass/_model.scss */\n  .model-group .group-btn {\n    left: 0;\n    width: 100%;\n  }\n\n  /* line 334, ../sass/_model.scss */\n  .model-group .title h1 {\n    font-size: 26px;\n  }\n\n  /* line 337, ../sass/_model.scss */\n  .model-group .model-user .info-item p {\n    font-size: 14px;\n  }\n\n  /* line 340, ../sass/_model.scss */\n  .model-group .model-user .info-item:nth-child(even),\n  .model-group .model-user .info-item {\n    grid-template-columns: 85px 1fr;\n  }\n\n  /* line 344, ../sass/_model.scss */\n  .model-group .model-user .user-info {\n    grid-gap: 5px 20px;\n  }\n\n  /* line 347, ../sass/_model.scss */\n  .model-group .model-user .wrapper_form .title-form p {\n    font-size: 18px;\n  }\n\n  /* line 350, ../sass/_model.scss */\n  .model-group .model-user .input-item label {\n    font-size: 14px;\n  }\n\n  /* line 353, ../sass/_model.scss */\n  .model-group .model-user .input-item input {\n    font-size: 18px;\n  }\n\n  /* line 356, ../sass/_model.scss */\n  .model-group .model-user .input-item {\n    grid-template-columns: 1fr;\n    grid-gap: 0px;\n    margin-bottom: 5px;\n  }\n\n  /* line 361, ../sass/_model.scss */\n  .model-group .model-user .group-input {\n    padding: 10px 15px;\n  }\n\n  /* line 364, ../sass/_model.scss */\n  .model-group .btn-cancel,\n  .model-group .btn-confirm {\n    width: 155px;\n    height: 35px;\n  }\n\n  /* line 370, ../sass/_model.scss */\n  .model-group .model-user .title {\n    margin-bottom: 15px !important;\n  }\n\n  /* line 373, ../sass/_model.scss */\n  .model-group .group-btn {\n    text-align: center;\n    margin-top: 25px !important;\n  }\n\n  /* line 377, ../sass/_model.scss */\n  .model-group .model-item {\n    width: calc(100vw - 15px);\n  }\n\n  /* line 380, ../sass/_model.scss */\n  .model-group .model-user .wrapper_form .title-form {\n    padding: 5px 14px;\n  }\n\n  /* line 384, ../sass/_model.scss */\n  .model-group .model-redeem {\n    max-width: 360px;\n  }\n\n  /* line 387, ../sass/_model.scss */\n  .model-redeem .title h3 {\n    font-size: 16px;\n  }\n\n  /* line 390, ../sass/_model.scss */\n  .model-group .model-redeem form input {\n    width: 100%;\n    max-width: 270px;\n    font-size: 20px;\n  }\n\n  /* line 395, ../sass/_model.scss */\n  .model-group .wrapper {\n    padding: 25px 15px;\n  }\n\n  /* line 398, ../sass/_model.scss */\n  .model-group .model-redeem .title h1 {\n    right: 88px;\n  }\n\n  /* line 403, ../sass/_model.scss */\n  .model-group .model-logout .title h3 {\n    font-size: 20px;\n  }\n\n  /* line 406, ../sass/_model.scss */\n  .model-group .model-logout {\n    max-width: 360px;\n  }\n\n  /* line 409, ../sass/_model.scss */\n  .model-group .model-logout .miniTxt {\n    top: 7px;\n    right: 73px;\n    font-size: 17px;\n  }\n}\n/* line 418, ../sass/_model.scss */\n.model-Link {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  visibility: hidden;\n  padding: 0 10px;\n  z-index: 100;\n}\n/* line 429, ../sass/_model.scss */\n.model-Link .overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  opacity: 1;\n}\n/* line 438, ../sass/_model.scss */\n.model-Link .Link_wrapper {\n  display: none;\n  border: 1px solid #1cdf2e;\n  background-color: black;\n  z-index: 2;\n  padding: 50px 20px;\n  position: relative;\n}\n/* line 446, ../sass/_model.scss */\n.model-Link .btnClose-modelslotPage {\n  cursor: pointer;\n  border: unset;\n  outline: unset;\n  background: unset;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(0%, -125%);\n  width: 30px;\n  height: 30px;\n  background-image: url('../images/close_bt.png');\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n/* line 462, ../sass/_model.scss */\n.model-Link .txtTtitle {\n  text-align: center;\n  font-size: 30px;\n  color: #fff;\n  margin-bottom: 20px;\n}\n/* line 468, ../sass/_model.scss */\n.model-Link .gorupLink {\n  display: flex;\n  grid-gap: 15px;\n}\n/* line 472, ../sass/_model.scss */\n.model-Link .link-item {\n  text-decoration: none;\n  cursor: pointer;\n  width: 175px;\n  height: 45px;\n  display: grid;\n  place-content: center;\n  color: #8b8b8b;\n  border-radius: 10px;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  border-radius: 7px;\n  border: 1px solid #8b8b8b;\n}\n/* line 486, ../sass/_model.scss */\n.model-Link .link-item:hover {\n  filter: brightness(1.5);\n}\n/* line 489, ../sass/_model.scss */\n.model-Link .link-item .icoLink {\n  width: 20px;\n  height: 20px;\n  background-size: 100% 100%;\n  margin-right: 10px;\n}\n/* line 496, ../sass/_model.scss */\n.model-Link .link-item .icoUnLink {\n  width: 20px;\n  height: 20px;\n  background-size: 100% 100%;\n  margin-right: 10px;\n}\n/* line 508, ../sass/_model.scss */\n.model-Link .call-codeLinkModel {\n  background-color: #1cdf2e;\n  border: 1px solid #1cdf2e;\n  color: #000;\n}\n/* line 513, ../sass/_model.scss */\n.model-Link .Link_wrapper.active {\n  display: block;\n}\n\n/* line 517, ../sass/_model.scss */\n.model-Link.active {\n  visibility: visible;\n}\n\n/* line 520, ../sass/_model.scss */\n.model-codeLink {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  visibility: hidden;\n  padding: 0 10px;\n  z-index: 100;\n}\n/* line 531, ../sass/_model.scss */\n.model-codeLink .overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  opacity: 1;\n}\n/* line 540, ../sass/_model.scss */\n.model-codeLink .codeLink_wrapper {\n  z-index: 2;\n  position: relative;\n  border: 1px solid #1cdf2e;\n  background-color: black;\n  padding: 20px;\n  position: relative;\n}\n/* line 548, ../sass/_model.scss */\n.model-codeLink .btnClose-modelslotPage {\n  cursor: pointer;\n  border: unset;\n  outline: unset;\n  background: unset;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(0%, -125%);\n  width: 30px;\n  height: 30px;\n  background-image: url('../images/close_bt.png');\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n/* line 564, ../sass/_model.scss */\n.model-codeLink .txtTtitle {\n  text-align: center;\n  font-size: 30px;\n  color: #fff;\n  margin-bottom: 20px;\n}\n/* line 571, ../sass/_model.scss */\n.model-codeLink .groupIp input {\n  border: unset;\n  width: 310px;\n  background-color: #333333;\n  outline: unset;\n  padding: 3px 10px;\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  margin-bottom: 20px;\n}\n/* line 583, ../sass/_model.scss */\n.model-codeLink .groupBtn {\n  display: flex;\n}\n/* line 586, ../sass/_model.scss */\n.model-codeLink .btnNo,\n.model-codeLink .btnYes {\n  text-decoration: none;\n  cursor: pointer;\n  width: 120px;\n  height: 40px;\n  margin: 0 auto;\n  border-radius: 7px;\n  display: grid;\n  place-content: center;\n}\n/* line 596, ../sass/_model.scss */\n.model-codeLink .btnNo p,\n.model-codeLink .btnYes p {\n  font-size: 20px;\n  color: #000;\n}\n/* line 601, ../sass/_model.scss */\n.model-codeLink .btnNo {\n  border: 1px solid #1cdf2e;\n}\n/* line 603, ../sass/_model.scss */\n.model-codeLink .btnNo p {\n  color: #fff;\n}\n/* line 607, ../sass/_model.scss */\n.model-codeLink .btnYes {\n  background-color: #1cdf2e;\n  border: 1px solid #1cdf2e;\n}\n\n/* line 612, ../sass/_model.scss */\n.model-codeLink.active {\n  visibility: visible;\n}\n\n@media only screen and (max-width: 460px) {\n  /* line 616, ../sass/_model.scss */\n  .model-Link .gorupLink {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n/* line 1, ../sass/selectGame.scss */\n.sec-slectGame {\n  width: 90%;\n  max-width: 1540px;\n  margin: 0 auto;\n  padding: 50px 3% 30px;\n  position: relative;\n  margin-top: 50px;\n}\n/* line 8, ../sass/selectGame.scss */\n.sec-slectGame .owl-carousel .owl-nav.disabled {\n  display: flex !important;\n}\n/* line 11, ../sass/selectGame.scss */\n.sec-slectGame .owl-carousel .owl-dots.disabled {\n  display: block !important;\n}\n/* line 14, ../sass/selectGame.scss */\n.sec-slectGame .owl-item {\n  transform: scale(0.85);\n  transition: 0.3s;\n}\n/* line 19, ../sass/selectGame.scss */\n.sec-slectGame .owl-item:hover .item .gameName {\n  visibility: visible;\n  opacity: 1;\n}\n/* line 23, ../sass/selectGame.scss */\n.sec-slectGame .owl-item:hover img {\n  filter: brightness(1.2);\n}\n/* line 28, ../sass/selectGame.scss */\n.sec-slectGame .owl-carousel .owl-stage-outer {\n  padding: 20px 0;\n}\n/* line 32, ../sass/selectGame.scss */\n.sec-slectGame .title-slide {\n  position: absolute;\n  top: -4%;\n  left: 0;\n  width: 100%;\n  text-align: center;\n  color: #fff;\n}\n/* line 40, ../sass/selectGame.scss */\n.sec-slectGame .item {\n  text-decoration: none;\n}\n/* line 42, ../sass/selectGame.scss */\n.sec-slectGame .item img {\n  filter: brightness(0.7);\n}\n/* line 46, ../sass/selectGame.scss */\n.sec-slectGame .item:hover .gameName {\n  visibility: visible;\n  opacity: 1;\n}\n/* line 50, ../sass/selectGame.scss */\n.sec-slectGame .item:hover img {\n  filter: brightness(1);\n}\n/* line 57, ../sass/selectGame.scss */\n.sec-slectGame .slide-2 .center,\n.sec-slectGame .slide-1 .center {\n  transform: scale(1);\n}\n/* line 59, ../sass/selectGame.scss */\n.sec-slectGame .slide-2 .center img,\n.sec-slectGame .slide-1 .center img {\n  filter: brightness(1) drop-shadow(0px 0px 7px #a8906f);\n}\n/* line 61, ../sass/selectGame.scss */\n.sec-slectGame .slide-2 .center img:hover,\n.sec-slectGame .slide-1 .center img:hover {\n  filter: brightness(1) drop-shadow(0px 0px 7px #a8906f);\n}\n/* line 68, ../sass/selectGame.scss */\n.sec-slectGame .owl-nav {\n  display: flex;\n  justify-content: space-between;\n}\n/* line 72, ../sass/selectGame.scss */\n.sec-slectGame .owl-nav button {\n  width: 140px;\n  height: 40px;\n  background-position: center !important;\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-color: unset !important;\n  outline: unset !important;\n}\n/* line 80, ../sass/selectGame.scss */\n.sec-slectGame .owl-nav button span {\n  display: none;\n}\n/* line 83, ../sass/selectGame.scss */\n.sec-slectGame .owl-nav button:active {\n  filter: brightness(1.2);\n}\n/* line 87, ../sass/selectGame.scss */\n.sec-slectGame .owl-nav .owl-prev {\n}\n/* line 90, ../sass/selectGame.scss */\n.sec-slectGame .owl-nav .owl-next {\n}\n/* line 94, ../sass/selectGame.scss */\n.sec-slectGame .owl-theme .owl-dots .owl-dot {\n  outline: unset;\n}\n/* line 97, ../sass/selectGame.scss */\n.sec-slectGame .owl-theme .owl-dots .owl-dot.active span,\n.sec-slectGame .owl-theme .owl-dots .owl-dot:hover span {\n  background: #03ff1c;\n}\n/* line 102, ../sass/selectGame.scss */\n.sec-slectGame .slectSlot_wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 95%;\n  margin: 0 auto;\n  max-height: 30vw;\n  overflow: auto;\n}\n/* line 111, ../sass/selectGame.scss */\n.sec-slectGame .slectSlot-item {\n  text-align: center;\n  text-decoration: none;\n  width: 19%;\n  margin: 10px 0.5%;\n  transform: scale(0.95);\n  transition: 0.3s;\n}\n/* line 118, ../sass/selectGame.scss */\n.sec-slectGame .slectSlot-item:hover {\n  transform: scale(1);\n}\n/* line 121, ../sass/selectGame.scss */\n.sec-slectGame .slectSlot-item p {\n  margin-top: 10px;\n  font-size: 20px;\n  color: #f3f3f3;\n  letter-spacing: 4px;\n}\n\n/* line 129, ../sass/selectGame.scss */\n.sec-navGame {\n  margin-top: 20px;\n}\n/* line 131, ../sass/selectGame.scss */\n.sec-navGame #myTab {\n  background: linear-gradient(90deg, black 0%, #3d7135 50%, black 100%);\n  justify-content: center;\n}\n/* line 135, ../sass/selectGame.scss */\n.sec-navGame .nav-item {\n  transition: 0.3s;\n  z-index: 1;\n}\n/* line 138, ../sass/selectGame.scss */\n.sec-navGame .nav-item:hover {\n  filter: brightness(1.5);\n}\n/* line 141, ../sass/selectGame.scss */\n.sec-navGame .nav-item a {\n  width: 200px;\n  display: flex;\n  justify-content: center;\n}\n/* line 146, ../sass/selectGame.scss */\n.sec-navGame .nav-item p {\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  color: #fff;\n}\n/* line 151, ../sass/selectGame.scss */\n.sec-navGame .nav-item p::before {\n  content: '';\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin-right: 10px;\n}\n/* line 159, ../sass/selectGame.scss */\n.sec-navGame .nav-item .active {\n  position: relative;\n}\n/* line 161, ../sass/selectGame.scss */\n.sec-navGame .nav-item .active::before {\n  content: '';\n  background-color: #007a31;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n/* line 175, ../sass/selectGame.scss */\n.sec-navGame .nav-item:nth-child(1) p::before {\n  width: 35px;\n  height: 35px;\n}\n/* line 182, ../sass/selectGame.scss */\n.sec-navGame .nav-item:nth-child(2) {\n  margin: 0 10px;\n}\n/* line 185, ../sass/selectGame.scss */\n.sec-navGame .nav-item:nth-child(2) p::before {\n  width: 50px;\n  height: 35px;\n}\n/* line 194, ../sass/selectGame.scss */\n.sec-navGame .nav-item:nth-child(3) p::before {\n  width: 35px;\n  height: 35px;\n}\n/* line 203, ../sass/selectGame.scss */\n.sec-navGame .nav-item:nth-child(4) p::before {\n  width: 35px;\n  height: 35px;\n}\n\n@media only screen and (max-width: 1440px) {\n  /* line 215, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item p {\n    margin-top: 5px;\n    font-size: 16px;\n    color: #f3f3f3;\n    letter-spacing: 2px;\n  }\n\n  /* line 221, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot_wrapper {\n    width: 95%;\n    max-height: 38vw;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  /* line 227, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item {\n    width: 45%;\n  }\n\n  /* line 230, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot_wrapper {\n    max-height: 485px;\n  }\n\n  /* line 233, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item p {\n    font-size: 20px;\n  }\n}\n@media only screen and (max-width: 1023px) {\n  /* line 238, ../sass/selectGame.scss */\n  .sec-navGame .nav-item a {\n    width: 160px;\n  }\n}\n@media only screen and (max-width: 900px) {\n  /* line 244, ../sass/selectGame.scss */\n  .sec-slectGame {\n    padding: 55px 3% 35px;\n  }\n\n  /* line 247, ../sass/selectGame.scss */\n  .sec-slectGame .item .gameName {\n    font-size: 16px;\n  }\n\n  /* line 250, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item {\n    margin: 10px 1%;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 255, ../sass/selectGame.scss */\n  .sec-navGame .nav-item a {\n    width: 110px;\n  }\n\n  /* line 258, ../sass/selectGame.scss */\n  .sec-navGame .nav-item p {\n    font-size: 18px;\n  }\n\n  /* line 261, ../sass/selectGame.scss */\n  .sec-navGame .nav-item:nth-child(1) p::before {\n    width: 25px;\n    height: 25px;\n  }\n\n  /* line 265, ../sass/selectGame.scss */\n  .sec-navGame .nav-item:nth-child(2) p::before {\n    width: 35px;\n    height: 25px;\n  }\n\n  /* line 269, ../sass/selectGame.scss */\n  .sec-navGame .nav-item:nth-child(3) p::before {\n    width: 25px;\n    height: 25px;\n  }\n\n  /* line 273, ../sass/selectGame.scss */\n  .sec-navGame .nav-item:nth-child(4) p::before {\n    width: 25px;\n    height: 25px;\n  }\n\n  /* line 278, ../sass/selectGame.scss */\n  .sec-slectGame .title-slide {\n    top: -10%;\n  }\n\n  /* line 281, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item p {\n    font-size: 2vw;\n  }\n\n  /* line 286, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item {\n    transform: scale(1);\n    filter: brightness(1);\n  }\n}\n@media only screen and (max-width: 460px) {\n  /* line 293, ../sass/selectGame.scss */\n  .sec-slectGame .title-slide {\n    font-size: 30px;\n    top: 0%;\n  }\n\n  /* line 297, ../sass/selectGame.scss */\n  .sec-slectGame .item .gameName {\n    font-size: 18px;\n    margin-bottom: 0px;\n  }\n\n  /* line 301, ../sass/selectGame.scss */\n  .sec-slectGame .owl-nav button {\n    width: 70px;\n    height: 25px;\n  }\n\n  /* line 305, ../sass/selectGame.scss */\n  .sec-slectGame {\n    width: 100%;\n    margin-top: 30px;\n    position: absolute;\n    top: 47%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  /* line 313, ../sass/selectGame.scss */\n  .sec-navGame {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 18vw;\n    overflow: hidden;\n    border-top: 1px solid #03ff1c;\n    border-bottom: 1px solid #03ff1c;\n  }\n\n  /* line 323, ../sass/selectGame.scss */\n  .sec-navGame #myTab {\n    height: 100%;\n    background-color: #000;\n  }\n\n  /* line 327, ../sass/selectGame.scss */\n  .sec-navGame .nav-item {\n    width: 25%;\n    margin: 0 !important;\n  }\n  /* line 330, ../sass/selectGame.scss */\n  .sec-navGame .nav-item a {\n    width: 100%;\n    height: 18.2vw;\n  }\n\n  /* line 335, ../sass/selectGame.scss */\n  .sec-navGame .nav-item p {\n    flex-direction: column;\n  }\n\n  /* line 338, ../sass/selectGame.scss */\n  .sec-navGame .nav-item p::before {\n    margin-right: 0px;\n  }\n\n  /* line 341, ../sass/selectGame.scss */\n  .sec-slectGame .owl-theme .owl-dots .owl-dot span {\n    width: 7px;\n    height: 7px;\n    margin: 5px 4px;\n  }\n\n  /* line 347, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot_wrapper {\n    width: 100%;\n    max-height: 60vh;\n  }\n\n  /* line 351, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item {\n    margin: 5px 2% 5px 0;\n  }\n\n  /* line 354, ../sass/selectGame.scss */\n  .sec-slectGame .slectSlot-item p {\n    font-size: 4vw;\n  }\n\n  /* line 357, ../sass/selectGame.scss */\n  .sec-navGame #myTab {\n    flex-wrap: nowrap;\n  }\n}\n/* line 1, ../sass/selectRoom.scss */\n.selectRoom-container {\n  display: flex;\n  width: 95%;\n  max-width: 1760px;\n  margin: 0 auto;\n  padding: 30px 0;\n}\n\n/* line 8, ../sass/selectRoom.scss */\n.btn-back-mobile {\n  display: none;\n  text-decoration: none !important;\n  transition: 0.3s;\n}\n/* line 12, ../sass/selectRoom.scss */\n.btn-back-mobile:hover {\n  filter: brightness(1.5);\n}\n\n/* line 16, ../sass/selectRoom.scss */\n.btn-formulaDD {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  /* line 20, ../sass/selectRoom.scss */\n  .selectRoom-container {\n    display: block;\n    padding-top: 10px;\n  }\n\n  /* line 24, ../sass/selectRoom.scss */\n  .btn-back-mobile {\n    display: flex;\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.8);\n    padding: 0 10px;\n    width: fit-content;\n  }\n  /* line 30, ../sass/selectRoom.scss */\n  .btn-back-mobile::before {\n    content: \"\";\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin-right: 10px;\n  }\n  /* line 40, ../sass/selectRoom.scss */\n  .btn-back-mobile p {\n    font-size: 12px;\n    color: #fff;\n  }\n\n  /* line 45, ../sass/selectRoom.scss */\n  .btn-formulaDD {\n    display: flex;\n    align-items: center;\n    background-color: #383838;\n    border: 1px solid #1cdf2e;\n    padding: 0 10px;\n    padding-right: 30px;\n    position: relative;\n    cursor: pointer;\n  }\n  /* line 54, ../sass/selectRoom.scss */\n  .btn-formulaDD p {\n    font-size: 12px;\n    color: #a3a3a3;\n  }\n  /* line 57, ../sass/selectRoom.scss */\n  .btn-formulaDD p::after {\n    content: \"\";\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    width: 13px;\n    height: 13px;\n    filter: brightness(2);\n    transform: translateY(-40%);\n  }\n}\n/* line 75, ../sass/selectRoom.scss */\n.sec-formula {\n  width: 300px;\n}\n/* line 77, ../sass/selectRoom.scss */\n.sec-formula .sec-formula_wrapper {\n  border: 2px solid #1cdf2e;\n}\n/* line 81, ../sass/selectRoom.scss */\n.sec-formula .formula-title {\n  background-color: rgba(0, 0, 0, 0.5);\n  text-align: center;\n  padding: 15px 0 0px;\n}\n/* line 85, ../sass/selectRoom.scss */\n.sec-formula .formula-title h1 {\n  font-family: \"Kanit-Light\";\n  color: #fff;\n  font-size: 26px;\n}\n/* line 91, ../sass/selectRoom.scss */\n.sec-formula .formula-group {\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px 15px;\n}\n/* line 95, ../sass/selectRoom.scss */\n.sec-formula .formula-item {\n  text-align: center;\n  position: relative;\n  cursor: pointer;\n  background-color: #00aa44;\n  margin-bottom: 5px;\n}\n/* line 101, ../sass/selectRoom.scss */\n.sec-formula .formula-item p {\n  padding: 18px 0;\n  color: #000;\n  font-size: 18px;\n  transition: 0.3s;\n}\n/* line 107, ../sass/selectRoom.scss */\n.sec-formula .formula-item:hover {\n  filter: brightness(2);\n}\n/* line 111, ../sass/selectRoom.scss */\n.sec-formula .formula-item_active {\n  background-color: #1cdf2e;\n}\n\n@media only screen and (max-width: 1024px) {\n  /* line 116, ../sass/selectRoom.scss */\n  .sec-formula .formula-title {\n    padding: 5px 0 10px;\n  }\n\n  /* line 119, ../sass/selectRoom.scss */\n  .sec-formula .formula-title h1 {\n    font-size: 20px;\n  }\n\n  /* line 122, ../sass/selectRoom.scss */\n  .sec-formula .formula-item p {\n    padding: 10px 0;\n    font-size: 15px;\n  }\n\n  /* line 126, ../sass/selectRoom.scss */\n  .sec-formula {\n    width: 275px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 131, ../sass/selectRoom.scss */\n  .sec-formula {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px;\n  }\n\n  /* line 137, ../sass/selectRoom.scss */\n  .sec-formula .sec-formula_wrapper {\n    display: flex;\n    border: unset;\n    padding: 5px;\n    background-color: rgba(0, 0, 0, 0.8);\n    position: relative;\n  }\n\n  /* line 144, ../sass/selectRoom.scss */\n  .sec-formula .formula-title {\n    background-color: unset;\n    text-align: center;\n    padding: 5px 10px;\n    display: flex;\n  }\n\n  /* line 150, ../sass/selectRoom.scss */\n  .sec-formula .formula-title h1 {\n    font-size: 12px;\n  }\n\n  /* line 153, ../sass/selectRoom.scss */\n  .sec-formula .formula-group {\n    display: none;\n  }\n\n  /* line 156, ../sass/selectRoom.scss */\n  .sec-formula .formula-item p {\n    font-size: 12px;\n  }\n\n  /* line 159, ../sass/selectRoom.scss */\n  .sec-formula .formula-group_active {\n    background-color: black;\n    display: block;\n    position: absolute;\n    top: 31px;\n    width: 62%;\n    right: -5px;\n    z-index: 3;\n  }\n}\n/* line 172, ../sass/selectRoom.scss */\n.sec-selectRoom {\n  border: 2px solid #1cdf2e;\n  background-color: rgba(0, 0, 0, 0.5);\n  margin-left: 20px;\n  width: 100%;\n  position: relative;\n}\n/* line 178, ../sass/selectRoom.scss */\n.sec-selectRoom .title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n}\n/* line 183, ../sass/selectRoom.scss */\n.sec-selectRoom .title h1 {\n  color: #fff;\n  font-size: 26px;\n}\n/* line 187, ../sass/selectRoom.scss */\n.sec-selectRoom .title .btn-close {\n  width: 30px;\n  height: 30px;\n  background-image: url('../images/close_bt.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: 0.3s;\n}\n/* line 195, ../sass/selectRoom.scss */\n.sec-selectRoom .title .btn-close:hover {\n  filter: brightness(1.5);\n}\n/* line 200, ../sass/selectRoom.scss */\n.sec-selectRoom .title-group {\n  overflow: hidden;\n}\n/* line 202, ../sass/selectRoom.scss */\n.sec-selectRoom .title-group p {\n  color: #fff;\n  font-size: 24px;\n  padding: 5px 30px;\n  position: relative;\n  z-index: 2;\n  width: fit-content;\n}\n/* line 211, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group {\n  margin-bottom: 10px;\n}\n/* line 213, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .inner_wrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 10px 15px;\n  padding: 20px;\n}\n/* line 219, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem {\n  position: relative;\n  overflow: hidden;\n  text-decoration: none;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  display: grid;\n  grid-template-columns: 170px 1fr 170px;\n  align-items: center;\n  height: 95px;\n  padding: 20px 50px;\n  transition: 0.3s;\n}\n/* line 232, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem .logoRoom {\n  height: 45px;\n  width: 120px;\n  margin-left: 20px;\n  display: flex;\n  align-items: center;\n}\n/* line 238, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem .logoRoom img {\n  max-height: 100%;\n  filter: drop-shadow(0px 0px 2px #000);\n}\n/* line 243, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem .roomNum {\n  color: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n/* line 249, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem .roomNum p {\n  font-weight: bold;\n  font-size: 20px;\n}\n/* line 254, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem .winrate {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n/* line 260, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem .winrate p:nth-child(1) {\n  color: #fff;\n  font-size: 16px;\n  line-height: 1;\n  filter: drop-shadow(0px 0px 2px #000);\n}\n/* line 266, ../sass/selectRoom.scss */\n.sec-selectRoom .Room_group .roomItem .winrate p:nth-child(2) {\n  color: #fff;\n  font-size: 36px;\n  filter: drop-shadow(0px 0px 2px #000);\n}\n/* line 275, ../sass/selectRoom.scss */\n.sec-selectRoom .scrollBar {\n  max-height: 640px;\n  overflow: auto;\n  padding-right: 15px;\n}\n/* line 279, ../sass/selectRoom.scss */\n.sec-selectRoom .scrollBar::-webkit-scrollbar {\n  width: 7px;\n}\n\n@media only screen and (max-width: 1599px) {\n  /* line 286, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem {\n    grid-template-columns: 130px 1fr 130px;\n    padding: 20px 40px;\n  }\n\n  /* line 290, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .roomNum p {\n    font-size: 16px;\n  }\n\n  /* line 293, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(2) {\n    font-size: 32px;\n  }\n\n  /* line 296, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(1) {\n    font-size: 12px;\n  }\n\n  /* line 299, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .logoRoom {\n    width: 100px;\n    margin-left: 0px;\n  }\n}\n@media only screen and (max-width: 1299px) {\n  /* line 305, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .inner_wrapper {\n    grid-template-columns: 1fr;\n  }\n\n  /* line 308, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem {\n    width: 470px;\n    margin: 0 auto;\n  }\n\n  /* line 312, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .logoRoom {\n    margin-left: 0px;\n  }\n}\n@media only screen and (max-width: 1024px) {\n  /* line 317, ../sass/selectRoom.scss */\n  .sec-selectRoom .title-group p {\n    font-size: 18px;\n  }\n\n  /* line 320, ../sass/selectRoom.scss */\n  .sec-selectRoom .title h1 {\n    font-size: 20px;\n  }\n\n  /* line 323, ../sass/selectRoom.scss */\n  .sec-selectRoom {\n    margin-left: 10px;\n  }\n\n  /* line 326, ../sass/selectRoom.scss */\n  .sec-selectRoom .title {\n    padding: 5px 15px 10px 30px;\n  }\n\n  /* line 329, ../sass/selectRoom.scss */\n  .sec-selectRoom .title .btn-close {\n    width: 25px;\n    height: 25px;\n  }\n\n  /* line 333, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .inner_wrapper {\n    padding: 10px;\n  }\n\n  /* line 336, ../sass/selectRoom.scss */\n  .sec-selectRoom .selectRoom_wrapper {\n    padding: 7px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 342, ../sass/selectRoom.scss */\n  .sec-selectRoom {\n    margin-left: 0px;\n  }\n\n  /* line 345, ../sass/selectRoom.scss */\n  .sec-selectRoom .title-group p::after,\n  .sec-selectRoom .title-group p::before {\n    width: 115%;\n  }\n\n  /* line 349, ../sass/selectRoom.scss */\n  .sec-selectRoom .title .btn-close {\n    display: none;\n  }\n\n  /* line 352, ../sass/selectRoom.scss */\n  .sec-selectRoom .title {\n    padding: 5px 15px 10px 15px;\n  }\n\n  /* line 355, ../sass/selectRoom.scss */\n  .sec-selectRoom .title h1 {\n    font-size: 16px;\n  }\n\n  /* line 358, ../sass/selectRoom.scss */\n  .sec-selectRoom .title-group p {\n    font-size: 14px;\n    padding: 0px 15px;\n  }\n\n  /* line 362, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem {\n    max-width: 470px;\n    width: 100%;\n    grid-template-columns: 80px 1fr 80px;\n    padding: 12px 25px;\n    height: 70px;\n  }\n\n  /* line 369, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .logoRoom {\n    height: 32px;\n    width: 70px;\n  }\n\n  /* line 373, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .roomNum p {\n    font-size: 11px;\n  }\n\n  /* line 376, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .winrate {\n    gap: 5px;\n  }\n\n  /* line 379, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(1) {\n    font-size: 8px;\n  }\n\n  /* line 382, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .roomItem .winrate p:nth-child(2) {\n    font-size: 20px;\n  }\n\n  /* line 385, ../sass/selectRoom.scss */\n  .sec-selectRoom .scrollBar {\n    padding-right: 0px;\n  }\n\n  /* line 388, ../sass/selectRoom.scss */\n  .sec-selectRoom .Room_group .inner_wrapper {\n    max-width: 360px;\n    margin: 0 auto;\n    padding: 0px;\n  }\n\n  /* line 393, ../sass/selectRoom.scss */\n  .sec-selectRoom .scrollBar {\n    max-height: unset;\n    overflow: unset;\n  }\n}\n/* line 1, ../sass/innerRoom.scss */\n.sec-innerRoom {\n  border: 2px solid #1cdf2e;\n  background-color: rgba(0, 0, 0, 0.5);\n  margin-left: 20px;\n  width: 100%;\n  position: relative;\n}\n/* line 7, ../sass/innerRoom.scss */\n.sec-innerRoom .title {\n  padding: 0 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px 0;\n}\n/* line 13, ../sass/innerRoom.scss */\n.sec-innerRoom .title h1 {\n  color: #fff;\n  font-size: 26px;\n}\n/* line 17, ../sass/innerRoom.scss */\n.sec-innerRoom .title .btn-close {\n  width: 30px;\n  height: 30px;\n  background-image: url('../images/close_bt.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: 0.3s;\n}\n/* line 25, ../sass/innerRoom.scss */\n.sec-innerRoom .title .btn-close:hover {\n  filter: brightness(1.5);\n}\n/* line 30, ../sass/innerRoom.scss */\n.sec-innerRoom .innerRoom_wrapper {\n  padding: 20px;\n}\n/* line 33, ../sass/innerRoom.scss */\n.sec-innerRoom .row-innerRoom {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  grid-gap: 20px;\n}\n/* line 38, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 10px;\n  margin-bottom: 10px;\n}\n/* line 43, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room .winRate {\n  background-color: #002201;\n  text-align: center;\n  padding: 10px;\n}\n/* line 47, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room .winRate .circle {\n  max-width: 90px;\n  margin: 0 auto 5px;\n}\n/* line 51, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room .winRate p {\n  text-align: center;\n  font-size: 20px;\n  color: #fff;\n}\n/* line 57, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room .showTurn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #002201;\n  padding: 7px;\n  position: relative;\n}\n/* line 64, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room .showTurn::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 110px;\n  height: 110px;\n  background-size: 100% 100%;\n  animation: showTurn_animate 10s linear infinite reverse;\n}\n/* line 76, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room .showTurn::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(0deg);\n  width: 110px;\n  height: 110px;\n  background-size: 100% 100%;\n  animation: showTurn_animate 10s linear infinite;\n}\n@keyframes showTurn_animate {\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n/* line 101, ../sass/innerRoom.scss */\n.sec-innerRoom .detail-room .showTurn .showTurn_item {\n  width: 40px;\n  height: 40px;\n}\n/* line 107, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-card {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 10px;\n}\n/* line 111, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-card .group-card {\n  background: #002201;\n  padding: 10px 20px;\n}\n/* line 114, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-card .group-card h5 {\n  margin-top: 5px;\n  text-align: center;\n  color: #fff;\n  font-size: 18px;\n}\n/* line 121, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-card .wrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 7px;\n}\n/* line 126, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-card .card-item {\n  max-width: 80px;\n  max-height: 110px;\n  min-width: 60px;\n  min-height: 85px;\n  width: 3.8vw;\n  height: 5vw;\n  overflow: hidden;\n  background: #000000;\n  place-self: center;\n}\n/* line 138, ../sass/innerRoom.scss */\n.sec-innerRoom .txt-wait {\n  text-align: center;\n  font-size: 18px;\n  color: #fff;\n  margin: 10px 0;\n}\n/* line 144, ../sass/innerRoom.scss */\n.sec-innerRoom .chessboard {\n  margin-bottom: 10px;\n}\n/* line 146, ../sass/innerRoom.scss */\n.sec-innerRoom .chessboard .bg-chessboard {\n  position: absolute;\n  top: 0;\n  display: grid;\n  grid-template-columns: repeat(12, 40px);\n  grid-template-rows: repeat(6, 25px);\n  grid-gap: 2px;\n  margin-top: 1px;\n  margin-left: 1px;\n}\n/* line 156, ../sass/innerRoom.scss */\n.sec-innerRoom .chessboard .bg-chessboard-item {\n  width: 100%;\n  height: 100%;\n  background: #007e0a;\n  border-radius: 1px;\n}\n/* line 162, ../sass/innerRoom.scss */\n.sec-innerRoom .chessboard .wrapper {\n  display: flex;\n  width: 505px;\n  height: 165px;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  overflow: hidden;\n  margin: 0 auto;\n  position: relative;\n}\n/* line 173, ../sass/innerRoom.scss */\n.sec-innerRoom .chessboard .chess-item {\n  width: 42px;\n  height: 23px;\n  z-index: 2;\n  margin: 2px 0;\n}\n/* line 180, ../sass/innerRoom.scss */\n.sec-innerRoom .sum-result {\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  color: #a3a3a3;\n  background: #002201;\n  padding: 2px 20px;\n  border-radius: 10px;\n}\n/* line 188, ../sass/innerRoom.scss */\n.sec-innerRoom .sum-result .sum-result_col-L {\n  display: flex;\n}\n/* line 192, ../sass/innerRoom.scss */\n.sec-innerRoom .sum-result .sum-result_col-R p {\n  color: #fff;\n}\n/* line 196, ../sass/innerRoom.scss */\n.sec-innerRoom .sum-result .sum-item {\n  margin-right: 10px;\n}\n/* line 198, ../sass/innerRoom.scss */\n.sec-innerRoom .sum-result .sum-item p {\n  color: #fff;\n}\n/* line 203, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup {\n  color: #fff;\n  background-color: #00431b;\n}\n/* line 207, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .txt-win::before {\n  content: \"\";\n  width: 35px;\n  height: 15px;\n  display: inline-block;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n/* line 219, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .txt-lose::before {\n  content: \"\";\n  width: 35px;\n  height: 15px;\n  display: inline-block;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n/* line 230, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  place-items: center;\n}\n/* line 234, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-row p {\n  width: 100%;\n  text-align: center;\n  padding: 5px 0;\n}\n/* line 240, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-turn {\n  font-size: 18px;\n}\n/* line 242, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-turn .table-body {\n  height: 200px;\n  overflow: auto;\n}\n/* line 245, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-turn .table-body .table-row {\n  background-color: #00431b;\n  position: relative;\n}\n/* line 248, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-turn .table-body .table-row::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  width: 90%;\n  height: 1px;\n  background-color: #adadad;\n}\n/* line 260, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-sum {\n  font-size: 20px;\n  margin-top: 5px;\n}\n/* line 265, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-sum p span {\n  margin-left: 5px;\n}\n/* line 270, ../sass/innerRoom.scss */\n.sec-innerRoom .table-turnGroup .table-title {\n  background-color: #002201;\n}\n/* line 275, ../sass/innerRoom.scss */\n.sec-innerRoom .graph {\n  background-color: #002201;\n  padding: 10px 0 30px;\n}\n/* line 278, ../sass/innerRoom.scss */\n.sec-innerRoom .graph .graph-title {\n  text-align: center;\n  padding-bottom: 10px;\n}\n/* line 281, ../sass/innerRoom.scss */\n.sec-innerRoom .graph .graph-title h1 {\n  color: #fff;\n  font-size: 24px;\n}\n/* line 286, ../sass/innerRoom.scss */\n.sec-innerRoom .graph .graph-area {\n  width: 90%;\n  margin: 0 auto;\n  height: 20vw;\n  max-height: 415px;\n  background: #c4c4c4;\n}\n/* line 294, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres {\n  margin-top: 10px;\n  background-color: #00431b;\n}\n/* line 297, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .graph-title {\n  background-color: #002201;\n  text-align: center;\n  padding: 10px 0;\n}\n/* line 301, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .graph-title h1 {\n  color: #fff;\n  font-size: 20px;\n}\n/* line 306, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .groupProgress {\n  padding: 15px 40px;\n}\n/* line 309, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .progress-item {\n  color: #fff;\n  margin-bottom: 5px;\n  position: relative;\n}\n/* line 313, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .progress-item label {\n  color: #fff;\n  display: block;\n  margin-bottom: 0px;\n  font-size: 18px;\n  line-height: 0.75;\n}\n/* line 320, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .progress-item progress {\n  width: calc(100% - 50px);\n  height: 13px;\n  border-radius: 0;\n  -webkit-appearance: none;\n  appearance: none;\n}\n/* line 326, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .progress-item progress::-webkit-progress-bar {\n  background-color: rgba(0, 0, 0, 0.1);\n  border: 1px solid #1e1e1e;\n  padding: 2px;\n}\n/* line 331, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .progress-item progress::-webkit-progress-value {\n  background-color: #00ff19;\n}\n/* line 335, ../sass/innerRoom.scss */\n.sec-innerRoom .sec-progres .progress-item span {\n  position: absolute;\n  right: 0;\n  font-size: 24px;\n  line-height: 0.75;\n}\n\n@media only screen and (max-width: 1440px) {\n  /* line 345, ../sass/innerRoom.scss */\n  .sec-innerRoom .sec-progres .graph-title h1 {\n    font-size: 14px;\n  }\n\n  /* line 348, ../sass/innerRoom.scss */\n  .sec-innerRoom .sec-progres .groupProgress {\n    padding: 15px 20px;\n  }\n}\n@media only screen and (max-width: 1240px) {\n  /* line 353, ../sass/innerRoom.scss */\n  .sec-innerRoom {\n    width: 100%;\n    margin-left: 10px;\n  }\n\n  /* line 357, ../sass/innerRoom.scss */\n  .sec-innerRoom .row-innerRoom {\n    grid-template-columns: 1fr;\n    width: fit-content;\n    margin: 0 auto;\n  }\n\n  /* line 362, ../sass/innerRoom.scss */\n  .sec-innerRoom .graph .graph-area {\n    height: 300px;\n  }\n}\n@media only screen and (max-width: 1024px) {\n  /* line 368, ../sass/innerRoom.scss */\n  .sec-innerRoom .title h1 {\n    font-size: 20px;\n  }\n\n  /* line 371, ../sass/innerRoom.scss */\n  .sec-innerRoom .title .btn-close {\n    width: 25px;\n    height: 25px;\n  }\n\n  /* line 376, ../sass/innerRoom.scss */\n  .sec-innerRoom .detail-room .winRate p {\n    font-size: 14px;\n  }\n\n  /* line 380, ../sass/innerRoom.scss */\n  .sec-innerRoom .detail-room .showTurn p {\n    font-size: 16px;\n  }\n\n  /* line 383, ../sass/innerRoom.scss */\n  .sec-innerRoom .chessboard .bg-chessboard {\n    grid-template-columns: repeat(12, 35px);\n    grid-template-rows: repeat(6, 20px);\n  }\n\n  /* line 387, ../sass/innerRoom.scss */\n  .sec-innerRoom .chessboard .wrapper {\n    width: 448px;\n    height: 135px;\n  }\n\n  /* line 391, ../sass/innerRoom.scss */\n  .sec-innerRoom .chessboard .chess-item {\n    width: 37.5px;\n    height: 18px;\n  }\n\n  /* line 395, ../sass/innerRoom.scss */\n  .sec-innerRoom .sec-card .card-item {\n    min-width: 57px;\n    min-height: 80px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 401, ../sass/innerRoom.scss */\n  .sec-innerRoom {\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  /* line 405, ../sass/innerRoom.scss */\n  .sec-innerRoom .chessboard .bg-chessboard {\n    grid-template-columns: repeat(10, 7.9vw);\n    grid-template-rows: repeat(6, 5.5vw);\n  }\n\n  /* line 409, ../sass/innerRoom.scss */\n  .sec-innerRoom .chessboard .wrapper {\n    width: 84vw;\n    height: 37vw;\n  }\n\n  /* line 413, ../sass/innerRoom.scss */\n  .sec-innerRoom .chessboard .chess-item {\n    width: 8.6vw;\n    height: 5vw;\n  }\n\n  /* line 417, ../sass/innerRoom.scss */\n  .sec-innerRoom .innerRoom_wrapper {\n    padding: 10px 10px;\n  }\n\n  /* line 420, ../sass/innerRoom.scss */\n  .sec-innerRoom .row-innerRoom {\n    width: 99%;\n  }\n\n  /* line 423, ../sass/innerRoom.scss */\n  .sec-innerRoom .sec-card .card-item {\n    width: 10.5vw;\n    height: 15vw;\n    min-width: 39px;\n    min-height: 55px;\n  }\n\n  /* line 429, ../sass/innerRoom.scss */\n  .sec-innerRoom .sec-card .group-card {\n    padding: 10px;\n  }\n\n  /* line 432, ../sass/innerRoom.scss */\n  .sec-innerRoom .title h1 {\n    font-size: 4vw;\n  }\n\n  /* line 435, ../sass/innerRoom.scss */\n  .sec-innerRoom .title {\n    padding: 10px 10px;\n  }\n\n  /* line 438, ../sass/innerRoom.scss */\n  .sec-innerRoom .title .btn-close {\n    width: 5vw;\n    height: 5vw;\n  }\n\n  /* line 442, ../sass/innerRoom.scss */\n  .sec-innerRoom .detail-room .showTurn p {\n    font-size: 3vw;\n  }\n\n  /* line 445, ../sass/innerRoom.scss */\n  .sec-innerRoom .sum-result {\n    font-size: 4vw;\n  }\n\n  /* line 448, ../sass/innerRoom.scss */\n  .sec-innerRoom .graph .graph-area {\n    height: 55vw;\n  }\n\n  /* line 451, ../sass/innerRoom.scss */\n  .sec-innerRoom .detail-room .winRate p:nth-child(3) {\n    font-size: 4vw;\n  }\n}\n/* line 1, ../sass/slot.scss */\n.slot-2-page {\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  position: relative;\n}\n/* line 7, ../sass/slot.scss */\n.slot-2-page .wrapper {\n  max-width: 1350px;\n  margin: 0 auto;\n}\n/* line 11, ../sass/slot.scss */\n.slot-2-page .titlePage {\n  text-align: center;\n}\n/* line 13, ../sass/slot.scss */\n.slot-2-page .titlePage h1 {\n  color: #fff;\n  font-size: 40px;\n  font-weight: 700;\n  padding: 20px 0;\n}\n/* line 20, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 10px;\n  margin: 0 auto;\n  padding: 0 50px 40px;\n}\n/* line 27, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item {\n  text-decoration: none;\n  background-size: 100% 100%;\n  color: #fff;\n  float: left;\n  width: 100%;\n  position: relative;\n  -webkit-column-break-inside: avoid;\n  break-inside: avoid;\n  margin-bottom: 5px;\n  padding: 30px 40px;\n  transition: 0.3s;\n}\n/* line 42, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item p {\n  font-size: 14px;\n  text-align: center;\n}\n/* line 47, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item .winrate-bar {\n  height: 16px;\n  width: 100%;\n  background: #c4c4c4;\n  border-radius: 20px;\n  position: relative;\n}\n/* line 54, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item .winrate-bar p {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  font-size: 18px;\n  margin: 0;\n  z-index: 2;\n  display: grid;\n  place-content: center;\n}\n/* line 65, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item .winrate-bar .winrate-bar_inner {\n  height: inherit;\n  background-color: #ff0600;\n  border-radius: inherit;\n  position: relative;\n  transform-origin: left;\n  transform: scaleX(0);\n  animation: winrate-bar_inner 1s forwards;\n  animation-delay: 1.3s;\n}\n@keyframes winrate-bar_inner {\n  100% {\n    transform: scaleX(1);\n  }\n}\n/* line 80, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item .winrate-bar .winrate-bar_inner::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-repeat: repeat;\n  border-radius: inherit;\n  animation: bg-processbar 50s linear infinite;\n}\n@keyframes bg-processbar {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 100vw 0;\n  }\n}\n/* line 106, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item_wrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  align-items: center;\n}\n/* line 111, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game {\n  width: 120px;\n}\n/* line 114, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game .img-game-inner {\n  text-align: center;\n}\n/* line 117, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game img {\n  max-width: 100%;\n  height: 76px;\n}\n/* line 123, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent {\n  padding-left: 20px;\n}\n/* line 126, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h4 {\n  font-size: 18px;\n  line-height: 0.8;\n}\n/* line 131, ../sass/slot.scss */\n.slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h3 {\n  margin-top: 10px;\n  line-height: 0.9;\n  font-size: 38px;\n  font-weight: 700;\n  color: #ff0600;\n}\n\n@media only screen and (max-width: 1349px) {\n  /* line 144, ../sass/slot.scss */\n  .slot-2-page .wrapper {\n    max-width: 1024px;\n  }\n\n  /* line 147, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media only screen and (max-width: 1023px) {\n  /* line 152, ../sass/slot.scss */\n  .slot-2-page .wrapper {\n    max-width: 700px;\n  }\n\n  /* line 155, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 160, ../sass/slot.scss */\n  .slot-2-page .wrapper {\n    max-width: 375px;\n  }\n\n  /* line 163, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper {\n    padding: 10px;\n  }\n\n  /* line 166, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item {\n    padding: 20px 25px;\n  }\n\n  /* line 169, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent {\n    padding-left: 10px;\n  }\n\n  /* line 172, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h4 {\n    font-size: 12px;\n  }\n\n  /* line 175, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game {\n    width: 62px;\n  }\n\n  /* line 178, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item_wrapper .img-game img {\n    height: 51px;\n  }\n\n  /* line 181, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item_wrapper .winrate-percent h3 {\n    margin-top: 5px;\n    font-size: 24px;\n  }\n\n  /* line 185, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item p {\n    font-size: 10px;\n  }\n\n  /* line 188, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item .winrate-bar p {\n    font-size: 10px;\n  }\n\n  /* line 191, ../sass/slot.scss */\n  .slot-2-page .menosary_wrapper .box-room-item .winrate-bar {\n    height: 10px;\n  }\n\n  /* line 194, ../sass/slot.scss */\n  .slot-2-page .btn-back-mobile p {\n    font-size: 16px;\n  }\n\n  /* line 197, ../sass/slot.scss */\n  .slot-2-page .btn-back-mobile::before {\n    width: 30px;\n    height: 30px;\n    margin-left: 10px;\n  }\n\n  /* line 202, ../sass/slot.scss */\n  .slot-2-page .titlePage h1 {\n    padding: 10px 0;\n  }\n\n  /* line 205, ../sass/slot.scss */\n  .slot-2-page {\n    padding-top: 15px;\n  }\n}\n.login-page{\n  overflow-y: hidden;\n\n}\n/* line 2, ../sass/login.scss */\n.login-page .bgLogin {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url('../images/bg.png');\n  background-size: cover;\n  background-position: center;\n  z-index: -1;\n}\n/* line 13, ../sass/login.scss */\n.login-page .index-page_wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-content: center;\n  overflow: hidden;\n}\n/* line 23, ../sass/login.scss */\n.login-page .logo {\n  margin: 0 auto;\n  text-align: center;\n  position: relative;\n  width: 1000px;\n  height: 600px;\n}\n/* line 29, ../sass/login.scss */\n.login-page .logo .logo_main {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n}\n/* line 38, ../sass/login.scss */\n.login-page .wrapper-content {\n  width: 100%;\n  padding: 30px 0;\n  text-align: center;\n  position: absolute;\n  bottom: 10%;\n  z-index: 2;\n}\n/* line 45, ../sass/login.scss */\n.login-page .wrapper-content h1 {\n  color: #fff;\n  margin-bottom: 10px;\n}\n/* line 48, ../sass/login.scss */\n.login-page .wrapper-content h1::before {\n  content: \">>\";\n  margin-right: 15px;\n}\n/* line 52, ../sass/login.scss */\n.login-page .wrapper-content h1::after {\n  content: \"<<\";\n  margin-left: 15px;\n}\n/* line 57, ../sass/login.scss */\n.login-page .wrapper-content .group-btn {\n  display: flex;\n  justify-content: center;\n}\n/* line 61, ../sass/login.scss */\n.login-page .wrapper-content .btn-item {\n  width: 220px;\n  height: 65px;\n  background-position: center;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  margin-right: 20px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n/* line 70, ../sass/login.scss */\n.login-page .wrapper-content .btn-item:last-child {\n  margin-right: 0;\n}\n/* line 73, ../sass/login.scss */\n.login-page .wrapper-content .btn-item:hover {\n  filter: brightness(2);\n}\n/* line 77, ../sass/login.scss */\n.login-page .wrapper-content .btn-login {\n  background-image: url('../images/btn-login.png');\n  width: 308px;\n  height: 85px;\n}\n/* line 82, ../sass/login.scss */\n.login-page .wrapper-content .btn-register {\n  background-image: url('../images/btn-register.png');\n  width: 308px;\n  height: 85px;\n}\n/* line 85, ../sass/login.scss */\n.login-page .wrapper-content .contact-txt {\n  font-family: \"Kanit-Light\";\n  font-size: 26px;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 15px;\n}\n/* line 93, ../sass/login.scss */\n.login-page .wrapper-content .contact-txt a {\n  margin-left: 15px;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  color: #fff;\n  background-color: #017008;\n  text-decoration: none;\n  padding-right: 20px;\n  border-radius: 7px;\n  overflow: hidden;\n  transition: 0.3s;\n}\n/* line 105, ../sass/login.scss */\n.login-page .wrapper-content .contact-txt a::before {\n  content: \"\";\n  background-position: center;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  width: 35px;\n  height: 35px;\n  margin-right: 15px;\n}\n/* line 115, ../sass/login.scss */\n.login-page .wrapper-content .contact-txt a:hover {\n  filter: brightness(1.5);\n}\n/* line 121, ../sass/login.scss */\n.login-page #bg-canvas {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  \n}\n\n/* line 129, ../sass/login.scss */\n.model-login {\n  display: none;\n  max-width: 550px !important;\n  background-image: url('../images/frame_popup-desktop.png');\n  background-size: 100% 100%;\n  padding-top: 60px;\n}\n/* line 135, ../sass/login.scss */\n.model-login .miniTxt {\n  position: absolute;\n  top: 8px;\n  left: 50%;\n  color: #05f31c;\n  font-size: 22px;\n  transform: translateX(-50%);\n}\n/* line 143, ../sass/login.scss */\n.model-login .wrapper {\n  border: unset;\n  background-color: unset;\n}\n/* line 147, ../sass/login.scss */\n.model-login .title {\n  text-align: left;\n}\n/* line 149, ../sass/login.scss */\n.model-login .title p {\n  text-indent: 50px;\n  color: #fff;\n  font-size: 20px;\n}\n/* line 153, ../sass/login.scss */\n.model-login .title p a {\n  color: #05f31c;\n  text-decoration: underline;\n}\n/* line 159, ../sass/login.scss */\n.model-login form {\n  text-align: center;\n}\n/* line 161, ../sass/login.scss */\n.model-login form input {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  font-family: \"Kanit-Light\";\n  color: #f3f3f3;\n  text-align: center;\n  width: 80%;\n  font-size: 24px;\n  padding: 5px 25px;\n}\n/* line 173, ../sass/login.scss */\n.model-login .txt-swith {\n  color: #a3a3a3;\n  font-size: 22px;\n  text-align: center;\n}\n/* line 177, ../sass/login.scss */\n.model-login .txt-swith .link-register {\n  margin-left: 10px;\n  font-size: 24px;\n  color: #fff;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* line 186, ../sass/login.scss */\n.model-login_active {\n  display: block;\n}\n\n/* line 190, ../sass/login.scss */\n.model-login .group-btn {\n  position: relative;\n  bottom: 0px;\n  left: 0px;\n}\n/* line 195, ../sass/login.scss */\n.model-login .recapcha {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* line 199, ../sass/login.scss */\n.model-login .recapcha .cf-code {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* line 203, ../sass/login.scss */\n.model-login .recapcha .cf-code p {\n  color: #05f31c;\n  font-size: 24px;\n}\n/* line 207, ../sass/login.scss */\n.model-login .recapcha .cf-code .refreshCode {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  width: 30px;\n  height: 30px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 15px;\n}\n/* line 217, ../sass/login.scss */\n.model-login .recapcha .cf-code .refreshCode.active {\n  transform: rotate(360deg);\n  transition: 0.7s;\n}\n/* line 222, ../sass/login.scss */\n.model-login .recapcha input {\n  width: 140px;\n  background-color: rgba(0, 0, 0, 0.5);\n  font-size: 20px;\n}\n\n/* line 230, ../sass/login.scss */\n.model-register {\n  display: none;\n}\n/* line 232, ../sass/login.scss */\n.model-register .title {\n  text-align: center;\n}\n/* line 235, ../sass/login.scss */\n.model-register form {\n  text-align: center;\n}\n/* line 237, ../sass/login.scss */\n.model-register form input {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  font-family: \"Kanit-Light\";\n  color: #f3f3f3;\n  text-align: center;\n  width: 80%;\n  font-size: 26px;\n  padding: 7px 25px;\n}\n/* line 249, ../sass/login.scss */\n.model-register .txt-swith {\n  color: #a3a3a3;\n  font-size: 22px;\n  text-align: center;\n}\n/* line 253, ../sass/login.scss */\n.model-register .txt-swith .link-login {\n  margin-left: 10px;\n  font-size: 24px;\n  color: #fff;\n  text-decoration: underline;\n  cursor: pointer;\n}\n/* line 261, ../sass/login.scss */\n.model-register .recapcha {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* line 265, ../sass/login.scss */\n.model-register .recapcha .cf-code {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* line 269, ../sass/login.scss */\n.model-register .recapcha .cf-code p {\n  color: #00ffff;\n  font-size: 32px;\n}\n/* line 273, ../sass/login.scss */\n.model-register .recapcha .cf-code .refreshCode {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  width: 30px;\n  height: 30px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 15px;\n}\n/* line 283, ../sass/login.scss */\n.model-register .recapcha .cf-code .refreshCode.active {\n  transform: rotate(360deg);\n  transition: 0.7s;\n}\n/* line 288, ../sass/login.scss */\n.model-register .recapcha input {\n  width: 140px;\n  border: 1px solid #00ffff;\n  font-size: 20px;\n}\n\n/* line 295, ../sass/login.scss */\n.model-register_active {\n  display: block;\n}\n\n/* line 302, ../sass/login.scss */\n.model-register .group-btn {\n  position: relative;\n  bottom: 0px;\n  left: 0px;\n}\n\n/* line 308, ../sass/login.scss */\n/*canvas {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100% !important;\n  height: 100% !important;\n}\n*/\n@media only screen and (max-width: 1300px) {\n  /* line 317, ../sass/login.scss */\n  .login-page .logo {\n    width: 600px;\n    height: 530px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 325, ../sass/login.scss */\n  .model-register form input {\n    width: 95%;\n    font-size: 20px;\n    padding: 7px 10px;\n  }\n\n  /* line 330, ../sass/login.scss */\n  .model-register .recapcha input {\n    width: 80px;\n    font-size: 14px;\n  }\n\n  /* line 334, ../sass/login.scss */\n  .model-register .recapcha .cf-code .refreshCode {\n    width: 20px;\n    height: 20px;\n  }\n\n  /* line 338, ../sass/login.scss */\n  .model-register .recapcha .cf-code p {\n    font-size: 14px;\n  }\n\n  /* line 341, ../sass/login.scss */\n  .model-register .recapcha .cf-code p:nth-child(2) {\n    font-size: 20px;\n  }\n\n  /* line 344, ../sass/login.scss */\n  .model-register .txt-swith {\n    font-size: 12px;\n  }\n\n  /* line 347, ../sass/login.scss */\n  .model-register .txt-swith .link-login {\n    font-size: 16px;\n  }\n\n  /* line 350, ../sass/login.scss */\n  .model-register .group-btn {\n    bottom: -30px;\n    left: 0;\n  }\n\n  /* line 354, ../sass/login.scss */\n  .model-register .wrapper {\n    padding: 50px 45px;\n  }\n\n  /* line 358, ../sass/login.scss */\n  .login-page .logo {\n    max-width: 80vw;\n  }\n\n  /* line 361, ../sass/login.scss */\n  .login-page .wrapper-content .group-btn {\n    display: block;\n    margin-top: 30px;\n  }\n\n  /* line 365, ../sass/login.scss */\n  .login-page .wrapper-content h1 {\n    font-size: 26px;\n  }\n\n  /* line 368, ../sass/login.scss */\n  .login-page .wrapper-content .btn-item:last-child {\n    margin-right: auto;\n  }\n\n  /* line 371, ../sass/login.scss */\n  .login-page .wrapper-content .btn-item {\n    width: 200px;\n    height: 55px;\n    margin: 15px auto;\n  }\n\n  /* line 377, ../sass/login.scss */\n  .login-page .wrapper-content::before {\n    top: 5%;\n    width: 90%;\n    border-top: 5px dotted #f2ab17;\n  }\n\n  /* line 382, ../sass/login.scss */\n  .login-page .wrapper-content .contact-txt {\n    font-family: \"Kanit-Light\";\n    font-size: 18px;\n    color: #fff;\n    display: inline-block;\n  }\n\n  /* line 388, ../sass/login.scss */\n  .login-page .wrapper-content .contact-txt a {\n    margin-left: 0px;\n    margin-top: 20px;\n  }\n\n  /* line 392, ../sass/login.scss */\n  .login-page .wrapper-content {\n    padding: 0px;\n  }\n\n  /* line 397, ../sass/login.scss */\n  .login-page .logo {\n    width: 400px;\n    height: 400px;\n  }\n\n  /* line 401, ../sass/login.scss */\n  .login-page .logo .logo_main {\n    max-width: 270px;\n  }\n}\n@media only screen and (max-width: 550px) {\n  /* line 406, ../sass/login.scss */\n  .model-login {\n    max-width: 360px !important;\n  }\n\n  /* line 409, ../sass/login.scss */\n  .model-login form input {\n    width: 90%;\n    font-size: 18px;\n    padding: 5px 10px;\n  }\n\n  /* line 414, ../sass/login.scss */\n  .model-login .recapcha .cf-code p {\n    font-size: 16px;\n  }\n\n  /* line 417, ../sass/login.scss */\n  .model-login .recapcha input {\n    width: 90px;\n    font-size: 16px;\n  }\n\n  /* line 421, ../sass/login.scss */\n  .model-login .miniTxt {\n    top: 8px;\n    right: 80px;\n    font-size: 20px;\n  }\n\n  /* line 426, ../sass/login.scss */\n  .model-login .title p {\n    text-indent: 20px;\n    font-size: 14px;\n  }\n}\n/* line 1, ../sass/_hilo.scss */\n.ico-hilo-h {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center 0px;\n  background-size: contain;\n}\n\n/* line 10, ../sass/_hilo.scss */\n.ico-hilo-l {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center 0px;\n  background-size: contain;\n}\n\n/* line 19, ../sass/_hilo.scss */\n.ico-hilo-s {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center 0px;\n  background-size: contain;\n}\n\n/* line 28, ../sass/_hilo.scss */\n.dice_1 {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 280%;\n}\n\n/* line 37, ../sass/_hilo.scss */\n.dice_2 {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 280%;\n}\n\n/* line 46, ../sass/_hilo.scss */\n.dice_3 {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 280%;\n}\n\n/* line 55, ../sass/_hilo.scss */\n.dice_4 {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 280%;\n}\n\n/* line 64, ../sass/_hilo.scss */\n.dice_5 {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 280%;\n}\n\n/* line 73, ../sass/_hilo.scss */\n.dice_6 {\n  width: 40px;\n  height: 40px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 280%;\n}\n\n/* line 82, ../sass/_hilo.scss */\n.group-diceHilo {\n  display: grid;\n  background-color: #002201;\n  grid-template-columns: 1fr 1fr 1fr;\n  overflow: hidden;\n}\n/* line 87, ../sass/_hilo.scss */\n.group-diceHilo .diceHilo_item {\n  text-align: center;\n}\n/* line 89, ../sass/_hilo.scss */\n.group-diceHilo .diceHilo_item img {\n  max-height: 130px;\n  max-width: 100%;\n  transform: scale(1.8);\n}\n\n/* line 96, ../sass/_hilo.scss */\n.sec-resultHilo {\n  height: 180px;\n  margin: 10px auto 20px;\n  overflow: hidden;\n  width: 90%;\n}\n/* line 101, ../sass/_hilo.scss */\n.sec-resultHilo .resultHilo-item {\n  float: left;\n  width: 10%;\n  padding: 10px 0;\n}\n/* line 105, ../sass/_hilo.scss */\n.sec-resultHilo .resultHilo-item:last-child {\n  background-color: #002201;\n}\n/* line 109, ../sass/_hilo.scss */\n.sec-resultHilo .resultHilo-inner {\n  margin-top: 5px;\n}\n/* line 112, ../sass/_hilo.scss */\n.sec-resultHilo .dice-item {\n  width: 40px;\n  height: 40px;\n  margin: 0 auto;\n}\n/* line 117, ../sass/_hilo.scss */\n.sec-resultHilo .icon-hilo {\n  margin: 0 auto;\n}\n\n@media only screen and (max-width: 1300px) {\n  /* line 122, ../sass/_hilo.scss */\n  .sec-resultHilo .icon-hilo {\n    width: 30px;\n    height: 30px;\n  }\n\n  /* line 126, ../sass/_hilo.scss */\n  .sec-resultHilo .resultHilo-item {\n    padding: 5px 0;\n  }\n\n  /* line 129, ../sass/_hilo.scss */\n  .sec-resultHilo .dice-item {\n    width: 35px;\n    height: 35px;\n  }\n\n  /* line 133, ../sass/_hilo.scss */\n  .sec-resultHilo {\n    height: 150px;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  /* line 138, ../sass/_hilo.scss */\n  .sec-resultHilo .icon-hilo {\n    width: 40px;\n    height: 40px;\n  }\n\n  /* line 142, ../sass/_hilo.scss */\n  .sec-resultHilo .dice-item {\n    width: 40px;\n    height: 40px;\n  }\n\n  /* line 146, ../sass/_hilo.scss */\n  .sec-resultHilo .resultHilo-item {\n    padding: 10px 0;\n  }\n\n  /* line 149, ../sass/_hilo.scss */\n  .sec-resultHilo {\n    height: 185px;\n  }\n}\n@media only screen and (max-width: 600px) {\n  /* line 154, ../sass/_hilo.scss */\n  .sec-resultHilo .icon-hilo {\n    width: 6.5vw;\n    height: 6.5vw;\n  }\n\n  /* line 158, ../sass/_hilo.scss */\n  .sec-resultHilo .resultHilo-item {\n    padding: 5px 0;\n  }\n\n  /* line 161, ../sass/_hilo.scss */\n  .sec-resultHilo .dice-item {\n    width: 7vw;\n    height: 7vw;\n  }\n\n  /* line 165, ../sass/_hilo.scss */\n  .sec-resultHilo {\n    height: 31vw;\n  }\n}\n/* line 1, ../sass/_RdProgress.scss */\nsvg.radial-progress {\n  height: auto;\n  max-width: 160px;\n  transform: rotate(-90deg);\n  width: 100%;\n}\n\n/* line 8, ../sass/_RdProgress.scss */\nsvg.radial-progress circle {\n  fill: transparent;\n  stroke: #fff;\n  stroke-dashoffset: 219.91148575129;\n  /* Circumference */\n  stroke-width: 5;\n}\n\n/* line 16, ../sass/_RdProgress.scss */\nsvg.radial-progress circle.incomplete {\n  opacity: 0.25;\n}\n\n/* line 20, ../sass/_RdProgress.scss */\nsvg.radial-progress circle.complete {\n  stroke-dasharray: 219.91148575129;\n  /* Circumference */\n}\n\n/* line 25, ../sass/_RdProgress.scss */\nsvg.radial-progress text {\n  fill: #fff;\n  text-anchor: middle;\n}\n\n/*** COLORS ***/\n/* Primary */\n/* line 34, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 1) circle {\n  stroke: #dbcc95;\n}\n\n/* line 38, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 1) circle.green {\n  stroke: #00ff19;\n}\n\n/* line 41, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 1) circle.yellow {\n  stroke: #ffc107;\n}\n\n/* line 44, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 1) circle.red {\n  stroke: #dc3545;\n}\n\n/* Secondary */\n/* line 50, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 2) circle {\n  stroke: #83e4e2;\n}\n\n/* Tertiary */\n/* line 56, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 3) circle {\n  stroke: #fd6470;\n}\n\n/* Quaternary */\n/* line 62, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 4) circle {\n  stroke: #fca858;\n}\n\n/* Quinary */\n/* line 68, ../sass/_RdProgress.scss */\nsvg.radial-progress:nth-of-type(6n + 5) circle {\n  stroke: #fddc32;\n}\n\n/* line 73, ../sass/_RdProgress.scss */\n.stork-Gray {\n  stroke: #333333 !important;\n}\n\n/* line 76, ../sass/_RdProgress.scss */\nsvg.radial-progress .txtWin {\n  fill: #fff;\n  font-size: 10px;\n}\n\n/* line 80, ../sass/_RdProgress.scss */\nsvg.radial-progress .percentage {\n  font-size: 16px;\n}\n\n/* line 85, ../sass/_RdProgress.scss */\n.SlotInnerRoom svg.radial-progress {\n  max-width: 100px;\n}\n\n@media only screen and (max-width: 550px) {\n  /* line 91, ../sass/_RdProgress.scss */\n  svg.radial-progress {\n    max-width: 100px;\n  }\n}\n/* line 1, ../sass/LinkPage.scss */\n.linkPage {\n  padding: 15px 20px;\n}\n/* line 3, ../sass/LinkPage.scss */\n.linkPage .title {\n  text-align: center;\n}\n/* line 5, ../sass/LinkPage.scss */\n.linkPage .title h1 {\n  color: #fff;\n  font-size: 36px;\n  padding: 20px 0;\n}\n\n/* line 12, ../sass/LinkPage.scss */\n.linkPage_wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  border: 2px solid #1cdf2e;\n  background-color: rgba(0, 0, 0, 0.7);\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 30px;\n  gap: 30px;\n  overflow: hidden;\n}\n\n/* line 25, ../sass/LinkPage.scss */\n.sec-iframe {\n  height: 560px;\n  max-width: 455px;\n  padding: 50px 15px 45px 20px;\n  background-size: 100% 100%;\n  background-position: center;\n}\n/* line 32, ../sass/LinkPage.scss */\n.sec-iframe iframe {\n  width: 100%;\n  height: 100%;\n  background: #878787;\n  border: unset;\n}\n\n/* line 39, ../sass/LinkPage.scss */\n.boxGame {\n  background-size: 100% 100%;\n  background-position: center;\n  padding: 25px;\n  text-align: center;\n  margin-bottom: 10px;\n}\n/* line 46, ../sass/LinkPage.scss */\n.boxGame img {\n  max-width: 300px;\n  margin-bottom: 5px;\n}\n/* line 50, ../sass/LinkPage.scss */\n.boxGame p {\n  color: #fff;\n  font-size: 20px;\n}\n\n/* line 55, ../sass/LinkPage.scss */\n.resetTime {\n  background-size: 100% 100%;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 20px;\n}\n/* line 64, ../sass/LinkPage.scss */\n.resetTime .time-icon {\n  width: 30px;\n  height: 50px;\n  background-position: center;\n  background-size: 100% 100%;\n  margin-right: 10px;\n}\n/* line 72, ../sass/LinkPage.scss */\n.resetTime p {\n  font-size: 18px;\n  color: #fff;\n}\n/* line 76, ../sass/LinkPage.scss */\n.resetTime h2 {\n  line-height: 1;\n  font-size: 30px;\n  color: #fff;\n}\n\n/* line 82, ../sass/LinkPage.scss */\n.winRateGame {\n  width: 270px;\n  height: 270px;\n  display: grid;\n  place-content: center;\n  text-align: center;\n  position: relative;\n  background-position: center;\n  background-size: 100% 100%;\n  z-index: 1;\n}\n/* line 93, ../sass/LinkPage.scss */\n.winRateGame::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: 100% 100%;\n  animation: winRateGame_animate 10s linear infinite;\n  z-index: -1;\n}\n@keyframes winRateGame_animate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* line 111, ../sass/LinkPage.scss */\n.winRateGame::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: 100% 100%;\n  animation: winRateGame_animate 10s linear infinite reverse;\n  z-index: -1;\n}\n@keyframes winRateGame_animate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* line 129, ../sass/LinkPage.scss */\n.winRateGame p {\n  font-size: 18px;\n  color: #fff;\n}\n/* line 133, ../sass/LinkPage.scss */\n.winRateGame h2 {\n  font-size: 36px;\n  color: #fff;\n}\n\n@media only screen and (max-width: 1149px) {\n  /* line 139, ../sass/LinkPage.scss */\n  .linkPage_wrapper {\n    flex-direction: column;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 144, ../sass/LinkPage.scss */\n  .linkPage_wrapper {\n    padding: 10px;\n  }\n\n  /* line 147, ../sass/LinkPage.scss */\n  .sec-iframe {\n    height: 445px;\n    padding: 0px;\n    background-image: unset;\n    border: 1px solid #03ff1c;\n  }\n\n  /* line 153, ../sass/LinkPage.scss */\n  .linkPage .btn-back-mobile {\n    padding: 5px 10px;\n  }\n\n  /* line 156, ../sass/LinkPage.scss */\n  .linkPage .btn-back-mobile::before {\n    width: 30px;\n    height: 30px;\n  }\n\n  /* line 160, ../sass/LinkPage.scss */\n  .linkPage .btn-back-mobile p {\n    font-size: 16px;\n  }\n\n  /* line 163, ../sass/LinkPage.scss */\n  .linkPage .title h1 {\n    padding: 10px 0;\n  }\n}\n/* line 1, ../sass/ball.scss */\n.ballPage {\n  color: #000;\n  margin: 0 auto;\n  margin-top: 30px;\n  max-width: 1300px;\n  border: 2px solid #1cdf2e;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n}\n/* line 9, ../sass/ball.scss */\n.ballPage .ballPage_title {\n  padding-left: 5px;\n  margin-bottom: 15px;\n}\n/* line 12, ../sass/ball.scss */\n.ballPage .ballPage_title h1 {\n  font-size: 34px;\n  color: #fff;\n}\n/* line 16, ../sass/ball.scss */\n.ballPage .ballPage_title p {\n  font-size: 20px;\n  color: #fff;\n}\n/* line 21, ../sass/ball.scss */\n.ballPage .ballPage-row {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr 1fr;\n  grid-gap: 15px;\n}\n/* line 26, ../sass/ball.scss */\n.ballPage .ballPage-col {\n  display: grid;\n  grid-template-rows: 1fr;\n}\n/* line 29, ../sass/ball.scss */\n.ballPage .ballPage-col .colTitle {\n  margin-bottom: 15px;\n}\n/* line 31, ../sass/ball.scss */\n.ballPage .ballPage-col .colTitle h1 {\n  font-size: 24px;\n  line-height: 0.75;\n}\n/* line 36, ../sass/ball.scss */\n.ballPage .ballPage-col .ballPage-colWrapper {\n  background-size: cover;\n  background-position: center;\n  border-radius: 10px;\n  padding: 15px;\n}\n/* line 44, ../sass/ball.scss */\n.ballPage .select-item {\n  position: relative;\n}\n/* line 46, ../sass/ball.scss */\n.ballPage .select-item label {\n  color: #fff;\n}\n/* line 49, ../sass/ball.scss */\n.ballPage .select-item select {\n  background-color: #00aa44;\n  border: unset;\n  outline: unset;\n  border-radius: 7px;\n  font-size: 16px;\n  padding: 3px 20px;\n  width: 100%;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  color: #fff;\n}\n/* line 63, ../sass/ball.scss */\n.ballPage .select-item .select-itemInner {\n  position: relative;\n}\n/* line 65, ../sass/ball.scss */\n.ballPage .select-item .select-itemInner::after {\n  content: \"\";\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translate(0, -50%);\n  width: 0.8em;\n  height: 0.5em;\n  background-color: #818181;\n  clip-path: polygon(100% 0%, 0 0%, 50% 100%);\n}\n/* line 79, ../sass/ball.scss */\n.ballPage .selectLeague .pic {\n  display: flex;\n  justify-content: center;\n  margin-top: 25px;\n  height: 200px;\n  border: 1px solid #d8d8d8;\n  border-radius: 5px;\n  padding: 20px;\n  background-color: #fff;\n}\n/* line 88, ../sass/ball.scss */\n.ballPage .selectLeague .pic img {\n  object-fit: contain;\n}\n/* line 94, ../sass/ball.scss */\n.ballPage .selectTeam .groupTeam {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 10px;\n  margin-top: 15px;\n  margin-bottom: 20px;\n}\n/* line 101, ../sass/ball.scss */\n.ballPage .selectTeam .teamItem {\n  text-align: center;\n}\n/* line 103, ../sass/ball.scss */\n.ballPage .selectTeam .teamItem .pic {\n  border: 1px solid #17f29b;\n  border-radius: 10px;\n  overflow: hidden;\n  padding-bottom: 20px;\n}\n/* line 108, ../sass/ball.scss */\n.ballPage .selectTeam .teamItem .pic img {\n  height: 110px;\n  object-fit: contain;\n}\n/* line 112, ../sass/ball.scss */\n.ballPage .selectTeam .teamItem .pic p {\n  background: linear-gradient(90deg, #163432 0%, #225851 50%, #163432 100%);\n  color: #fff;\n  padding: 10px 0;\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n/* line 120, ../sass/ball.scss */\n.ballPage .selectTeam .teamItem h3 {\n  color: #fff;\n  margin-top: 10px;\n  font-size: 12px;\n}\n/* line 126, ../sass/ball.scss */\n.ballPage .selectTeam .teamItem:nth-child(2) .pic p {\n  color: #fff;\n  background: linear-gradient(90deg, #168032 0%, #22ec51 50%, #168032 100%);\n}\n/* line 132, ../sass/ball.scss */\n.ballPage .selectTeam .graoup-startTime {\n  text-align: center;\n}\n/* line 134, ../sass/ball.scss */\n.ballPage .selectTeam .graoup-startTime p {\n  color: #fff;\n  font-size: 20px;\n}\n/* line 138, ../sass/ball.scss */\n.ballPage .selectTeam .graoup-startTime .startTime {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n/* line 142, ../sass/ball.scss */\n.ballPage .selectTeam .graoup-startTime .startTime h4 {\n  padding: 5px 10px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n}\n/* line 152, ../sass/ball.scss */\n.ballPage .calBall .btn-calBall {\n  background-color: unset;\n  border: unset;\n  outline: unset;\n  font-size: 16px;\n  background-color: #00aa44;\n  color: #fff;\n  width: 100%;\n  border-radius: 7px;\n  padding: 4px 0;\n  border: 2px solid #000;\n}\n/* line 162, ../sass/ball.scss */\n.ballPage .calBall .groupTeam {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 10px;\n  margin-top: 15px;\n  margin-bottom: 20px;\n}\n/* line 169, ../sass/ball.scss */\n.ballPage .calBall .teamItem {\n  text-align: center;\n}\n/* line 171, ../sass/ball.scss */\n.ballPage .calBall .teamItem .pic {\n  border: 1px solid #17f29b;\n  border-radius: 10px;\n  overflow: hidden;\n  padding-bottom: 20px;\n}\n/* line 176, ../sass/ball.scss */\n.ballPage .calBall .teamItem .pic img {\n  height: 110px;\n  object-fit: contain;\n}\n/* line 180, ../sass/ball.scss */\n.ballPage .calBall .teamItem .pic p {\n  background: linear-gradient(90deg, #163432 0%, #225851 50%, #163432 100%);\n  color: #fff;\n  padding: 10px 0;\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n/* line 189, ../sass/ball.scss */\n.ballPage .calBall .teamItem h3 {\n  color: #fff;\n  margin-top: 10px;\n  font-size: 12px;\n}\n/* line 194, ../sass/ball.scss */\n.ballPage .calBall .teamItem h1 {\n  color: #fff;\n  font-size: 65px;\n}\n/* line 199, ../sass/ball.scss */\n.ballPage .calBall .teamItem:nth-child(2) .pic p {\n  color: #fff;\n  background: linear-gradient(90deg, #168032 0%, #22ec51 50%, #168032 100%);\n}\n\n@media only screen and (max-width: 1260px) {\n  /* line 209, ../sass/ball.scss */\n  .ballPage .ballPage-row {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media only screen and (max-width: 960px) {\n  /* line 214, ../sass/ball.scss */\n  .ballPage .ballPage-row {\n    grid-template-columns: 1fr;\n  }\n\n  /* line 217, ../sass/ball.scss */\n  .ballPage .selectLeague .pic {\n    height: 150px;\n  }\n  /* line 219, ../sass/ball.scss */\n  .ballPage .selectLeague .pic img {\n    max-height: 100%;\n  }\n\n  /* line 224, ../sass/ball.scss */\n  .ballPage .calBall .teamItem .pic h1 {\n    font-size: 70px;\n    line-height: 1;\n  }\n\n  /* line 228, ../sass/ball.scss */\n  .ballPage .selectTeam .teamItem .pic h3 {\n    margin-top: 10px;\n    font-size: 16px;\n  }\n\n  /* line 232, ../sass/ball.scss */\n  .ballPage {\n    margin-top: 10px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  /* line 237, ../sass/ball.scss */\n  .ballPage .ballPage_title h1 {\n    font-size: 24px;\n  }\n\n  /* line 240, ../sass/ball.scss */\n  .ballPage {\n    padding-bottom: 80px;\n  }\n\n  /* line 243, ../sass/ball.scss */\n  .ballPage .select-item select {\n    font-size: 16px;\n  }\n\n  /* line 247, ../sass/ball.scss */\n  .ballPage .selectTeam .teamItem p {\n    font-size: 16px;\n  }\n\n  /* line 250, ../sass/ball.scss */\n  .ballPage .selectTeam .teamItem .pic h3 {\n    font-size: 12px;\n  }\n\n  /* line 253, ../sass/ball.scss */\n  .ballPage .selectTeam .graoup-startTime p {\n    font-size: 20px;\n  }\n\n  /* line 256, ../sass/ball.scss */\n  .ballPage .selectTeam .graoup-startTime .startTime h4 {\n    font-size: 18px;\n  }\n\n  /* line 259, ../sass/ball.scss */\n  .ballPage .calBall .btn-calBall {\n    font-size: 18px;\n  }\n\n  /* line 262, ../sass/ball.scss */\n  .ballPage .calBall .teamItem p {\n    font-size: 16px;\n  }\n\n  /* line 265, ../sass/ball.scss */\n  .ballPage .calBall .teamItem .pic h3 {\n    font-size: 14px;\n  }\n\n  /* line 268, ../sass/ball.scss */\n  .ballPage .calBall .teamItem .pic h1 {\n    font-size: 54px;\n  }\n}\n.floating-btns{\n  position: fixed;\n  bottom: 40px;\n  z-index: 1;\n  right: 40px;\n  color: white;\n  border-radius: 10px;\n  outline: none;\n  border: none;\n  display: flex;\n  justify-content: space-between;\n}\n.floating-btns>a:hover{\n  cursor: pointer;\n}\n.swal2-popup {\n  background-size: 100% 100% !important;\n  padding: 40px 0px !important;\n  border-radius: 10px !important;\n  background-color: #000000bd !important;\n}\n#swal2-title {\n  color: #fff;\n}\n#swal2-content {\n  color: #fff;\n}\n\n/*.swal2-confirm {*/\n/*    background-color: #147e4f !important; !* Button background color *!*/\n\n/*}*/\n\n/*.swal2-confirm:hover {*/\n/*    background-color: #0e5214 !important; !* Hover effect *!*/\n/*}*/\n\n\nbody {\n  background-position: left top;\n  background-size: auto;\n  background-repeat: repeat;\n  background-attachment: scroll;\n}\n\n.box-goto-lobby {\n  background: url('../images/goto-lobby.png');\n  background-size: 100% 100%;\n  padding: 10px;\n  transition: 0.3s ease all;\n  text-align: center;\n  margin: auto;\n}\n\n.box-goto-lobby:hover{\n  transform: scale(1.1);\n}\n\n.bg-custom-image{\n  background-image: url('../images/BG_dialog.jpg');\n}\n\n.menu-lobby{\n  background: url(\"../images//homepage/BG_home.jpg\");\n  background-size: cover;\n  filter: drop-shadow(0px 0px 10px #00ff9c);\n}\n\n.room-box {\n  background: url(\"../../casino/images/BG_frame_SAgaming.png\");\n  background-size: 100% 100%;\n  padding: 35px 10px 35px 10px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  cursor: pointer;\n  transition: 0.4s ease;\n}\n.room-box:hover{\n  transform: scale(0.95);\n}\n.score-board{\n  background-image: url('../images//BG_frame_login.jpg');\n  background-size: 100% 100%;\n\n}\n .sec-formula_wrapper {\n  border-width: 2px;\n  border-style: solid;\n  border-color: rgb(28, 223, 46);\n  border-image: initial;\n}\n\n.box-winlose-percent {\n  background: url(\"../images/BG_register.png\");\n  background-size: 100% 100%;\n  padding: 30px;\n}\n\n.box-statistic {\n  background: url(\"../images/BG_register.png\");\n  background-size: 100% 100%;\n  padding: 4rem;\n  filter: drop-shadow(2px 4px 6px black);\n}\n\n.chart-board {\n  background: url(\"../images/BG_register.png\");\n  background-size: 100% 100%;\n  padding: 80px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
